import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import indexRoutes from "routes/index.jsx";
import Login from "views/Pages/LoginPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";

import LoginPage from "layouts/Pages/Pages.jsx";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";
// import FaceDetection from "views/FaceDetection/FaceDetection.jsx";
import { truncate } from "fs";
// react plugin for creating notifications over the dashboard
// import NotificationAlert from "react-notification-alert";
import NotificationAlert from "components/CustomNotification/CustomNotification.jsx";
// import LZ from "LZString";
// import LZ from "lzma";

import moment from "moment";
import "moment/locale/es";
import axios from "axios";
import ReactGA from "react-ga";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
import { isObject } from "util";
import Cookies from "universal-cookie";
import { SpeedDial, BubbleList, BubbleListItem } from 'react-speed-dial';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Avatar from 'material-ui/Avatar';
import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  CardTitle,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { List, ListItem } from 'material-ui/List';
import { CardText } from 'material-ui/Card';
import { Checkbox } from "material-ui";

import {
  PanelHeader,
  FormInputs,
  CardAuthor,
  CardSocials,
  Button,
  Timeline,
  Statistics
} from "components";
import {grey400, darkBlack, lightBlack} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';

import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

// Softphone
// import SoftPhone from 'react-softphone';
// import { WebSocketInterface } from 'jssip';
// import "regenerator-runtime/runtime";
// const config = {
//   domain: '78.136.82.185', // sip-server@your-domain.io
//   uri: 'sip:2031704@78.136.82.185', // sip:sip-user@your-domain.io
//   password: 'RubenFijo2020%', //  PASSWORD ,
//   ws_servers: 'wss://2031704@78.136.82.185:9060/ws', //ws server
//   sockets: new WebSocketInterface('wss://78.136.82.185:9060/ws'),
//   display_name: 'Test softphone',//jssip Display Name
//   debug: true // Turn debug messages on
// };
// const config = {
//   domain: 'aire21.meetip.net', // sip-server@your-domain.io
//   uri: 'sip:9991000@aire21.meetip.net:6999', // sip:sip-user@your-domain.io
//   password: '30%6_VmpQ2GN8o2I!j72', //  PASSWORD ,
//   ws_servers: 'wss://9991000@aire21.meetip.net/ws', //ws server
//   sockets: new WebSocketInterface('wss://aire21.meetip.net/ws'),
//   display_name: 'Test softphone',//jssip Display Name
//   debug: true // Turn debug messages on
// };
const setConnectOnStartToLocalStorage =(newValue)=>{
  // Handle save the auto connect value to local storage
  return true
}
const setNotifications =(newValue)=>{
  // Handle save the Show notifications of an incoming call to local storage
  return true
}
const setCallVolume =(newValue)=>{
  // Handle save the call Volume value to local storage
  return true
}
const setRingVolume =(newValue)=>{
  // Handle save the Ring Volume value to local storage
  return true
}

const cookies = new Cookies();

ReactGA.initialize("UA-62932919-3");

// Icons tasks menu
library.add(fab, faCheckSquare, faCoffee, fas, far);
const iconButtonElement = (taskId, binding) => {
  return (
    <IconButton
      touch={true}
      onClick={() => {
        // console.log("funciona el botoncito", taskId);
        binding.setState({ selectedTaskMenu: taskId });
      }}
    >
      <MoreVertIcon color={grey400} />
    </IconButton>
  );
};

const rightIconMenu = (taskId, binding) => {
  return (
    <IconMenu iconButtonElement={iconButtonElement(taskId, binding)}>
      {/* <MenuItem>Reply</MenuItem>
      <MenuItem>Forward</MenuItem>
      <MenuItem>Delete</MenuItem> */}
    </IconMenu>
  );
}
// End icons taks menu

const LZ = require("lzma/src/lzma_worker.js").LZMA_WORKER;
// const API = "https://mi-tienda.nadunet.es/api/rest/";
const DEBUG_MODE = window.location.host.includes("localhost") || window.location.host.includes("192.168.");
const API = !(DEBUG_MODE) ? "https://" + window.location.host + "/api/rest/" : "https://oficina.nadunet.es/api/rest/";
// const API = !(DEBUG_MODE) ? "https://" + window.location.host + "/api/rest/" : "https://mi-tienda.nadunet.es/api/rest/";
const API_ext = "https://oficina.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const LOGIN_URL = "nadulogin_resources/login";
const DO_LOGOUT_URL = "user/logout";
const GET_TOKEN_URL = "user/token";
/* const GET_ORDERS_URL =
  "views/commerce_backoffice_user_orders?display_id=service_user_orders"; */
const GET_ORDERS_URL = "pedidos-shop.json";
const SEARCH_BILLS_URL = "pedidos-shop-filter.json?search=";
const SEARCH_BILLS_BY_ID_URL = "pedidos-shop-filter-customerid.json?search=";
const SEARCH_UNPAID_BILLS_URL = "unpaid-bills-shop-filter.json?search=";
const SEARCH_CONTRACTS_URL = "contracts-shop-filter.json?search=";
const SEARCH_CUSTOMER_CONTRACTS_URL = "contracts-customer-shop-filter.json?search=";
// const GET_CONTRACT_URL = "get-contract-shop.json?contract_id=";
const GET_CONTRACT_URL = "nadunet_contracts_resources/get_contract.json";
const LOAD_CONTRACT_TEMPLATES_URL = "contract-templates-shop.json";

// <HOME_VISITS>
const SEARCH_HOME_VISITS_URL = "get-lista-visitas-domicilio";
const GET_CUSTOMER_HOME_VISITS_URL = "get-lista-visitas-domicilio-cliente";
const GET_CURRENT_HOME_VISIT_URL = "get-visita-domicilio-activa.json";
const GET_HOME_VISIT = "nadunet_office_resources/get_home_visit";
const VIEW_HOME_VISIT = "nadunet_office_resources/view_home_visit";
const ADD_HOME_VISIT_COMMENT = "nadunet_office_resources/add_home_visit_comment";
const ADD_HOME_VISIT_PHOTO = "nadunet_office_resources/add_home_visit_photo";
const EDIT_HOME_VISIT_PHOTO = "nadunet_office_resources/edit_home_visit_photo";
const DELETE_HOME_VISIT_PHOTO = "nadunet_office_resources/delete_home_visit_photo";
const CREATE_HOME_VISIT = "nadunet_office_resources/create_home_visit";
const EDIT_HOME_VISIT = "nadunet_office_resources/edit_home_visit";
const EDIT_HOME_VISIT_DATE = "nadunet_office_resources/edit_home_visit_date";
const START_HOME_VISIT = "nadunet_office_resources/start_home_visit";
const FINISH_HOME_VISIT = "nadunet_office_resources/finish_home_visit";
const DELETE_HOME_VISIT = "nadunet_office_resources/delete_home_visit";
const GET_HOME_VISITS_LOG = "nadunet_office_resources/get_calendar_log";
const CHANGE_HOME_VISIT_BILLING_STATUS = "nadunet_office_resources/change_home_visit_billing_review";
// </HOME_VISIT>

const UNSUBSCRIBE_MOBILE = "nadunet_office_resources/unsubscribe_mobile_line";
const UNSUBSCRIBE_MOBILE_HISTORY = "nadunet_office_resources/get_unsubscribe_mobile_history";
const COMMUNICATION_TEMPLATES = "nadunet_office_resources/get_email_templates";
const SEND_CUSTOMER_EMAIL = "nadunet_office_resources/send_email";
const GET_CUSTOMER_COMMUNICATIONS = "nadunet_office_resources/get_customer_communications";
const CREATE_COMMUNICATION = "nadunet_office_resources/create_communication";
const SET_CUSTOMER_INTERNET_PLAN = "nadunet_office_resources/set_customer_internet_plan";
const GET_NOTIFICATIONS = "nadunet_office_resources/get_notifications";
const READ_NOTIFICATION = "nadunet_office_resources/read_notification";
const UNREAD_NOTIFICATION = "nadunet_office_resources/unread_notification";
const MARK_ALL_NOTIFICATIONS_AS_READ = "nadunet_office_resources/mark_all_notifications_as_read";
const GET_CONFIGURATION = "nadunet_office_resources/get_configuration";
const SET_CONFIGURATION = "nadunet_office_resources/set_configuration";
const SET_PASSWORD = "nadunet_office_resources/set_own_password";

// <Tickets>
const LIST_SUPPORT_TICKETS = "nadunet_users_resources/list_support_tickets";
const GET_SUPPORT_TICKETS_STATISTICS = "nadunet_users_resources/get_tickets_statistics";
const GET_SUPPORT_TICKET_OPTIONS = "nadunet_users_resources/get_ticket_options";
const CREATE_SUPPORT_TICKET = "nadunet_users_resources/create_support_ticket";
const GET_SUPPORT_TICKETS = "nadunet_users_resources/get_support_ticket";
const GET_DEPARTMENTS = "nadunet_office_resources/get_departments";
const CHANGE_TICKET_DEPARMENT = "nadunet_users_resources/change_ticket_department";
const ASSIGN_TICKET = "nadunet_users_resources/assign_ticket";
const UNASSIGN_TICKET = "nadunet_users_resources/unassign_ticket";
const OPEN_TICKET = "nadunet_users_resources/open_ticket";
const CLOSE_TICKET = "nadunet_users_resources/close_ticket";
const SEND_TICKET_MESSAGE = "nadunet_users_resources/send_ticket_message";
// </Tickets>

/* const GET_ORDERS_ARTICLES_URL =
  "views/commerce_backoffice_user_orders?display_id=service_user_orders_articles"; */
const GET_ORDERS_ARTICLES_URL = "articulos-pedidos.json";
const GET_ORDERS_ARTICLES_SHOP_URL = "articulos-pedidos-shop.json?search=";
const GET_ORDERS_ARTICLES_SHOP_NUMBER_URL = "articulos-pedidos-shop-number.json?order_number=";
const GET_INTERNET_URL = "client_internet_info.json";
/* const GET_MOBILE_URL = "mobile_cdr_resources/get_user_mobiles.json"; */
const GET_MOBILE_URL = "user_mobiles.json";
//const GET_SERVICES_URL = "mobile_cdr_resources/get_user_services.json";
const GET_SERVICES_URL = "user_services.json";
const GET_MOBILE_CDR_URL = "cdr-mobile.json?args[0]=";
const GET_MOBILE_CDR_REGISTRIES_URL = "mobile_cdr_resources/get_mobile_cdr";
const GET_MOBILE_CDR_SHORT_URL = "cdr-mobile-short.json?search=";
const GET_CUSTOMER = "get-customer-shop.json?search=";
const GET_SEARCH_CUSTOMER = "search-customer-shop.json?search=";
const GET_SEARCH_CUSTOMER_FILTER = "search-customer-shop-filter.json?search=";
const GET_SEARCH_CUSTOMER_MONTH = "search-customer-created-count.json?created=";
const GET_CUSTOMERS_MOBILES_URL = "customers-mobiles-shop";
const GET_CUSTOMERS_MOBILES_FILTER_URL = "customers-mobiles-shop-filter?search=";
const GET_CUSTOMERS_MOBILES_DNI_FILTER_URL = "customers-mobiles-shop-dni-filter?search=";
const GET_CUSTOMERS_MOBILES_SEARCH_URL = "customers-mobiles-shop-search?search=";
const CREATE_NODE = "node.json";
const SEARCH_MOBILE_PROCEDURES = "mobile-procedures-shop?client_id=";
const SEARCH_MOBILE_PROCEDURES_BY_STATUS = "mobile-procedures-shop?procedure_status=";
// const SEARCH_SIM_DELIVERIES = "sim-deliveries-shop.json?client_id=";
const SEARCH_SIM_DELIVERIES = "mobile_cdr_resources/get_sim_deliveries";
const CONFIRM_SIM_DELIVERY = "mobile_cdr_resources/confirm_sim_delivery";
const CREATE_SIM_DELIVERY = "mobile_cdr_resources/create_sim_delivery";
const GET_SIM_DELIVERY_TYPES = "mobile_cdr_resources/get_sim_delivery_types";
const FREE_SIM = "mobile_cdr_resources/free_sim";
const FLAG_NODE = "flag/flag.json";
const GET_ACTIVE_CUSTOMERS_COUNT = "count-customers";
const GET_MOBILE_PROCEDURES_COUNT = "mobile-procedures-count";
const GET_MOBILE_PROCEDURES_COUNT_GROUPED = "mobile-procedures-count-grouped";
const GET_MOBILE_REJECTED_PROCEDURES_COUNT = "mobile-procedures-rejected-count";
const GET_MOBILE_PLANS_GLOBAL = "mobile-plans-global";
const GET_MOBILE_PLANS_SHOP = "mobile-plans";
const GET_BILL_STATUSES = "list-bill-statuses";
const GET_PROCEDURE_TYPES_GLOBAL = "procedure-types-global";
const GET_CUSTOMER_NOTES = "customer-notes?user_id=";
const GET_ENTITY_NOTES = "mobile_cdr_resources/get_entity_notes";
const GET_CUSTOMER_EXTRA_EXPENSES = "customer-extra-expenses?user_id=";
const GET_INTERNET_PLANS = "internet-plans";
const UPDATE_CUSTOMER = "user/";
const GET_TV_PLANS_SHOP = "tv-plans";
const GET_ORDER_ID = "get-order-id.json?order_number=";
// const CREATE_CUSTOMER = "user";

// <USER_CUSTOM_API>
const CREATE_CUSTOMER = "nadunet_users_resources/new_user";
const EDIT_CUSTOMER = "nadunet_users_resources/edit_user";
const SWITCH_RENEWAL_CUSTOMER = "nadunet_users_resources/switch_renewal";
const SET_IBAN_CUSTOMER = "nadunet_users_resources/set_iban";
const CREATE_EXTRA_EXPENSE = "nadunet_users_resources/new_extra_expense";
const EDIT_EXTRA_EXPENSE = "nadunet_users_resources/edit_extra_expense";
const CHANGE_CLIENT_PASSWORD = "nadunet_users_resources/set_password";
const GET_CONTRACT_PRODUCTS = "nadunet_users_resources/get_contract_products";
const CREATE_CONTRACT = "nadunet_users_resources/new_contract";
const RESEND_CONTRACT = "nadunet_users_resources/resend_contract";
const SAVE_CONTRACT = "nadunet_contracts_resources/save_contract.json";
const EDIT_CONTRACT = "nadunet_users_resources/edit_contract.json";
const DELETE_CONTRACT = "nadunet_users_resources/delete_contract.json";
const GET_CONTRACTS_COUNT = "contracts-shop-counter.json";
const EDIT_TV_SUBSCRIPTION = "nadunet_users_resources/edit_tv_subscription";
// </USER_CUSTOM_API>

// <BILLING>
const GET_MONTHLY_BILLING_ALL = "bills-all-monthly";
const GET_MONTHLY_BILLING_PLANS = "bills-plans-monthly";
const GET_MONTHLY_BILLING_EXTRAS = "bills-extras-monthly";
const GET_MONTHLY_BILLING_NADUPACK = "bills-nadupack-monthly";
const GET_MONTHLY_BILLING_RETURNS = "bills-returns-monthly";
const GET_MONTHLY_BILLING_RETURNS_PAID = "bills-returns-paid-monthly";
const GET_MONTHLY_BILLS_PAID_RECURRENT = "paidbills-recurrent-monthly";
const GET_MONTHLY_BILLS_PAID_VARIABLE = "paidbills-variable-monthly";
const GET_MONTHLY_BILLS_PAID_ALL = "paidbills-all-monthly";
const GET_MONTHLY_BILLS_PAID_INVESTMENT = "paidbills-invest-monthly";
const GET_MONTHLY_BILLS_PAID_DETAIL = "nadunet_billing_resources/get_bills_paid_detail";
const UPDATE_ORDER_STATUS = "nadunet_billing_resources/update_order_status";
const CREATE_CUSTOMER_ORDER = "nadunet_billing_resources/create_order_by_id";
const CREATE_CUSTOMER_RECTIFICATION_BILL = "nadunet_billing_resources/create_rectification_order";
const CREATE_CUSTOMER_RECTIFICATION_ORDER = "nadunet_billing_resources/create_rectification_order_items";
const CREATE_CUSTOMER_PROFORMA_BILL = "nadunet_billing_resources/create_proforma_order";
// </BILLING>
// <CUSTOMERS>
const GET_MONTHLY_ACTIVE_CUSTOMERS = "bills-customers-monthly";
const GET_MONTHLY_BILL_RETURNING_CUSTOMERS = "bills-customers-debtors-monthly";
const GET_MONTHLY_BILL_RETURNING_PAID_CUSTOMERS = "bills-customers-debtors-paid-monthly";
const GET_CURRENT_INTERNET_CUSTOMERS = "get-internet-customers-count";
const GET_CURRENT_INTERNET_WIFI_CUSTOMERS = "get-internet-wifi-customers-count";
const GET_CURRENT_INTERNET_FIBER_CUSTOMERS = "get-internet-fibra-customers-count";
const GET_CURRENT_MOBILE_CUSTOMERS = "get-mobile-customers-count";
const GET_ACTIVE_MOBILE_LINES = "get-mobiles-count";
const GET_CURRENT_MOBILE_CUSTOMERS_WITH_INTERNET = "get-mobile-internet-customers-count";
const GET_CURRENT_MOBILE_CUSTOMERS_WITHOUT_INTERNET = "get-mobile-nointernet-customers-count";
// </CUSTOMERS>
// <EMPLOYEES>
const GET_MONTHLY_EMPLOYEES_PAYROLLS = "employee-payrolls";
// </EMPLOYEES>
// <CASH REGISTERS>
const GET_CASH_REGISTERS_LIST = "nadunet_office_resources/get_cash_registers";
const CREATE_CASH_REGISTRY = "nadunet_office_resources/create_cash_registry";
// </CASH REGISTERS>
// <TASKS>
const GET_TASKS_LIST = "nadunet_office_resources/list_tasks";
const START_TASK = "nadunet_office_resources/start_task";
const PAUSE_TASK = "nadunet_office_resources/pause_task";
const FINISH_TASK = "nadunet_office_resources/finish_task";
const CREATE_TASK = "nadunet_office_resources/create_task";
// </TASKS>

// <PSO>
const SEARCH_ONTS = "nadunet_pso_resources/search_onts";
const SEARCH_BUILDINGS = "nadunet_pso_resources/search_buildings";
const CHECK_COVERAGE = "nadunet_pso_resources/check_coverage";
const GET_BUILDING_DETAILS = "nadunet_pso_resources/get_building_details";
const SEARCH_CUSTOMER_SECRET = "nadunet_pso_resources/search_customer_secret";
const GET_SECRET_TRAFFIC = "nadunet_pso_resources/get_secret_traffic";
// </PSO>



const GET_MOBILE_SERVICES = "mobile-services?timestamp="; //rest/mobile_cdr_resources/get_current_day_data_cdr
const GET_MOBILE_SERVICES_API_URL = "mobile_cdr_resources/get_mobile_info";
const GET_TODAY_DATA_USAGE = "mobile_cdr_resources/get_current_day_data_cdr";

const GET_WEB_MOBILE_REQUESTS = "list-mobile-web-requests.json?search=";
const GET_WEB_MOBILE_REQUEST_DOCUMENTS = "documents-mobile-web-request.json?search=";
const GET_CUSTOMER_WEB_MOBILE_REQUESTS = "get-mobile-web-requests.json?client_id=";
const GET_CUSTOMER_WEB_MOBILE_REQUESTS_BY_STATUS = "get-mobile-web-requests-status.json?status=";
const GET_WEB_MOBILE_REQUESTS_COUNT = "get-mobile-web-requests-count";
const GET_BULK_CUSTOMERS = "mobile_cdr_resources/get_bulk_customers";
const EDIT_MOBILE = "mobile_cdr_resources/edit_mobile";
const CREATE_NOTE = "mobile_cdr_resources/create_note";
const ADD_MOBILE = "mobile_cdr_resources/add_mobile";
const CREATE_MOBILE_PROCEDURE = "mobile_cdr_resources/create_mobile_procedure";
const CANCEL_PROCEDURE = "mobile_cdr_resources/cancel_mobile_procedure";

const GET_TECHNICIANS_LIST = "get-technicians-list";
const GET_HOME_VISIT_TYPES_LIST = "get-home-visit-types-list";
const GET_HOME_VISIT_FINISH_REASON_LIST = "get-home-visit-finish-reason-list";
const GET_CALENDARS_LIST = "get-calendars-list";


const GET_WEB_CONTENT = "nadunet_frontend_resources/get_web_content";
const ASSIGN_WEBFORM = "nadunet_frontend_resources/assign_webform";
const UNASSIGN_WEBFORM = "nadunet_frontend_resources/unassign_webform";
const CLOSE_WEBFORM = "nadunet_frontend_resources/close_webform";


const MONTHS_TO_LOAD_COUNT = 6;

const TASK_MENU_LIST = "task-menu-list";
const TASK_MENU_CREATE = "task-menu-create";
const TASK_MENU_MAIN = "task-menu-main";

//<WHEEL>
const START_WHEEL = "nadunet_billing_resources/start_wheel";
const SEND_WHEEL_FORM = "nadunet_billing_resources/send_wheel_form";
//</WHEEL>
const GET_PAYMENT_LINK = "nadunet_billing_resources/generate_recharge_url";
const GET_CONTRACT_LINK = "nadunet_office_resources/get_contract_url";
const GET_RELATED_CONTRACTS_OPTION_LIST = "nadunet_office_resources/get_related_contracts_option_list";
const GET_WEBFORM = "nadunet_frontend_resources/get_webform";
const GET_GLOBAL_BILLING_STATUS = "nadunet_billing_resources/get_billing_global_status";
const LIST_RETURNED_BILLS = "nadunet_billing_resources/list_returned_bills";
const GET_ORDER = "nadunet_billing_resources/get_order";
const GET_CUSTOMER_ORDERS = "nadunet_billing_resources/get_customer_orders";
const LIST_DEBTORS = "nadunet_billing_resources/list_debtors";
const NEW_REGISTER_PAYMENT = "nadunet_billing_resources/register_payment";
const SEARCH_ROULETTE_RESULTS = "nadunet_billing_resources/list_roulette_results";
const SET_ROULETTE_RESULT_STATUS = "nadunet_billing_resources/set_roulette_result_status";

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const hist = createBrowserHistory();
const smallDeviceThreshold = 765;
var alreadyShownNotificationsPopUps = [];
var taskStateIcons = {
  247: "media-1_button-pause",      // Esperando
  248: "arrows-1_refresh-69 spin",  // En proceso
  249: "ui-1_check"                 // Finalizada
};
var lastTasksLoadedOnUpdate = 0;
const local_bills = [
  {
    fecha: "2022/06/17",
    numero_pedido: "422022220288",
    total: "-156,19 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/101605",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "101605",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/06/06",
    numero_pedido: "422022217849",
    total: "164,22 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/99166",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pago parcial",
    fecha_devolucion: "2022-06-06 10:00:00",
    fecha_pago_devolucion: [""],
    order_id: "99166",
    remaining_amount: "13,03 \u20ac",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/06/03",
    numero_pedido: "422022216783",
    total: "156,19 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/98100",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "98100",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/05/04",
    numero_pedido: "422022214304",
    total: "164,20 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/95621",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "95621",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/04/04",
    numero_pedido: "422022210783",
    total: "98,47 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/92101",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "92101",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/03/08",
    numero_pedido: "42202227295",
    total: "102,29 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/88613",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "88613",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/02/03",
    numero_pedido: "42202224189",
    total: "98,04 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/85507",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "85507",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2022/01/04",
    numero_pedido: "42202221096",
    total: "94,14 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/82414",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "82414",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/12/06",
    numero_pedido: "422021233918",
    total: "83,79 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/79323",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-12-17 11:59:01",
    fecha_pago_devolucion: "2022-02-04 08:59:10",
    order_id: "79323",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/11/03",
    numero_pedido: "422021230819",
    total: "85,76 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/76223",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "76223",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/10/05",
    numero_pedido: "422021229674",
    total: "-46,90 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/75076",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "75076",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/10/04",
    numero_pedido: "422021227726",
    total: "84,09 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/73128",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-10-28 11:31:41",
    fecha_pago_devolucion: "2021-11-04 10:57:52",
    order_id: "73128",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/09/03",
    numero_pedido: "422021224534",
    total: "84,24 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/69889",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-10-06 09:54:05",
    fecha_pago_devolucion: "2021-10-14 07:18:39",
    order_id: "69889",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/08/03",
    numero_pedido: "422021221476",
    total: "71,99 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/66831",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-08-18 10:27:29",
    fecha_pago_devolucion: "2021-09-08 13:13:29",
    order_id: "66831",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/07/05",
    numero_pedido: "422021218460",
    total: "85,04 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/63815",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-07-12 17:31:44",
    fecha_pago_devolucion: "2021-08-09 06:41:12",
    order_id: "63815",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/06/04",
    numero_pedido: "422021215538",
    total: "84,67 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/60894",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-06-18 11:32:14",
    fecha_pago_devolucion: "2021-07-02 14:27:06",
    order_id: "60894",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/05/03",
    numero_pedido: "422021212677",
    total: "83,94 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/58033",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-05-11 17:12:35",
    fecha_pago_devolucion: "2021-06-07 12:31:31",
    order_id: "58033",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/04/05",
    numero_pedido: "42202129848",
    total: "84,08 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/55204",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-04-21 09:05:31",
    fecha_pago_devolucion: "2021-05-05 09:08:54",
    order_id: "55204",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/03/02",
    numero_pedido: "42202127005",
    total: "98,03 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/52361",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-03-22 20:14:07",
    fecha_pago_devolucion: "2021-04-01 12:16:29",
    order_id: "52361",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/02/04",
    numero_pedido: "42202124159",
    total: "104,47 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/49515",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-02-10 19:25:31",
    fecha_pago_devolucion: "2021-03-03 11:55:12",
    order_id: "49515",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2021/01/04",
    numero_pedido: "42202121297",
    total: "76,56 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/46653",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2021-01-25 08:34:48",
    fecha_pago_devolucion: "2021-02-03 08:28:27",
    order_id: "46653",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/12/03",
    numero_pedido: "422020227782",
    total: "62,51 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/43858",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-12-11 18:51:26",
    fecha_pago_devolucion: "2020-12-30 18:15:50",
    order_id: "43858",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/11/02",
    numero_pedido: "422020224979",
    total: "54,00 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/41054",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-11-16 14:46:19",
    fecha_pago_devolucion: "2020-11-25 12:00:28",
    order_id: "41054",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/10/02",
    numero_pedido: "422020222218",
    total: "53,85 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/38294",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-10-20 16:47:20",
    fecha_pago_devolucion: "2020-10-26 10:05:01",
    order_id: "38294",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/09/04",
    numero_pedido: "422020219470",
    total: "65,80 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/35549",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-09-14 16:32:30",
    fecha_pago_devolucion: "2020-10-26 10:05:05",
    order_id: "35549",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/08/03",
    numero_pedido: "422020216790",
    total: "3,08 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/32869",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-08-14 10:45:40",
    fecha_pago_devolucion: "2020-09-11 16:33:45",
    order_id: "32869",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/07/05",
    numero_pedido: "422020214237",
    total: "47,95 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/30316",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-07-14 10:12:15",
    fecha_pago_devolucion: "2020-07-30 09:15:05",
    order_id: "30316",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/06/03",
    numero_pedido: "422020211822",
    total: "48,86 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/27902",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: "2020-06-15 13:42:17",
    fecha_pago_devolucion: "2020-07-15 10:48:16",
    order_id: "27902",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/05/05",
    numero_pedido: "42202029536",
    total: "36,29 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/25615",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "25615",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/04/03",
    numero_pedido: "42202027306",
    total: "35,85 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/23386",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: "2020-04-28 12:45:28",
    order_id: "23386",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/03/04",
    numero_pedido: "42202025145",
    total: "0,30 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/21226",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: "2020-04-28 12:45:23",
    order_id: "21226",
    line_items: {
      count: 10
    }
  },
  {
    fecha: "2020/02/10",
    numero_pedido: "42202023248",
    total: "47,85 \u20ac",
    enlace_pdf: "https://mi-tienda.nadunet.es/api/invoice-pdf/19329",
    cliente_id: "118136",
    nombre: "M\u00aa Luz",
    primer_apellido: "Romero",
    segundo_apellido: "Herraiz",
    estado_pedido: "Pagada",
    fecha_devolucion: [""],
    fecha_pago_devolucion: [""],
    order_id: "19329",
    line_items: {
      count: 10
    }
  }
];

class App extends Component {
  constructor(props) {
    super(props);
    // localStorage.clear();
    console.log("minadunet tienda v1.6.4 - Face Login detect in server");
    //console.log("DEBUG MODE:" + DEBUG_MODE);

    axios.interceptors.request.use(request => {
      ////console.log("Starting Request...", request);
      return request;
    });

    let orders = [];
    this.state = {
      auxArrayCDR: [],
      customers: [],
      customersLoaded: false,
      customersLastMonths: [],
      customersLastMonthsLoaded: false,
      customersMobiles: [],
      customersMobilesRaw: [],
      customersMobilesLoaded: false,
      debug: DEBUG_MODE,
      isLoggedIn: false,
      hasMobile: false,
      hasInternet: false,
      internet_plan: null,
      internetLoaded: false,
      mobiles: [],
      mobilesLoaded: false,
      mobilePlans: {
        raw: [],
        forOptions: []
      },
      mobilesCDR: [],
      mobilesCDRLoaded: false,
      mobilesLoadedCount: 0,
      mobilesSearchResult: [],
      orders: orders,
      ordersArticles: [],
      ordersLoaded: false,
      ordersArticlesLoaded: false,
      ordersByCustomer: [],
      retriesCDR: 0,
      width: 0,
      height: 0,
      smallDevice: false,
      resetPass: this.checkReset(),
      searchCustomerQuery: "",
      isSearchingCustomer: false,
      isSearchCustomerResult: false,
      mobileProcedures: [],
      isSearchingMobileProcedures: [],
      isCancellingMobileProcedure: [],
      mobileProceduresCount: 0,
      mobileProceduresCountLoaded: false,
      mobileProcedureTypes: [],
      customersCount: 0,
      customersCountLoaded: false,
      mobileRejectedProceduresCount: 0,
      mobileRejectedProceduresCountLoaded: false,
      searchBulkCustomer: null,
      customerSearchResult: [],
      isSearchBillResult: false,
      isSearchingCustomerNotes: [],
      customerNotes: [],
      settingCustomerInternet: [],
      customerExtraExpenses: [],
      mobileServices: [],
      webMobileRequests: [],
      webMobileRequestsByCustomerID: [],
      webMobileRequestsLoaded: false,
      webMobileRequestsSearchResult: [],
      searchWebMobileRequestsQuery: "",
      isSearchingWebMobileRequests: false,
      isSearchWebMobileRequestsResult: false,
      webMobileRequestDocuments: [],
      isSearchingWebMobileRequestsDocuments: [],
      createCustomerFromWebRequest: null,
      createCustomerFromContract: null,
      isCreatingSIMDelivery: false,
      isSearchingSIMDeliveries: [],
      SIMDeliveries: [],
      webMobileRequestsByStatus: [],
      billStatuses: [],
      todayDataUsage: [],
      refreshingSession: false,
      refreshRetries: 0,
      contractProducts: [],
      settingCustomerTV: [],
      TVPlans: {
        raw: [],
        forOptions: []
      },
      contractsLoaded: false,
      contracts: [],
      customerContracts: [],
      isSearchingContracts: false,
      contractsSearchResult: [],
      contractTemplatesLoaded: false,
      contractTemplates: [],
      contract: null,
      contractToEdit: null,
      isEditingContract: false,
      closeContract: false,
      orders_ids: [],
      contractsCount: [],
      existingCustomerForContract: null,
      isTechnician: this.isTechnician.bind(this),
      customerSearchReference: [],
      techniciansList: [],
      homeVisitTypesList: [],
      unsubscribeHistory: null,
      communicationTemplates: {},
      last_customer_update: [],
      isChangingOwnPass: false,
      notifications: [],
      sessionConfig: [],
      coverages: [],
      buildings: [],
      isSearchingCoverage: false,
      taskMenu: {
        position: TASK_MENU_MAIN
      },
      tasksList: [],
      selectedTaskMenu: 0,
      startingTask: [],
      finishingTask: [],
      pausingTask: [],
      webforms: [],
      isAssigningWebform: [],
      isClosingWebform: []
    };
    // if(DEBUG_MODE) this.state.tasksList = [
    //     {
    //      "id":"10094883",
    //      "title":"Nueva nota de prueba",
    //      "url":"/clientes/fichas/635",
    //      "description":null,
    //      "related_data":null,
    //      "state":247,
    //      "state_name":"Esperando",
    //      "date":"2021-09-06T10:38:17",
    //      "start":"1970-01-01T01:00:00",
    //      "finish":"1970-01-01T01:00:00",
    //      "priority":111,
    //      "priority_name":"Normal",
    //      "destiny":{
    //         "name":"Adrian-nadunet",
    //         "picture":"https://mi-tienda.nadunet.es/api/sites/default/files/pictures/picture-469-1599415384.png",
    //         "id":"469"
    //      },
    //      "author":{
    //         "name":"Adrian-nadunet",
    //         "picture":"https://mi-tienda.nadunet.es/api/sites/default/files/pictures/picture-469-1599415384.png",
    //         "id":"469"
    //      }
    //     }
    //   ];

    let retrievedState = null;
    try {
      retrievedState = this.loadSavedSession();
      // console.log("Retrieved state \"mi-tienda\"");
      // console.log(retrievedState);
      // console.log("OK");
      if (Object.keys(retrievedState).length > 0) {
        if (this.checkPermissions(retrievedState.user.roles)) {
          Object.keys(retrievedState).map(element => {
            this.state[element] = retrievedState[element];
          });
        }
      }
      // console.log("State after loading saved state \"mi-tienda\"");
      // console.log(this.state);
      // if (this.state.isLoggedIn) this.godMode(null, true);
    } catch (e) {
      // console.log("ERROR");
      retrievedState = {};
      localStorage.removeItem("mi-tienda");
    }
    // console.log(retrievedState);

    this.buildQueryHeaders = this.buildQueryHeaders.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.clearCookies = this.clearCookies.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.getOrders = this.getOrders.bind(this);
    this.getOrdersArticles = this.getOrdersArticles.bind(this);
    this.getServices = this.getServices.bind(this);
    this.getInternet = this.getInternet.bind(this);
    this.getMobile = this.getMobile.bind(this);
    this.signOut = this.signOut.bind(this);
    this.getMobileCDR = this.getMobileCDR.bind(this);
    this.getMobileCDRShort = this.getMobileCDRShort.bind(this);
    this.checkIfLoggedIn = this.checkIfLoggedIn.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
    this.disableRestart = this.disableRestart.bind(this);
    this.setSearchCustomerQuery = this.setSearchCustomerQuery.bind(this);
    this.getCustomersMobiles = this.getCustomersMobiles.bind(this);
    this.createMobileProcedure = this.createMobileProcedure.bind(this);
    this.searchMobileProcedures = this.searchMobileProcedures.bind(this);
    this.cancelMobileProcedure = this.cancelMobileProcedure.bind(this);
    this.getMobileRejectedProceduresCount = this.getMobileRejectedProceduresCount.bind(this);
    this.getMobileProceduresCount = this.getMobileProceduresCount.bind(this);
    this.getMobilePlans = this.getMobilePlans.bind(this);
    this.getTVPlans = this.getTVPlans.bind(this);
    this.getMobileProcedureTypes = this.getMobileProcedureTypes.bind(this);
    this.searchBills = this.searchBills.bind(this);
    this.searchBillsByCustomerID = this.searchBillsByCustomerID.bind(this);
    this.searchContracts = this.searchContracts.bind(this);
    this.loadContractTemplates = this.loadContractTemplates.bind(this);
    this.getCustomerNotes = this.getCustomerNotes.bind(this);
    this.createNote = this.createNote.bind(this);
    this.setCustomerInternetPlan = this.setCustomerInternetPlan.bind(this);
    this.toggleCustomerInternetService = this.toggleCustomerInternetService.bind(this);
    this.setCustomerIBAN = this.setCustomerIBAN.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.switchCustomerRenewal = this.switchCustomerRenewal.bind(this);
    this.createCustomerMobile = this.createCustomerMobile.bind(this);
    this.createInternetWrapper = this.createInternetWrapper.bind(this);
    this.createExtraExpenseWrapper = this.createExtraExpenseWrapper.bind(this);
    this.getCustomerExtraExpenses = this.getCustomerExtraExpenses.bind(this);
    this.loadMobileServices = this.loadMobileServices.bind(this);
    this.getMobileServices = this.getMobileServices.bind(this);
    this.createMobileServicesWrapper = this.createMobileServicesWrapper.bind(this);
    this.modifyMobileServicesWrapper = this.modifyMobileServicesWrapper.bind(this);
    this.changeClientPassword = this.changeClientPassword.bind(this);
    
    this.searchWebMobileRequests = this.searchWebMobileRequests.bind(this);
    this.setSearchWebMobileRequestsQuery = this.setSearchWebMobileRequestsQuery.bind(this);
    this.getWebMobileRequestDocuments = this.getWebMobileRequestDocuments.bind(this);
    this.getWebMobileRequestsCount = this.getWebMobileRequestsCount.bind(this);
    this.createCustomerFromWebRequest = this.createCustomerFromWebRequest.bind(this);
    this.searchSIMDeliveries = this.searchSIMDeliveries.bind(this);
    this.createSIMDelivery = this.createSIMDelivery.bind(this);
    this.getBillStatuses = this.getBillStatuses.bind(this);
    this.editBill = this.editBill.bind(this);
    this.getTodayDataUsage = this.getTodayDataUsage.bind(this);
    this.getMobileServicesAPI = this.getMobileServicesAPI.bind(this);
    this.searchBulkCustomer = this.searchBulkCustomer.bind(this);
    this.editCustomer = this.editCustomer.bind(this);
    this.getContract = this.getContract.bind(this);
    this.closeContract = this.closeContract.bind(this);
    this.saveContract = this.saveContract.bind(this);
    this.editContract = this.editContract.bind(this);
    this.editContractAsync = this.editContractAsync.bind(this);
    this.deleteContract = this.deleteContract.bind(this);
    this.cleanContract = this.cleanContract.bind(this);
    this.createCustomerFromContract = this.createCustomerFromContract.bind(this);
    this.getContractsCount = this.getContractsCount.bind(this);

    this.doLogin = this.doLogin.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.getContractProducts = this.getContractProducts.bind(this);
    this.createContract = this.createContract.bind(this);
    this.resendContract = this.resendContract.bind(this);
    this.saveSession = this.saveSession.bind(this);
    this.continueSavingSession = this.continueSavingSession.bind(this);
    this.edit_tv_subscription = this.edit_tv_subscription.bind(this);
    this.getOrderID = this.getOrderID.bind(this);
    this.searchCustomerContracts = this.searchCustomerContracts.bind(this);

    this.getAllBillingMonthly = this.getAllBillingMonthly.bind(this);
    this.getPlansBillingMonthly = this.getPlansBillingMonthly.bind(this);
    this.getExtrasBillingMonthly = this.getExtrasBillingMonthly.bind(this);
    this.getNaduPacksBillingMonthly = this.getNaduPackBillingMonthly.bind(this);
    this.getBillingData = this.getBillingData.bind(this);
    this.getMonthlyBillingReturns = this.getMonthlyBillingReturns.bind(this);
    this.getMonthlyBillingReturnsPaid = this.getMonthlyBillingReturnsPaid.bind(this);
    this.getMonthlyBillReturningCustomers = this.getMonthlyBillReturningCustomers.bind(this);
    this.getMonthlyBillReturningPaidCustomers = this.getMonthlyBillReturningPaidCustomers.bind(this);
    this.getMonthlyPayrolls = this.getMonthlyPayrolls.bind(this);

    this.getCashRegistersList = this.getCashRegistersList.bind(this);
    this.createCashRegistry = this.createCashRegistry.bind(this);

    this.setExistingCustomerForContract = this.setExistingCustomerForContract.bind(this);
    this.setExistingCustomerForHomeVisit = this.setExistingCustomerForHomeVisit.bind(this);
    this.setExistingCustomerForTicket = this.setExistingCustomerForTicket.bind(this);
    
    this.setProductsForContract = this.setProductsForContract.bind(this);
    
    this.isTechnician = this.isTechnician.bind(this);
    this.isBillingDepartment = this.isBillingDepartment.bind(this);
    this.isBillingDepartmentN1 = this.isBillingDepartmentN1.bind(this);
    this.isBillingDepartmentN2 = this.isBillingDepartmentN2.bind(this);
    this.isSalesDepartment = this.isSalesDepartment.bind(this);

    this.searchHomeVisits = this.searchHomeVisits.bind(this);
    this.getHomeVisitsLog = this.getHomeVisitsLog.bind(this);
    this.getCurrentHomeVisit = this.getCurrentHomeVisit.bind(this);
    this.getHomeVisit = this.getHomeVisit.bind(this);
    this.viewHomeVisit = this.viewHomeVisit.bind(this);
    this.startHomeVisit = this.startHomeVisit.bind(this);
    this.changeHomeVisitBillingStatus = this.changeHomeVisitBillingStatus.bind(this);
    this.deleteHomeVisit = this.deleteHomeVisit.bind(this);
    this.addHomeVisitComment = this.addHomeVisitComment.bind(this);
    this.addHomeVisitPhoto = this.addHomeVisitPhoto.bind(this);
    this.editHomeVisitPhoto = this.editHomeVisitPhoto.bind(this);
    this.deleteHomeVisitPhoto = this.deleteHomeVisitPhoto.bind(this);
    this.searchCustomerReference = this.searchCustomerReference.bind(this);
    this.getTechniciansList = this.getTechniciansList.bind(this);
    this.getHomeVisitTypesList = this.getHomeVisitTypesList.bind(this);
    this.getHomeVisitFinishReasonList = this.getHomeVisitFinishReasonList.bind(this);
    this.createHomeVisit = this.createHomeVisit.bind(this);
    this.editHomeVisit = this.editHomeVisit.bind(this);
    this.editHomeVisitDate = this.editHomeVisitDate.bind(this);
    this.finishHomeVisit = this.finishHomeVisit.bind(this);
    this.getCustomerHomeVisits = this.getCustomerHomeVisits.bind(this);
    this.createHomeVisitFromCalendar = this.createHomeVisitFromCalendar.bind(this);
    this.getCalendarsList = this.getCalendarsList.bind(this);
    this.unsubscribe_mobile = this.unsubscribe_mobile.bind(this);
    this.unsubscribe_mobile_history = this.unsubscribe_mobile_history.bind(this);
    this.get_communication_templates = this.get_communication_templates.bind(this);
    this.send_customer_email = this.send_customer_email.bind(this);
    this.get_customer_communications = this.get_customer_communications.bind(this);
    this.create_communication = this.create_communication.bind(this);
    this.get_notifications = this.get_notifications.bind(this);
    this.read_notification = this.read_notification.bind(this);
    this.unread_notification = this.unread_notification.bind(this);
    this.get_configuration = this.get_configuration.bind(this);
    this.set_configuration = this.set_configuration.bind(this);
    this.setPassword = this.setPassword.bind(this);

    this.list_support_tickets = this.list_support_tickets.bind(this);
    this.get_support_ticket = this.get_support_ticket.bind(this);
    this.get_departments = this.get_departments.bind(this);
    this.changeTicketDepartment = this.changeTicketDepartment.bind(this);
    this.assignTicket = this.assignTicket.bind(this);
    this.unassignTicket = this.unassignTicket.bind(this);
    this.openTicket = this.openTicket.bind(this);
    this.closeTicket = this.closeTicket.bind(this);
    this.sendTicketMessage = this.sendTicketMessage.bind(this);
    this.get_tickets_statistics = this.get_tickets_statistics.bind(this);
    this.get_ticket_options = this.get_ticket_options.bind(this);
    this.createSupportTicket = this.createSupportTicket.bind(this);
    this.confirmSIMDelivery = this.confirmSIMDelivery.bind(this);
    this.getSIMDeliveryTypes = this.getSIMDeliveryTypes.bind(this);
    this.getMobileCdrRegistries = this.getMobileCdrRegistries.bind(this);

    this.saveSessionConfig = this.saveSessionConfig.bind(this);
    this.show_notifications_popups = this.show_notifications_popups.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    
    this.searchONTs = this.searchONTs.bind(this);
    this.searchBuildings = this.searchBuildings.bind(this);
    this.checkCoverage = this.checkCoverage.bind(this);
    this.getBuildingDetails = this.getBuildingDetails.bind(this);
    this.freeSIM = this.freeSIM.bind(this);
    this.readAllNotifications = this.readAllNotifications.bind(this);
    this.getTaskMenu = this.getTaskMenu.bind(this);
    this.changeSelectedTaskMenu = this.changeSelectedTaskMenu.bind(this);
    this.startTask = this.startTask.bind(this);
    this.pauseTask = this.pauseTask.bind(this);
    this.finishTask = this.finishTask.bind(this);
    this.createTask = this.createTask.bind(this);
    this.getTasks = this.getTasks.bind(this);
    this.searchCustomerSecret = this.searchCustomerSecret.bind(this);
    this.getSecretsTraffic = this.getSecretsTraffic.bind(this);

    this.getWebContent = this.getWebContent.bind(this);
    this.assignWebform = this.assignWebform.bind(this);
    this.closeWebform = this.closeWebform.bind(this);
    this.startWheel = this.startWheel.bind(this);
    this.sendWheelForm = this.sendWheelForm.bind(this);
    this.getPaymentLink = this.getPaymentLink.bind(this);
    this.getContractURL = this.getContractURL.bind(this);
    this.getRelatedContracts = this.getRelatedContracts.bind(this);
    this.getWebform = this.getWebform.bind(this);
    this.getGlobalBillingStatus = this.getGlobalBillingStatus.bind(this);
    this.listReturnedBills = this.listReturnedBills.bind(this);
    this.getOrder = this.getOrder.bind(this);
    this.getCustomerOrders = this.getCustomerOrders.bind(this);
    this.listDebtors = this.listDebtors.bind(this);
    this.deleteContractAsync = this.deleteContractAsync.bind(this);
    this.newRegisterPayment = this.newRegisterPayment.bind(this);
    this.searchRouletteResults = this.searchRouletteResults.bind(this);
    this.setRouletteResultStatus = this.setRouletteResultStatus.bind(this);
    this.addFaces = this.addFaces.bind(this);
    this.createBill = this.createBill.bind(this);
    this.createRectificationBill = this.createRectificationBill.bind(this);
    this.createProformaBill = this.createProformaBill.bind(this);
    this.getRectificationBillItems = this.getRectificationBillItems.bind(this);
    this.setCustomerOrders = this.setCustomerOrders.bind(this);
    this.pushCustomerOrder = this.pushCustomerOrder.bind(this);
    this.changeConfiguration = this.changeConfiguration.bind(this);
    this.faceExists = this.faceExists.bind(this);
    this.getXCSRFToken = this.getXCSRFToken.bind(this);
    this.setXCSRFToken = this.setXCSRFToken.bind(this);
    this.removeXCSRFToken = this.removeXCSRFToken.bind(this);
    this.faceLogin = this.faceLogin.bind(this);
    this.detectFace = this.detectFace.bind(this);
    this.getTaxesAndConcepts = this.getTaxesAndConcepts.bind(this);
    this.formatPrice = this.formatPrice.bind(this);
    this.createReceivedOrders = this.createReceivedOrders.bind(this);
    this.createProvider = this.createProvider.bind(this);
    this.godMode = this.godMode.bind(this);
    this.listReminders = this.listReminders.bind(this);
    this.createReminder = this.createReminder.bind(this);
    this.changeReminderDate = this.changeReminderDate.bind(this);
    this.loadReminder = this.loadReminder.bind(this);
    this.setPayday = this.setPayday.bind(this);
    this.searchByBillNumber = this.searchByBillNumber.bind(this);
    this.getFreeWebformsCount = this.getFreeWebformsCount.bind(this);
    this.getProcessingWebformsCount = this.getProcessingWebformsCount.bind(this);
    // this.unassignWebform = this.unassignWebform.bind(this);
    // this.addWebformComment = this.addWebformComment.bind(this);

    // if (DEBUG_MODE) {
    //   hist.push("/face");
    // } else {
      this.checkIfLoggedIn();
    // }
  }
  async componentDidMount() {
    return;
    if (window.location.host.includes("instalar")) document.title = "Instalar - nadunet";
    if (this.state.isLoggedIn) this.godMode(null, true);
    window.addEventListener("beforeunload", ev => {
      ev.preventDefault();
      // this.clearCookies();
    });
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    hist.listen(location => ReactGA.pageview(location.pathname));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.getWebformsCount) {
      this.getFreeWebformsCount();
      this.getProcessingWebformsCount();
      this.getWebformsCount = setInterval(() => {
        // Lógica de la función que se ejecutará cada 1 minuto
        this.getFreeWebformsCount();
        this.getProcessingWebformsCount();
      }, 60000); // 60000 milisegundos = 1 minuto
    }
    // console.log("App update, this.state", this.state);
    // console.log("TEST GA", ReactGA.get);
    if (this.state.isTechnician() && this.state.isLoggedIn && (!window.location.pathname.startsWith("/citas") && 
      !window.location.pathname.startsWith("/herramientas") && !window.location.pathname.startsWith("/configuracion"))) {
      hist.push("/citas");
    }
    if (this.state.isLoggedIn && !prevState.isLoggedIn) {
      let becariosUsers = [
        "Miguel.Zarzo-nadunet"
      ];
      
      let externalUsers = [
        "Oniti"
      ];
      if (becariosUsers.indexOf(this.state.user.name) > -1 || externalUsers.indexOf(this.state.user.name) > -1) {
        hist.push("/clientes");
      } else {
        hist.push("/dashboard");
      }
    }
    this.saveSession();
    if (this.state.isLoggedIn) {
      if (!this.isTechnician()) this.getTasks();
    }
  }
  buildQueryHeaders() {
    let headers = null;
    cookies.get("refreshing_session");
    headers = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return headers;
  }
  saveSessionConfig(section, config) {
    // console.log("saving session config", {
    //   section: section,
    //   config: config
    // });
    let sessionConfig = this.state.sessionConfig;
    if (!sessionConfig) sessionConfig = [];

    sessionConfig[section] = config;

    this.setState({ sessionConfig: sessionConfig });
  }
  checkReset() {
    if (window.location.pathname.includes("/api/user/reset/")) {
      let resetPath = window.location.pathname;
      let splitPath = resetPath.split("/");
      let resetPassUid = splitPath[4];
      let resetPassToken = splitPath[6];
      let timestamp = splitPath[5];

      return {
        isResetPass: true,
        token: resetPassToken,
        uid: resetPassUid,
        path: splitPath,
        timestamp: timestamp
      };
    } else {
      return {
        isResetPass: false,
        token: null,
        uid: null,
        path: null
      };
    }
  }

  goToLogin() {
    hist.push("/entrar");
    this.disableRestart();
  }

  disableRestart() {
    this.setState({
      resetPass: {
        isResetPass: false
      }
    });
  }

  checkIfLoggedIn() {
    if (!this.state.resetPass.isResetPass) {
      if (
        !this.state.isLoggedIn &&
        !window.location.pathname.includes("/restablecer") &&
        !window.location.pathname.includes("/recuperar")
      )
        hist.push("/entrar");
    } else {
      hist.push("/restablecer");
    }
  }
  // Check if face model exists for current user
  async faceExists() {
    let request = {
      // label: this.state.user.field_entity_uuid.und[0].value
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "face/naduface_exists";
    // console.log("llamada a add_faces (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición naduface_exists: ", error.message);
      });
  }
  // Add face to faceapi models
  async addFaces(faces, name) {
    let request = {
      faces: {
        // name: this.state.user.field_entity_uuid.und[0].value,
        faces: faces
      }
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "face/add_nadufaces";
    console.log("llamada a add_faces (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición add_nadufaces: ", error.message);
      });
  }
  // Face login
  async faceLogin(face) {
    let request = {
      img: {
        face: face
      }
    };
    let queryHeaders = {
      headers: {
        // "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let face_axios = new axios.create();
    face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "face/naduface_login";
    // console.log("llamada a naduface_login (url)", url);
    return face_axios.post(url, request, queryHeaders, { withCredentials: false })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición naduface_login: ", error.message);
      });
  }
  // Detect Face
  async detectFace(face) {
    let request = {
      face: {
        face: face
      }
    };
    let queryHeaders = {
      headers: {
        // "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let face_axios = new axios.create();
    face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "face/detect_face";
    // console.log("llamada a naduface_login (url)", url);
    return face_axios.post(url, request, queryHeaders, { withCredentials: false })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición detect_face: ", error.message);
      });
  }
  // Get free webforms count
  async getFreeWebformsCount() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_frontend_resources/count_free_webforms";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        if (result && result.data) {
          if (result.data.ok) {
            this.setState({ freeWebformsCount: result.data.count });
            if (result.data.count > 0) {
              let options = {
                place: "tc",
                message: <a style={{color: "#FFF"}} href="/web">{"Hay " + result.data.count + " formularios web sin atender"}</a>,
                type: "danger",
                icon: "now-ui-icons travel_info",
                autoDismiss: 10
              };
              if (result.data.count === 1) options.message = <a style={{color: "#FFF"}} href="/web">{"Hay 1 formulario web sin atender"}</a>;
              // this.showNotification(options);
            }
          }
        }
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición count_free_webforms: ", error.message);
      });
  }
  // Get processing webforms count
  async getProcessingWebformsCount() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_frontend_resources/count_processing_webforms";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        if (result && result.data) {
          if (result.data.ok) {
            this.setState({ processingWebformsCount: result.data.count });
            if (result.data.count > 0) {
              let options = {
                place: "tc",
                message: <a style={{color: "#FFF"}} href="/web">{"Hay " + result.data.count + " formularios web en proceso"}</a>,
                type: "warning",
                icon: "now-ui-icons travel_info",
                autoDismiss: 10
              };
              if (result.data.count === 1) options.message = <a style={{color: "#FFF"}} href="/web">{"Hay 1 formulario web en proceso"}</a>;
              // this.showNotification(options);
            }
          }
        }
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición count_processing_webforms: ", error.message);
      });
  }
  // Get taxes, concepts and business lines lists
  async getTaxesAndConcepts() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_billing_resources/load_taxes_and_concepts";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición getTaxesAndConcepts: ", error.message);
      });
  }
  // List reminders with filter
  async listReminders(filter) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      filter: filter
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_office_resources/list_reminders";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición listReminders: ", error.message);
      });
  }
  // Load reminder by id
  async loadReminder(id) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      id: id
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_office_resources/load_reminder";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición load_reminder: ", error.message);
      });
  }
  // Create reminder
  async createReminder(reminder) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      reminder: reminder
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_office_resources/create_reminder";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición createReminder: ", error.message);
      });
  }
  // Change reminder date
  async changeReminderDate(reminder) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      reminder: reminder
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_office_resources/change_reminder_date";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición changeReminderDate: ", error.message);
      });
  }
  // Create providers received bills
  async createReceivedOrders(orders) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      bills: orders
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_billing_resources/create_received_bill";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición createReceivedOrders: ", error.message);
      });
  }
  // Set customer Payday
  async setPayday(payday) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      payday: payday
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_users_resources/set_payday";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición set_payday: ", error.message);
      });
  }
  // Create providers received bills
  async createProvider(provider) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      provider: provider
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_billing_resources/create_provider";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición createProvider: ", error.message);
      });
  }
  // Create customer bill
  async createBill(items, id, billStatus) {
    let request = {
      items: items,
      id: id,
      order_status: billStatus
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + CREATE_CUSTOMER_ORDER;
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => result.data)
      .catch((error) => {
        console.error("Error en la petición create_order: ", error.message);
      });
  }
  // Create customer bill
  async createRectificationBill(request) {
    // let request = {
    //   items: items,
    //   id: id,
    //   order_status: billStatus
    // };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + CREATE_CUSTOMER_RECTIFICATION_BILL;
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => result.data)
      .catch((error) => {
        console.error("Error en la petición create_rectification_order: ", error.message);
      });
  }
  // Create customer bill
  async createProformaBill(request) {
    // let request = {
    //   items: items,
    //   id: id,
    //   order_status: billStatus
    // };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + CREATE_CUSTOMER_PROFORMA_BILL;
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => result.data)
      .catch((error) => {
        console.error("Error en la petición create_proforma_order: ", error.message);
      });
  }
  // Create customer bill
  async getRectificationBillItems(billIds) {
    let request = {
      order_ids: billIds,
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // let face_axios = new axios.create();
    // face_axios.defaults.withCredentials = false;
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + CREATE_CUSTOMER_RECTIFICATION_ORDER;
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => result.data)
      .catch((error) => {
        console.error("Error en la petición create_rectification_order_items: ", error.message);
      });
  }
  // Save contract (product data) 
  async deleteContractAsync(contract) {
    // if (this.state.isSavingContract) return;
    /* ////console.log("################## GET USERNAME ################"); */

    // this.setState({
    //   isSavingContract: true
    //   // isSigningContract: contract.signature || false
    // });

    let request = {
      contract: contract
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return axios.post(API + DELETE_CONTRACT, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  // Search roulette Results 
  async searchRouletteResults(filter) {
    let request = {
      filter: filter
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return axios.post(API + SEARCH_ROULETTE_RESULTS, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  // Set roulette result status (result: {id, status})
  async setRouletteResultStatus(result) {
    let request = {
      result: result
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    return axios.post(API + SET_ROULETTE_RESULT_STATUS, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async getOrder(orderId, updateInCustomerList, orderReloaded) {
    if (orderReloaded) {
      if (updateInCustomerList) {
        let ordersByCustomer = this.state.ordersByCustomer;
        if (!ordersByCustomer) {
          ordersByCustomer = [];
          ordersByCustomer[updateInCustomerList] = [];
        }
        ordersByCustomer[updateInCustomerList][orderId] = orderReloaded;
        // ordersByCustomer[updateInCustomerList] = result.data.bills;
        this.setState({
          // orders: orders,
          ordersByCustomer: ordersByCustomer
        });
      }
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      id: orderId
    };
    this.setState({ isGettingOrder: true });

    return axios.post(API + GET_ORDER, request, queryHeaders, {withCredentials: true})
      .then(result => {
        this.setState({ isGettingOrder: false });
        if (updateInCustomerList) {
          let ordersByCustomer = this.state.ordersByCustomer;
          if (!ordersByCustomer) {
            ordersByCustomer = [];
            ordersByCustomer[updateInCustomerList] = [];
          }
          ordersByCustomer[updateInCustomerList][orderId] = result.data.bill;
          // ordersByCustomer[updateInCustomerList] = result.data.bills;
          this.setState({
            // orders: orders,
            ordersByCustomer: ordersByCustomer
          });
        }
        return result.data;
      })
      .catch((error) => {
        this.setState({ isGettingOrder: false });
      });
  }
  async getGlobalBillingStatus(query) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      query: query
    };

    return axios.post(API + GET_GLOBAL_BILLING_STATUS, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async listReturnedBills(query) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      query: query
    };

    return axios.post(API + LIST_RETURNED_BILLS, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async listDebtors(search) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      search: search
    };

    return axios.post(API + LIST_DEBTORS, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async getWebform(webformId) {
    let request = {
      webform_id: webformId
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return axios.post(API + GET_WEBFORM, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async getRelatedContracts(customerID) {
    let request = {
      data: {
        customer_id: customerID
      }
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return axios.post(API + GET_RELATED_CONTRACTS_OPTION_LIST, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async getContractURL(contract_id, contract_pin) {
    let request = {
      data: {
        contract_id: contract_id,
        contract_pin: contract_pin
      }
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return axios.post(API + GET_CONTRACT_LINK, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  async getPaymentLink(customer_id, short_url = false) {
    let request = {
      data: {
        customer_id: customer_id,
        short_url: short_url
      }
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return axios.post(API + GET_PAYMENT_LINK, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }

  async startWheel() {
    console.log("Empezando ruleta...");
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      params: {
        secret: "39rCgTt4XQmUBbkcB2bVgN5XbNtUK9n2TAY6SC57x2L3xDdEn7T9XJgPHNXGkUXAAsEPv8mKFUg5w88YeJr6nYS2U7whqfhYqUy7BM34f5VwhnGrDL8hSC3aW2wY7B8RpV3xXB9mfjzZJfNazq4kqtSLC4sf5KQMseNsYkVb9MSRMYh368p3YgcdWN3TN7Br3fmBbMmQNzTXbK8MBB2Sz9QUcvKrkpstA7hu4ku9CstSvN4FZuUzwDzm4wqckkhX",
        commercial: this.state.user.uid
      }
    };
    return axios
      .post(API + START_WHEEL, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => result.data)
      .catch(error => {
        console.log("Error al girar la ruleta");
      });
  }
  async sendWheelForm(data) {
    // console.log("Empezando ruleta...");
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let query = {
      data: data
    };
    return axios
      .post(API + SEND_WHEEL_FORM, query, queryHeaders, {
        withCredentials: true
      })
      .then(result => result.data)
      .catch(error => {
        console.log("Error al girar la ruleta");
      });
  }
  async saveSession() {
    try {
      if (this.state.user) {
        if (!this.checkPermissions(this.state.user.roles)) return;
      }
      // console.log("Starting save to localStorage \"mi-tienda\"");
      // console.log(this.state);
      let stateToSave = {
        isLoggedIn: this.state.isLoggedIn,
        session: this.state.session,
        user: this.state.user,
        password: this.state.password
      };
      // let stateToSave = this.state;
      let alreadySavedState = this.loadSavedSession();
      if (JSON.stringify(alreadySavedState) !== JSON.stringify(stateToSave)) {
        // console.log("Saving to localStorage subState \"mi-tienda\"");
        // console.log(stateToSave);
        let stateAsString = JSON.stringify(stateToSave);
        // console.log("TOTAL SIZE - NORMAL");
        // console.log(stateAsString.length);
        /*let stateCompressed = */
        LZ.compress(
          stateAsString,
          1,
          this.continueSavingSession,
          this.showCompressionProgess
        );
      } else {
        // console.log("NOT SAVED. Equals than existing \"mi-tienda\"");
      }
    } catch (error) {
      try {
        // console.log("ERROR saving to localStorage \"mi-tienda\"");
        // console.log(error);
        // console.log("Clearing localStorage");
        localStorage.clear();
        // console.log("Trying again to save to localStorage \"mi-tienda\"");
        // console.log(stateToSave);
        // let stateToSave = {
        //   isLoggedIn: this.state.isLoggedIn,
        //   session: this.state.session,
        //   user: this.state.user,
        //   password: this.state.password
        // };
        // let stateToSave = this.state;
        // localStorage.setItem("mi-tienda", JSON.stringify(stateToSave));
      } catch (error) {
        // console.log("IMPOSIBLE to save to localStorage \"mi-tienda\"");
        // console.log("TOTAL SIZE");
        // console.log(JSON.stringify(this.state).length);
      }
    }
  }
  continueSavingSession(stateCompressed) {
    // console.log("TOTAL SIZE - COMPRESSED");
    // console.log(stateCompressed.length);
    // console.log(stateCompressed);
    // let stateCompressedString = this.compressedToString(stateCompressed);
    // console.log("TOTAL SIZE - COMPRESSED AS STRING");
    // console.log(stateCompressedString.length);
    // console.log("COMPRESSION RATE STATE/COMPRESSED");
    // console.log(stateCompressed.length / stateAsString.length);
    // console.log("COMPRESSION RATE STATE/COMPRESSED-STRING");
    // console.log(stateCompressedString.length / stateAsString.length);
    // stateCompressed = stateCompressedString;
    // console.log("CHECK STRING-BYTE INTEGRITY");
    // console.log(this.stringToCompressed(stateCompressedString).equals(stateCompressed));
    let chunkSize = 4500000;
    let chunksToSave = Math.ceil(stateCompressed.length / chunkSize);

    localStorage.setItem("mi-tienda-chunks", chunksToSave);
    for (let index = 0; index < chunksToSave; index++) {
      // console.log("Saving to localStorage subState \"mi-tienda\" [CHUNK " + (index + 1) + "/" + chunksToSave + "]");
      let startIndex = index * chunkSize;
      let endIndex = (index + 1) * chunkSize;
      let currentChunk = stateCompressed.slice(startIndex, endIndex);
      localStorage.setItem("mi-tienda-" + index, currentChunk);
    }
    // console.log("SAVED to localStorage subState \"mi-tienda\"");
  }
  showCompressionProgess(progress) {
    // console.log("Compressing... " + progress);
  }
  loadSavedSession() {
    let chunksToLoad = localStorage.getItem("mi-tienda-chunks") || 0;
    let loadedState = null;
    if (chunksToLoad != 0) {
      chunksToLoad = parseInt(chunksToLoad);
      loadedState = "";
    }
    for (let index = 0; index < chunksToLoad; index++) {
      // console.log("Loading from localStorage subState \"mi-tienda\" [CHUNK " + (index + 1) + "/" + chunksToLoad + "]");
      loadedState = loadedState + localStorage.getItem("mi-tienda-" + index);
    }
    if (loadedState) {
      loadedState = this.stringToCompressed(loadedState);
      loadedState = LZ.decompress(loadedState);
    } else {
      loadedState = "{}";
    }
    loadedState = JSON.parse(loadedState);
    // console.log("Loaded all CHUNKS from localStorage subState \"mi-tienda\"");
    // console.log(loadedState);

    return loadedState;
  }
  compressedToString(compressed) {
    var result = "";
    for (var i = 0; i < compressed.length; i++) {
      result += parseInt(compressed[i], 2).toString();
      if (i < compressed.length - 2) result += ",";
    }
    return result;
  }
  stringToCompressed(string) {
    var result = [];
    string = string.split(",");
    for (var i = 0; i < string.length; i++) {
      result.push(string[i].toString(2));
    }
    return result;
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", ev => {
      ev.preventDefault();
      // this.clearCookies();
    });
    window.removeEventListener("resize", this.updateWindowDimensions);
    if (this.checkNotifications) clearInterval(this.checkNotifications);
    if (this.getWebformsCount) clearInterval(this.getWebformsCount);
  }

  UNSAFE_componentWillUpdate() {
    this.checkIfLoggedIn();
  }

  updateWindowDimensions() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
      smallDevice: window.innerWidth < smallDeviceThreshold
    });
  }

  signOut() {
    hist.push("/entrar");
    this.clearCookies();
    this.setState({
      auxArrayCDR: [],
      // customers: [],
      customersLoaded: false,
      customersLastMonths: [],
      customersLastMonthsLoaded: false,
      customersMobiles: [],
      customersMobilesRaw: [],
      customersMobilesLoaded: false,
      debug: DEBUG_MODE,
      isLoggedIn: false,
      hasMobile: false,
      hasInternet: false,
      internet_plan: null,
      internetLoaded: false,
      mobiles: [],
      mobilesLoaded: false,
      mobilesCDR: [],
      mobilesCDRLoaded: false,
      mobilesLoadedCount: 0,
      ordersLoaded: false,
      ordersArticlesLoaded: false,
      retriesCDR: 0,
      width: 0,
      height: 0,
      smallDevice: false,
      resetPass: this.checkReset(),
      searchCustomerQuery: "",
      isSearchingCustomer: false,
      isSearchCustomerResult: false,
      mobileProcedures: [],
      isSearchingMobileProcedures: [],
      isCancellingMobileProcedure: [],
      mobileProceduresCount: 0,
      mobileProceduresCountLoaded: false,
      customersCount: 0,
      customersCountLoaded: false,
      mobileRejectedProceduresCount: 0,
      mobileRejectedProceduresCountLoaded: false
    });
  }

  clearCookies() {
    if (this.state.session) {
      let queryHeaders = {
        "X-CSRF-Token": this.getXCSRFToken()
      };
      axios
        .post(API + DO_LOGOUT_URL, {}, { headers: queryHeaders })
        .then(result => {
          /* //////console.log("################## RESPUESTA LOGOUT ################");
          //////console.log(result); */
        })
        .catch(error => {
          // Error 😨
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            /* //////console.log(error.response.data);
                //////console.log(error.response.status);
                //////console.log(error.response.headers); */
            this.setState({
              error,
              loginError: true
            });
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            /* //////console.log(error.request); */
            this.setState({
              error,
              loginError: true
            });
          } else {
            // Something happened in setting up the request and triggered an Error
            /* //////console.log('Error', error.message); */
            this.setState({
              error,
              loginError: true
            });
          }
          /* //////console.log(error.config); */
        });
    }
    // if (this.state.debug) {
    //   let cookies = document.cookie.split(";");

    //   for (let i = 0; i < cookies.length; i++) {
    //     let cookie = cookies[i];
    //     let eqPos = cookie.indexOf("=");
    //     let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    //     document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    //   }
    // }
  }
  edit_tv_subscription(subscription) {
    if (this.state.isEditingTVSubscription) return;
    this.setState({
      isEditingTVSubscription: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let ACTION_BAJA = 1;
    let ACTION_CAMBIO = 2;
    let ACTION_ALTA = 3;
    if (subscription.action === "BAJA") subscription.action = ACTION_BAJA;
    if (subscription.action === "ALTA") {
      subscription.action = ACTION_ALTA;
      subscription.plan = parseInt(subscription.plan.value);
    }
    let request = {
      subscription: subscription
    };
    axios
      .post(API + EDIT_TV_SUBSCRIPTION, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isEditingTVSubscription: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Subscripción de TV editada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {
          let options = {
            place: "tr",
            message: "Error al modificar la subscripción de TV",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isEditingTVSubscription: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  unsubscribe_mobile(mobile) {
    if (this.state.isUnsubscribingMobile) return;
    this.setState({
      isUnsubscribingMobile: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      mobile: mobile
    };
    axios
      .post(API + UNSUBSCRIBE_MOBILE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.unsubscribe_mobile_history();
        this.setState({
          isUnsubscribingMobile: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Móvil dado de baja",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar dar de baja el móvil: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isUnsubscribingMobile: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  searchONTs(query) {
    if (this.state.isSearchingONTs) return;
    this.setState({
      isSearchingONTs: true,
      searchONTsQuery: query
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      search: query
    };
    axios
      .post(API + SEARCH_ONTS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isSearchingONTs: false
        });
        if (result.data.result === "OK") {
          let foundONTs = this.state.foundONTs;
          if (!foundONTs) foundONTs = [];
          foundONTs[query] = result.data.onts;
          this.setState({ foundONTs: foundONTs });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar buscar ONTs: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSearchingONTs: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  searchBuildings(query) {
    if (this.state.isSearchingBuildings) return;
    this.setState({
      isSearchingBuildings: true,
      searchBuildingsQuery: query
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      address: query
    };
    axios
      .post(API + SEARCH_BUILDINGS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isSearchingBuildings: false
        });
        if (result.data.result === "OK") {
          let buildings = this.state.buildings;
          if (!buildings) buildings = [];
          buildings[query] = result.data.buildings;
          this.setState({ buildings: buildings });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar buscar edificios: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSearchingBuildings: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  checkCoverage(query) {
    if (this.state.isSearchingCoverage) return;
    this.setState({
      isSearchingCoverage: true,
      searchCoverageQuery: query
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      gescal: query
    };
    axios
      .post(API + CHECK_COVERAGE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isSearchingCoverage: false
        });
        if (result.data.result === "OK") {
          let coverages = this.state.coverages;
          if (!coverages) coverages = [];
          coverages[query] = result.data.coverage;
          this.setState({ coverages: coverages });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar obtener la cobertura: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSearchingCoverage: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }
  
  getBuildingDetails(query) {
    if (this.state.isSearchingBuildingDetails) return;
    this.setState({
      isSearchingBuildingDetails: true,
      searchBuildingDetailsQuery: query
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      gescal: query
    };
    axios
      .post(API + GET_BUILDING_DETAILS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isSearchingBuildingDetails: false
        });
        if (result.data.result === "OK") {
          let buildingDetails = this.state.buildingDetails;
          if (!buildingDetails) buildingDetails = [];
          buildingDetails[query] = result.data.buildingDetails;
          this.setState({ buildingDetails: buildingDetails });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar obtener los detalles del edificio: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSearchingBuildingDetails: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }
  
  searchCustomerSecret(query) {
    if (this.state.isSearchingCustomerSecret) return;
    this.setState({
      isSearchingCustomerSecret: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      customer_id: query
    };
    axios
      .post(API + SEARCH_CUSTOMER_SECRET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isSearchingCustomerSecret: false
        });
        if (result.data.result === "OK") {
          let secrets = this.state.secrets;
          if (!secrets) secrets = [];
          secrets[query] = result.data.secrets;
          this.setState({ secrets: secrets });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar buscar el secret: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSearchingBuildingDetails: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }
  
  getSecretsTraffic(query) {
    if (this.state.isGettingSecretsTraffic) return;
    this.setState({
      isGettingSecretsTraffic: true
    });

    let secretsToSearch = null;
    if (this.state.secrets) {
      if (query in this.state.secrets) {
        secretsToSearch = this.state.secrets[query];
      }
    }
    if (!secretsToSearch || secretsToSearch.length === 0) {
      this.setState({
        isGettingSecretsTraffic: false
      });
      return;
    }

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      secrets: secretsToSearch
    };
    axios
      .post(API + GET_SECRET_TRAFFIC, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isGettingSecretsTraffic: false
        });
        if (result.data.result === "OK") {
          let secrets = this.state.secrets;
          if (!secrets) secrets = [];
          Object.keys(result.data.secrets).map(secretId => {
            if (!secrets[query]) secrets[query] = [];
            secrets[query][secretId] = result.data.secrets[secretId];
          });
          this.setState({ secrets: secrets });
          // let options = {
          //   place: "tr",
          //   message: "Móvil dado de baja",
          //   type: "primary",
          //   icon: "now-ui-icons ui-1_check",
          //   autoDismiss: 3
          // };
          // this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar obtener el tráfico: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingSecretsTraffic: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  freeSIM(query) {
    if (this.state.isSearchingCoverage) return;
    this.setState({
      isFreeingSIM: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      icc: query
    };
    axios
      .post(API + FREE_SIM, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // this.unsubscribe_mobile_history();
        this.setState({
          isFreeingSIM: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "SIM liberada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al intentar liberar la SIM: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isFreeingSIM: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  getMobileCdrRegistries(mobiles, month) {
    // // console.log("################## GET MOBILE CDR ################", {number: number, month: month });
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    // if (month){
    //   if (month in this.state.olderCdrLoaded && this.state.olderCdrLoaded[month]) return;
    //   let auxLoadedMonths = this.state.olderCdrLoaded;
    //   auxLoadedMonths[month] = true;
    //   this.setState({ olderCdrLoaded: auxLoadedMonths });
    // }

    /* this.state.mobiles.forEach(function iterator(currentMobileObject) { */
    // let currentMobile = number;
    let url = API + GET_MOBILE_CDR_REGISTRIES_URL; // + currentMobile;
    let currentMonth = moment().format("YYYY-MM");
    if (month) {
      currentMonth = month;
    } else {
      month = currentMonth;
    }
    // url = url + "&args[1]=" + currentMonth
    // mobiles = mobiles.map(mobile => {
    //   return {
    //     number: mobile
    //   };
    // });
    if (mobiles.length === 1 && month) {
      if (mobiles[0].number in this.state.mobilesCDR) {
        if (month in this.state.mobilesCDR[mobiles[0].number]) {
          // console.log("CDR EXISTENTE, ABOOOOOOOORT");
          // console.log("---------------");
          return;
        }
      }
    }
    // console.log("CARGANDO NUEVO CDR");
    // console.log("mobiles", mobiles);
    // console.log("month", month);
    let request = {
      cdr: {
        mobiles: mobiles,
        date: currentMonth
      }
    };
    axios
      .post(url, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // // console.log(
        //   "################## RESPUESTA GET CDR " +
        //     currentMobile +
        //     " ################"
        // );
        // // console.log(result);
        // // console.log("resultado obtener CDR", result);

        if (result && result.data) {
          let newCDR = result.data;
          let cdr = this.state.mobilesCDR;
          Object.keys(newCDR).map( currentMobile => {
            let existingCDR = [];
            if (!cdr) cdr = [];
            if (currentMobile in cdr) existingCDR = cdr[currentMobile];
            existingCDR[month] = newCDR[currentMobile][month];
            cdr[currentMobile] = existingCDR;
          });
          // // console.log("cdr ready to save", cdr);
          this.setState({
            mobilesCDR: cdr,
            // auxArrayCDR: newMobilesCDR,
            mobilesCDRLoaded: true,
            mobilesLoadedCount: mobiles.length
          });
            
          var options = {
            place: "tr",
            message: "CDR móvil cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else if (this.state.retriesCDR < 5) {
          const retries = this.state.retriesCDR + 1;
          this.setState({
            retriesCDR: retries
          });
          this.getMobileCDR(mobiles, month);
        } else {
          this.setState({
            mobilesCDRLoaded: true,
            mobilesLoadedCount: this.state.mobilesLoadedCount + mobiles.length
          });
        }
      })
      .catch(error => {
        console.log("error obtener CDR", error);
        if (month){
          let auxLoadedMonths = this.state.olderCdrLoaded;
          if (!auxLoadedMonths) auxLoadedMonths = [];
          auxLoadedMonths[month] = false;
          this.setState({ olderCdrLoaded: auxLoadedMonths });
        }
        /* ////// console.log("################## ERROR ################"); */
      });
    /* }, this); */
  }

  unsubscribe_mobile_history() {
    if (this.state.isGettingUnsubscribeMobileHistory) return;
    this.setState({
      isGettingUnsubscribeMobileHistory: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + UNSUBSCRIBE_MOBILE_HISTORY, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingUnsubscribeMobileHistory: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Historial de bajas de móvil cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (DEBUG_MODE) this.showNotification(options);
          this.setState({ unsubscribeHistory: result.data.history });
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener el historial de bajas: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingUnsubscribeMobileHistory: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  get_tickets_statistics() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_SUPPORT_TICKETS_STATISTICS, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Tickets cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (DEBUG_MODE) this.showNotification(options);
          this.setState({ tickets_statistics: result.data.statistics });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener las estadísticas de los tickets: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingSupportTickets: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  createSupportTicket(ticket) {
    this.setState({
      isCreatingTicket: true,
      isErrorCreatingTicket: false
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      new_ticket: ticket
    };
    axios
      .post(API + CREATE_SUPPORT_TICKET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Ticket abierto",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          let tickets = this.state.tickets;
          if (!tickets) tickets = {};
          tickets[result.data.ticket.id] = result.data.ticket;
          this.setState({
            tickets: tickets,
            lastCreatedTicketID: result.data.ticket.id,
            isCreatingTicket: false,
            isErrorCreatingTicket: false
          });
          // this.searchHomeVisits();
        } else {
          this.setState({
            isCreatingTicket: false,
            isErrorCreatingTicket: true
          });
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo abrir el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        this.setState({
          isCreatingTicket: false,
          isErrorCreatingTicket: true
        });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  get_ticket_options() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_SUPPORT_TICKET_OPTIONS, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Opciones de tickets cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (DEBUG_MODE) this.showNotification(options);
          this.setState({ ticket_options: result.data.options });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al cargar las opciones de los tickets: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  list_support_tickets(customer) {
    if (this.state.isGettingUnsubscribeMobileHistory) return;
    // if (DEBUG_MODE) customer = -666;
    this.setState({
      isGettingSupportTickets: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      customer: customer ? parseInt(customer) : 0
    };
    axios
      .post(API + LIST_SUPPORT_TICKETS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingSupportTickets: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Tickets cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          if (customer === -666) customer = null;
          if (customer && customer !== 0) {
            let customersTickets = this.state.customersTickets;
            if (!customersTickets) customersTickets = {};
            customersTickets[parseInt(customer)] = result.data.tickets;
            this.setState({ customersTickets: customersTickets });
          } else {
            let tickets = this.state.tickets;
            if (!tickets) tickets = {};
            Object.keys(result.data.tickets).map(ticketID => {
              let ticket = result.data.tickets[ticketID];
              tickets[ticketID] = ticket;
            });
            this.setState({ tickets: tickets });
          }
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener los tickets: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingSupportTickets: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  get_departments() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_DEPARTMENTS, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Departamentos cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          this.setState({ departments: result.data.departments });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener los departamentos: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  changeTicketDepartment(ticket_id, department_id) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: {
        id: ticket_id,
        department: department_id
      }
    };
    axios
      .post(API + CHANGE_TICKET_DEPARMENT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Departamento cambiado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // this.searchHomeVisits();
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo cambiar el departamento: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  assignTicket(ticket_id) {
    if (this.state.assigningTicket) return;
    this.setState({ assigningTicket: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: ticket_id
    };
    axios
      .post(API + ASSIGN_TICKET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ assigningTicket: false });
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Ticket asignado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // this.searchHomeVisits();
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo asignar el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ assigningTicket: false });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  unassignTicket(ticket_id) {
    if (this.state.assigningTicket) return;
    this.setState({ assigningTicket: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: ticket_id
    };
    axios
      .post(API + UNASSIGN_TICKET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ assigningTicket: false });
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Ticket asignado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // this.searchHomeVisits();
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo abandonar el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ assigningTicket: false });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  openTicket(ticket_id) {
    if (this.state.openingTicket) return;
    this.setState({ openingTicket: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: ticket_id
    };
    axios
      .post(API + OPEN_TICKET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ openingTicket: false });
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Ticket abierto",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al abrir el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ openingTicket: false });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  closeTicket(ticket_id) {
    if (this.state.openingTicket) return;
    this.setState({ openingTicket: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: ticket_id
    };
    axios
      .post(API + CLOSE_TICKET, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ openingTicket: false });
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Ticket cerrado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al cerrar el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ openingTicket: false });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  sendTicketMessage(ticket_id, message) {
    if (this.state.sendingTicketMessage) return;
    this.setState({ sendingTicketMessage: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      message: {
        ticket: ticket_id,
        message: message
      }
    };
    let user_picture = null;
    if (this.state.user.picture) user_picture = this.state.user.picture.url;
    let temp_message = {
      id: -1,
      author: {
        name: "Yo",
        id: this.state.user.uid,
        picture:
          user_picture ||
          "https://mi-tienda.nadunet.es/api/sites/default/files/pictures/default-user-image.png"
      },
      text: message.text,
      data: [],
      state: {
        id: 666,
        name: "Enviando"
      },
      date: "1970-01-01T00:00:00"
    };
    if (message.data) temp_message.data = message.data;
    let aux_temp = this.state.tickets;
    let current_ticket = aux_temp[ticket_id];
    let ticket_messages = current_ticket.comments;
    if (!ticket_messages) ticket_messages = [];
    ticket_messages.push(temp_message);
    aux_temp[ticket_id] = current_ticket;
    this.setState({ tickets: aux_temp });
    axios
      .post(API + SEND_TICKET_MESSAGE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ sendingTicketMessage: false });
        if (result.data.result === "OK") {
          let tickets = this.state.tickets;
          if (tickets === null) tickets = [];
          tickets[ticket_id] = result.data.ticket;
          this.setState({
            tickets: tickets
          });
          let options = {
            place: "tr",
            message: "Mensaje enviado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al enviar el mensaje: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ sendingTicketMessage: false });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  get_support_ticket(id) {
    if (this.state.isGettingUnsubscribeMobileHistory) return;
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      ticket: id
    };
    axios
      .post(API + GET_SUPPORT_TICKETS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Tickets cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          let auxTickets = this.state.tickets;
          if (!auxTickets) auxTickets = {};
          auxTickets[id] = result.data.ticket;
          this.setState({ tickets: auxTickets });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener el ticket: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  get_communication_templates() {
    if (this.state.isGettingCommunicationTemplates) return;
    this.setState({
      isGettingCommunicationTemplates: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + COMMUNICATION_TEMPLATES, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingCommunicationTemplates: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Plantillas de comunicaciones cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          let templatesForOptions = result.data.templates.map(item => {
            return {
              label: item.title,
              value: item.id
            };
          });
          const groupByID = groupBy("id");
          const groupedByID = groupByID(result.data.templates);
          this.setState({
            communicationTemplates: {
              templates: groupedByID,
              forOptions: templatesForOptions
            }
          });
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener la lista de plantillas: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingCommunicationTemplates: false
        });
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  send_customer_email(email) {
    if (this.state.isSendingCustomerEmail) return;
    this.setState({
      isSendingCustomerEmail: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      email: email
    };
    axios
      .post(API + SEND_CUSTOMER_EMAIL, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isSendingCustomerEmail: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Email enviado al cliente",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (DEBUG_MODE) */ this.showNotification(options);
          this.get_customer_communications(email.customer_id);
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener la lista de plantillas: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isSendingCustomerEmail: false
        });
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  create_communication(communication) {
    if (this.state.isCreatingCommunication) return;
    this.setState({
      isCreatingCommunication: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      communication: communication
    };
    axios
      .post(API + CREATE_COMMUNICATION, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isCreatingCommunication: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Comunicación creada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (DEBUG_MODE) */ this.showNotification(options);
          this.get_customer_communications(communication.customer_id);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al crear la comunicación: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isCreatingCommunication: false
        });
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  get_customer_communications(customer) {
    if (this.state.isGettingCustomerCommunications) return;
    this.setState({
      isGettingCustomerCommunications: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      customer: customer
    };
    axios
      .post(API + GET_CUSTOMER_COMMUNICATIONS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingCustomerCommunications: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Comunicaciones cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          let customersCommunications = this.state.customersCommunications;
          if (!customersCommunications) customersCommunications = [];
          customersCommunications[customer] = result.data.communications;
          this.setState({
            customersCommunications: customersCommunications
          });
        } else {  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener la lista de comunicaciones: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isGettingCustomerCommunications: false
        });
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  get_notifications(no_concat) {
    if (this.state.isGettingNotifications) return;
    if (window.location.pathname.includes("/calendario")) return;
    if (window.location.pathname.includes("/recordatorios")) return;
    this.setState({
      isGettingNotifications: true
    });
    let max_notifications = 2000;
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let offset = 0;
    let concat = true; // window.location.pathname.includes("notificaciones");
    // console.log("concat notifications", concat);
    if (concat && !no_concat && this.state.notifications) {
      if (this.state.notifications && Object.keys(this.state.notifications).length > 0) {
        offset = Object.keys(this.state.notifications).length;
        if (offset > max_notifications) offset = max_notifications;
      }
    }
    let request = {
      offset: offset
    };
    axios
      .post(API + GET_NOTIFICATIONS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingNotifications: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Notificaciones cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          // console.log("notifications response", result.data.notifications);

          let aux_notifications = this.state.notifications;
          if (!aux_notifications) aux_notifications = {};
          Object.keys(result.data.notifications).map(current_id => {
            aux_notifications[current_id] = result.data.notifications[current_id];
          });

          this.setState({
            notifications: aux_notifications
          });

          // if (concat && !no_concat) this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener las notificaciones: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        this.show_notifications_popups();
      })
      .catch(error => {
        this.setState({
          isGettingNotifications: false
        });
        // if (error && error.response) {
        //   if (error.response.status === 403 || error.response.status === 401)
        //     this.cleanSession();
        // }
      });
  }

  filter_notifications_channels(configuration) {
    return configuration.notifications.id === "notifications-channels";
  }

  filter_notifications_channels_popup(channel) {
    return channel.showPopUp === true;
  }

  filter_unread_notifications(notification) {
    return !notification.isRead;
  }

  redirectTo(redirect) {
    hist.push(redirect);
    // this.props.history.push(redirect);
  }

  createNotificationRedirect(redirect) {
    switch (redirect.type) {
      case "customer":
        return "/clientes/fichas/" + redirect.id;
      case "home_visit":
        return "/citas/" + redirect.id;
      case "register_box":
        return "/cajas/" + redirect.id;
      case "ticket":
        return "/tickets/" + redirect.id;
      case "contract":
        return "/contratos/" + redirect.id;
      case "task":
        return redirect.id;
      default:
        return "#";
    }
  }

  show_notifications_popups() {
    let configuration = this.state.configuration;
    let notifications = this.state.notifications;
    if (!configuration) return;
    if (!notifications || notifications.length < 1) return;

    let channels = null;
    try {
      channels = configuration.notifications.tweaks["notifications-channels"].value;
    } catch (error) {
      return;
    } 
    if (!channels) return;
    let channelsToPopUp = channels.filter(this.filter_notifications_channels_popup);
    channelsToPopUp = channelsToPopUp.map(channel => { return channel.id; });
    if (!channelsToPopUp) return;

    notifications = notifications.filter(this.filter_unread_notifications);
    notifications.map(notification => {
      let showNotification = false;
      if (!alreadyShownNotificationsPopUps.includes(notification.id)) {
        let notification_categories = notification.category;
        notification_categories.map(category => { 
          if(channelsToPopUp.includes(parseInt(category.id))) showNotification = true;
        });
        let notification_to_show = null;
        if (showNotification) notification_to_show = notification;
        if (notification_to_show) {
          let current = notification_to_show;
          alreadyShownNotificationsPopUps.push(current.id);
          // console.log("notification to show popup", current);
          let notification_type = <span className={"type " + current.type.name.toLowerCase()}></span>;
          let notification_category = current.category.map(category => {
            return <span key={category.id} className={"category " + category.id}>{category.name}</span>;
          });
          let notification_text = <div style={{display: "contents"}} dangerouslySetInnerHTML={{ __html: current.text }} />;
          let notification_state = current.isRead ? "read" : "unread";
          let date_class = "notification-date " + notification_state;
          let notification_date = <span className={date_class}>{moment(current.date).fromNow()}</span>;
          let notification = (
            <div
              className={"notification " + notification_state}
              onClick={() => {
                this.read_notification(current.id);
                if (current.hasRedirect) this.redirectTo(this.createNotificationRedirect(current.redirect));
              }}
            >
              {notification_text}
              <br />
              {notification_date}
            </div>
          );
          let notification_color = current.type.name.toLowerCase();
          switch (notification_color) {
            case "ok": notification_color = "primary"; break;
            case "error": notification_color = "danger"; break;
            case "warning": notification_color = "warning"; break;
            case "neutral": notification_color = "neutral"; break;
            default: notification_color = "neutral";
          }
          let options = {
            place: "br",
            message: notification,
            type: notification_color,
            icon: "now-ui-icons shopping_tag-content",
            autoDismiss: 30
          };
          this.showNotification(options);
        }
      }
    });
  }

  read_notification(id) {
    console.log("Read notification in App", id);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      notification: id
    };
    axios
      .post(API + READ_NOTIFICATION, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Notificación leída",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al marcar como leída la notificación: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  unread_notification(id) {
    console.log("Unread notification in App", id);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      notification: id
    };
    axios
      .post(API + UNREAD_NOTIFICATION, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Notificación marcada como no leída",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al marcar como no leída la notificación: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  get_configuration() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_CONFIGURATION, null, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Configuración cargada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          this.setState({
            configuration: result.data.configuration
          });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener la configuración: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  changeConfiguration(configuration) {
    this.setState({
      configuration: configuration
    });
  }

  set_configuration(configuration) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      configuration: configuration
    };
    axios
      .post(API + SET_CONFIGURATION, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Configuración guardada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // if (DEBUG_MODE) this.showNotification(options);
          this.setState({
            configuration: result.data.configuration
          });
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al guardar la configuración: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  setPassword(password) {
    if (this.state.isChangingOwnPass) return;
    this.setState({ isChangingOwnPass: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      password: password
    };
    axios
      .post(API + SET_PASSWORD, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          this.setState({ 
            isChangingOwnPass: false,
            changingOwnPassSuccess: true
          });
          let options = {
            place: "tr",
            message: "Contraseña cambiada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {
          this.setState({ 
            isChangingOwnPass: false,
            changingOwnPassSuccess: false
          });
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al guardar la configuración: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ 
          isChangingOwnPass: false,
          changingOwnPassSuccess: false
        });
        if (error && error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  getOrderID(order_number) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    if (order_number === undefined) {
      return;
    }
    if (order_number in this.state.orders_ids) {
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_ORDER_ID + order_number;
    
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);
        
        try {
          let orders_ids = this.state.orders_ids;
          orders_ids[order_number] = result.data[0].order_id;
  
          this.setState({
            orders_ids: orders_ids
          });
          let options = {
            place: "tr",
            message: "ID de factura cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } catch (error) {
          let options = {
            place: "tr",
            message: "Error al cargar el ID de factura",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  // Search bills by bill number
  async searchByBillNumber(query) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      search: query
    };
    // console.log("llamada a add_faces (request)", JSON.stringify(request));
    let url = API + "nadunet_billing_resources/search_bill";
    // console.log("llamada a naduface_login (url)", url);
    return axios.post(url, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("Respuesta de la petición: ", JSON.stringify(result));
        return result.data;
      })
      .catch((error) => {
        console.error("Error en la petición search_bill: ", error.message);
      });
  }

  searchBills(query, unpaid) {
    // console.log("################## GET BILLS BY CUSTOMER NIF ################");
    // console.log(query);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingBills) {
      this.setState({
        searchBillsQuery: query,
        isSearchingBills: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_BILLS_URL + query;
    if (unpaid) {
      urlToUse = API + SEARCH_UNPAID_BILLS_URL + query;
    }
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS BY CUSTOMER NIF ################");
        // console.log(result);

        const groupByID = groupBy('cliente_id');
        const groupByOrderID = groupBy('order_id');
        const groupedByCliente_id = groupByID(result.data);
        const groupedByOrder_id = groupByOrderID(result.data);
        let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        this.setState({
          ordersLoaded: true,
          orders: result.data,
          isSearchingBills: false,
          isSearchBillResult: true
        });
        let options = {
          place: "tr",
          message: "Facturas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  pushCustomerOrder(customerId, order) {
    let ordersByCustomer = this.state.ordersByCustomer;
    if (!ordersByCustomer) ordersByCustomer = [];
    if (!ordersByCustomer[customerId]) ordersByCustomer[customerId] = [];
    ordersByCustomer[customerId][order.order_id] = order;
    this.setState({
      ordersByCustomer: ordersByCustomer,
    });
  }
  setCustomerOrders(customerId, orders) {
    let ordersByCustomer = this.state.ordersByCustomer;
    if (!ordersByCustomer) ordersByCustomer = [];
    ordersByCustomer[customerId] = orders;
    this.setState({
      ordersByCustomer: ordersByCustomer,
    });
  }
  getCustomerOrders(customerId) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      id: customerId
    };
    axios
      .post(API + GET_CUSTOMER_ORDERS, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS BY CUSTOMER ID ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        if (result.data.ok) {
          let ordersByCustomer = this.state.ordersByCustomer;
          if (!ordersByCustomer) ordersByCustomer = [];
          ordersByCustomer[customerId] = result.data.bills;
          this.setState({
            ordersLoaded: true,
            // orders: orders,
            ordersByCustomer: ordersByCustomer,
            orders: result.data.bills,
            isSearchingBills: false,
            isSearchBillResult: true
          });
          let options = {
            place: "tr",
            message: "Facturas cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          let options = {
            place: "tr",
            message: "Error al cargar las facturas del cliente. " + result.data.error[0],
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }


        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
          if (error.response.status === 403 && !DEBUG_MODE) {
            // setTimeout((function() {
            //   this.searchBillsByCustomerID(query, unpaid);
            // }).bind(this), 1000);
          }
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  searchBillsByCustomerID(query, unpaid, isGetCustomerBills) {
    if (isGetCustomerBills) {
      this.getCustomerOrders(query);
      return;
    }
    // console.log("################## GET BILLS BY CUSTOMER ID ################");
    // console.log(query);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingBills) {
      this.setState({
        searchBillsQuery: query,
        isSearchingBills: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_BILLS_BY_ID_URL + query;
    if (unpaid) {
      urlToUse = API + SEARCH_UNPAID_BILLS_URL + query;
    }

    let orders = [
      {
        "fecha":"2021/04/05",
        "numero_pedido":"42202128633",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/53989",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"53989"
      },
      {
        "fecha":"2021/01/04",
        "numero_pedido":"422021221",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/45377",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"45377"
      },
      {
        "fecha":"2020/11/02",
        "numero_pedido":"422020223617",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/39692",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"39692"
      },
      {
        "fecha":"2020/10/30",
        "numero_pedido":"422020223616",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/39691",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"39691"
      },
      {
        "fecha":"2020/10/30",
        "numero_pedido":"422020223615",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/39690",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"39690"
      },
      {
        "fecha":"2020/09/28",
        "numero_pedido":"422020220816",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/36891",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"36891"
      },
      {
        "fecha":"2020/04/03",
        "numero_pedido":"10250",
        "total":"0,42 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/10249",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"10249"
      },
      {
        "fecha":"2020/03/04",
        "numero_pedido":"42202023590",
        "total":"39,44 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/19671",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 16:34:48",
        "fecha_pago_devolucion":"2020-11-24 16:34:43",
        "order_id":"19671"
      },
      {
        "fecha":"2020/02/10",
        "numero_pedido":"42202021659",
        "total":"48,55 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/17739",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 15:18:49",
        "fecha_pago_devolucion":"2020-03-09 18:10:19",
        "order_id":"17739"
      },
      {
        "fecha":"2020/01/07",
        "numero_pedido":"422020229",
        "total":"17,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/16109",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2021-01-05 09:43:42",
        "fecha_pago_devolucion":"2020-04-29 16:27:22",
        "order_id":"16109"
      },
      {
        "fecha":"2019/12/04",
        "numero_pedido":"42201929619",
        "total":"17,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/14734",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 14:24:04",
        "fecha_pago_devolucion":"2020-04-08 02:55:43",
        "order_id":"14734"
      },
      {
        "fecha":"2019/11/06",
        "numero_pedido":"42201929507",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/14622",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"14622"
      },
      {
        "fecha":"2019/11/05",
        "numero_pedido":"42201928284",
        "total":"18,04 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/13399",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 15:31:12",
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"13399"
      },
      {
        "fecha":"2019/10/05",
        "numero_pedido":"42201927118",
        "total":"17,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/12233",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 15:36:45",
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"12233"
      },
      {
        "fecha":"2019/09/10",
        "numero_pedido":"42201926110",
        "total":"18,15 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/11225",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Recibo devuelto",
        "fecha_devolucion":"2020-11-24 15:32:36",
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"11225"
      },
      {
        "fecha":"2019/08/05",
        "numero_pedido":"42201925142",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/10251",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"10251"
      },
      {
        "fecha":"2019/08/05",
        "numero_pedido":"42201925141",
        "total":"17,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/10250",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"10250"
      },
      {
        "fecha":"2019/07/05",
        "numero_pedido":"42201924284",
        "total":"17,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/9390",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"9390"
      },
      {
        "fecha":"2019/06/27",
        "numero_pedido":"42201924282",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/8655",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"8655"
      },
      {
        "fecha":"2019/06/27",
        "numero_pedido":"42201924281",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/8654",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"8654"
      },
      {
        "fecha":"2019/06/27",
        "numero_pedido":"42201924280",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/8653",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"8653"
      },
      {
        "fecha":"2019/06/27",
        "numero_pedido":"42201924279",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/8652",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"8652"
      },
      {
        "fecha":"2019/06/27",
        "numero_pedido":"42201924278",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/8651",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"8651"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923527",
        "total":"15,73 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7900",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7900"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923526",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7899",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7899"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923525",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7898",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7898"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923524",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7897",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7897"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923523",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7896",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7896"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923522",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7895",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7895"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923521",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7894",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7894"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923520",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7893",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7893"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923519",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7891",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7891"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923518",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7890",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7890"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923517",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7889",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7889"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923516",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7879",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7879"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923515",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7875",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7875"
      },
      {
        "fecha":"2019/06/03",
        "numero_pedido":"42201923514",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7874",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7874"
      },
      {
        "fecha":"2019/05/31",
        "numero_pedido":"42201923513",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7873",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7873"
      },
      {
        "fecha":"2019/05/31",
        "numero_pedido":"42201923512",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7872",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7872"
      },
      {
        "fecha":"2019/05/31",
        "numero_pedido":"42201923511",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/7871",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"7871"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921599",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5959",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5959"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921568",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5928",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5928"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921567",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5927",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5927"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921566",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5926",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5926"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921565",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5925",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5925"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921564",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5924",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5924"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921563",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5923",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5923"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921562",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5922",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5922"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921561",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5921",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5921"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921560",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5920",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5920"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921559",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5919",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5919"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921558",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5918",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5918"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921557",
        "total":"9,85 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5917",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5917"
      },
      {
        "fecha":"2019/03/07",
        "numero_pedido":"42201921556",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5915",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5915"
      },
      {
        "fecha":"2019/03/06",
        "numero_pedido":"42201921554",
        "total":"0,00 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5914",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5914"
      },
      {
        "fecha":"2019/03/04",
        "numero_pedido":"42201921021",
        "total":"15,54 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/5381",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"5381"
      },
      {
        "fecha":"2019/02/04",
        "numero_pedido":"4220192493",
        "total":"16,48 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/4854",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"4854"
      },
      {
        "fecha":"2019/01/04",
        "numero_pedido":"422019231",
        "total":"15,54 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/4391",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"4391"
      },
      {
        "fecha":"2018/12/04",
        "numero_pedido":"42201823392",
        "total":"15,83 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/3948",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"3948"
      },
      {
        "fecha":"2018/11/02",
        "numero_pedido":"42201823021",
        "total":"16,39 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/3571",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"3571"
      },
      {
        "fecha":"2018/10/02",
        "numero_pedido":"40201819802",
        "total":"47,23 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/3218",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"3218"
      },
      {
        "fecha":"2018/09/03",
        "numero_pedido":"36201816641",
        "total":"11,30 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/2898",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"2898"
      },
      {
        "fecha":"2018/08/03",
        "numero_pedido":"31201813665",
        "total":"81,59 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/2592",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"2592"
      },
      {
        "fecha":"2018/07/02",
        "numero_pedido":"2720189891",
        "total":"46,30 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1961",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1961"
      },
      {
        "fecha":"2018/06/21",
        "numero_pedido":"29201812412",
        "total":"540,10 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/2461",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"2461"
      },
      {
        "fecha":"2018/06/13",
        "numero_pedido":"29201812402",
        "total":"385,19 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/2460",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"2460"
      },
      {
        "fecha":"2018/06/04",
        "numero_pedido":"2320187781",
        "total":"47,93 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1730",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1730"
      },
      {
        "fecha":"2018/05/07",
        "numero_pedido":"1920186331",
        "total":"47,64 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1587",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1587"
      },
      {
        "fecha":"2018/04/06",
        "numero_pedido":"1420185545",
        "total":"424,52 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1500",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1500"
      },
      {
        "fecha":"2018/04/06",
        "numero_pedido":"1420185535",
        "total":"681,82 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1499",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1499"
      },
      {
        "fecha":"2018/04/05",
        "numero_pedido":"1420184374",
        "total":"46,30 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1351",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1351"
      },
      {
        "fecha":"2018/03/04",
        "numero_pedido":"0920182990",
        "total":"46,30 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1239",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1239"
      },
      {
        "fecha":"2018/02/05",
        "numero_pedido":"0620181651",
        "total":"46,30 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/1101",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"1101"
      },
      {
        "fecha":"2018/01/14",
        "numero_pedido":"022018450",
        "total":"45,63 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/975",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"975"
      },
      {
        "fecha":"2017/12/12",
        "numero_pedido":"5020175842",
        "total":"48,90 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/892",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"892"
      },
      {
        "fecha":"2017/11/11",
        "numero_pedido":"4520175276",
        "total":"51,87 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/822",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"822"
      },
      {
        "fecha":"2017/10/15",
        "numero_pedido":"4120174190",
        "total":"55,92 \u20ac",
        "enlace_pdf":"https://mi-tienda.nadunet.es/api/invoice-pdf/708",
        "cliente_id":"635",
        "nombre":"Adri\u00e1n",
        "primer_apellido":"Duque",
        "segundo_apellido":"Gir\u00f3n",
        "estado_pedido":"Pagada",
        "fecha_devolucion":[
            ""
        ],
        "fecha_pago_devolucion":[
            ""
        ],
        "order_id":"708"
      }
    ];
    if (DEBUG_MODE) {
      let ordersByCustomer = this.state.ordersByCustomer;
      if (!ordersByCustomer) ordersByCustomer = [];
      ordersByCustomer[query] = local_bills;

      this.setState({
        ordersLoaded: true,
        // orders: orders,
        ordersByCustomer: ordersByCustomer,
        orders: local_bills,
        isSearchingBills: false,
        isSearchBillResult: true
      });
      return;
    }
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS BY CUSTOMER ID ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let ordersByCustomer = this.state.ordersByCustomer;
        if (!ordersByCustomer) ordersByCustomer = [];
        ordersByCustomer[query] = result.data;

        this.setState({
          ordersLoaded: true,
          // orders: orders,
          ordersByCustomer: ordersByCustomer,
          orders: result.data,
          isSearchingBills: false,
          isSearchBillResult: true
        });
        let options = {
          place: "tr",
          message: "Facturas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
          if (error.response.status === 403 && !DEBUG_MODE) {
            setTimeout((function() {
              this.searchBillsByCustomerID(query, unpaid);
            }).bind(this), 1000);
          }
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getContractsCount() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_CONTRACTS_COUNT, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          contractsCount: result.data
        });
        let options = {
          place: "tr",
          message: "Contador de contratos cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getContractProducts() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_CONTRACT_PRODUCTS, {}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          this.setState({
            contractProducts: result.data.plans
          });
          let options = {
            place: "tr",
            message: "Productos para el contrato cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al cargar los productos para el contrato",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  cleanContract() {
    this.setState({
      contract: null,
      contractToEdit: null,
      contractToSave: null,
      closeContract: false
    });
  }

  setExistingCustomerForTicket(customer_id, customer) {
    if (!customer_id) {
      this.setState({ existingCustomerForTicket: null });
    } else {
      this.setState({
        existingCustomerForTicket: {
          id: parseInt(customer_id),
          customer: customer
        }
      });
    }
  }

  setExistingCustomerForContract(customer_id) {
    this.setState({ existingCustomerForContract: parseInt(customer_id) });
  }

  setProductsForContract(products) {
    // console.log("Setting products for contract", products);
    this.setState({ productsForContract: products });
  }

  setExistingCustomerForHomeVisit(customer_id, customer) {
    if (!customer_id) {
      this.setState({ existingCustomerForHomeVisit: null });
    } else {
      this.setState({
        existingCustomerForHomeVisit: {
          id: parseInt(customer_id),
          customer: customer
        }
      });
    }
  }

  async createContract(contract) {
    if (this.state.isCreatingContract) return;
    this.setState({
      isCreatingContract: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      contract: contract
    };
    return axios
      .post(API + CREATE_CONTRACT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isCreatingContract: false,
          closeContract: true
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Contrato creado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
          return {
            ok: true
          }
        } else {
          let options = {
            place: "tr",
            message: "Error al crear el contrato",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
          return {
            ok: false,
            error: "Error al crear el contrato"
          };
        }
      })
      .catch(error => {
        this.setState({
          isCreatingContract: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        return {
          ok: false,
          error: "Error al crear el contrato"
        };
      });
  }

  resendContract(contract, mobile) {
    if (this.state.isResendingContract) return;
    this.setState({
      isResendingContract: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      contract: contract,
      mobile: mobile
    };
    axios
      .post(API + RESEND_CONTRACT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isResendingContract: false,
          closeContract: false
        });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Contrato reenviado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {
          let options = {
            place: "tr",
            message: "Error al reenviar el contrato",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isResendingContract: false
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401)
            this.cleanSession();
        }
      });
  }

  searchContracts(query) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingContracts) {
      this.setState({
        searchContractsQuery: query,
        isSearchingContracts: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_CONTRACTS_URL + query;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        this.setState({
          contractsLoaded: true,
          contracts: result.data,
          isSearchingContracts: false,
          isSearchContractsResult: true
        });
        let options = {
          place: "tr",
          message: "Contratos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  searchCustomerContracts(query) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingContracts) {
      this.setState({
        searchContractsQuery: query,
        isSearchingContracts: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_CUSTOMER_CONTRACTS_URL + query + "&search2=" + query;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let foundContracts = this.state.customerContracts;
        foundContracts[parseInt(query)] = result.data;
        this.setState({
          contractsLoaded: true,
          customerContracts: foundContracts,
          isSearchingContracts: false,
          isSearchContractsResult: true
        });
        let options = {
          place: "tr",
          message: "Contratos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  searchCustomerTickets(query) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingContracts) {
      this.setState({
        searchTicketsQuery: query,
        isSearchingTickets: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_CUSTOMER_CONTRACTS_URL + query + "&search2=" + query;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let foundContracts = this.state.customerContracts;
        foundContracts[parseInt(query)] = result.data;
        this.setState({
          contractsLoaded: true,
          customerContracts: foundContracts,
          isSearchingContracts: false,
          isSearchContractsResult: true
        });
        let options = {
          place: "tr",
          message: "Contratos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  loadContractTemplates() {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + LOAD_CONTRACT_TEMPLATES_URL;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        this.setState({
          contractTemplatesLoaded: true,
          contractTemplates: result.data
        });
        let options = {
          place: "tr",
          message: "Plantillas de contrato cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        this.setState({
          contractTemplatesLoaded: true
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getContract(contract_id, isToEdit) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    let query = contract_id;
    if (query === undefined) {
      query = "";
    }
    this.setState({
      isEditingContract: isToEdit
    });
    // if (!this.state.isSearchingContracts) {
    //   this.setState({
    //     searchContractsQuery: query,
    //     isSearchingContracts: true
    //   });
    // }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      contract: {
        contract_id: parseInt(contract_id)
      }
    };
    // if (DEBUG_MODE) request.contract.is_god_mode = true;
    let urlToUse = API + GET_CONTRACT_URL /* + query*/;
    axios
      .post(urlToUse, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET CONTRACT ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        try {
          if (result.data.result === "OK") {
            let contract = result.data.contract;
            if (contract.raw_contract) {
              contract.raw_contract = JSON.parse(contract.raw_contract);
            }
            if (contract.products && contract.products.length > 0) {
              contract.products = JSON.parse(contract.products);
            } else {
              contract.products = [];
            }
            if (contract.customer && contract.customer.length > 0) {
              contract.customerData = JSON.parse(contract.customer);
            } else {
              contract.customerData = {};
            }
            contract.contract_id = parseInt(contract_id);
            contract.id = parseInt(contract_id);
            // contract.pin = this.state.pin;
  
            if (isToEdit) {
              this.setState({
                contractToEdit: contract
              });
            } else {
              this.setState({
                contract: contract
              });
            }
          } else {
            let options = {
              place: "tr",
              message: <div dangerouslySetInnerHTML={{ __html: result.data.error }} />,
              type: "danger",
              icon: "now-ui-icons objects_key-25",
              autoDismiss: 3
            };
            this.props.showNotification(options);
          }
        } catch (error) {
          console.log("############ INTENTAR PASEAR CONTRATO ###############");
          console.log(error);
        }
        let options = {
          place: "tr",
          message: "Contrato cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  // Save contract (customer data) 
  async saveContract(contract) {
    if (this.state.isSavingContract) return;
    /* ////console.log("################## GET USERNAME ################"); */

    this.setState({
      isSavingContract: true,
      isSigningContract: contract.signature || false
    });

    let request = {
      contract: {
        contract_id: this.state.contract.contract_id
      }
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    Object.keys(contract).map(current => {
      request.contract[current] = contract[current];
    });
    /* ////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + SAVE_CONTRACT, request, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          isSavingContract: false,
          isSigningContract: false
        });
        if (result.data.result === "OK") {
          // console.log("respuesta save OK");
          let options = {
            place: "tr",
            message: "Contrato " + (contract.signature ? "firmado" : "guardado"),
            type: "primary",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
          this.setState({
            isContractOpened: false,
            closeContract: true
          });
        } else {
          let options = {
            place: "tr",
            message: "No se pudo guardar el contrato",
            type: "danger",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch((error) => {
        this.setState({
          isLoadingContract: false,
          isSigningContract: false
        });
        /* ////console.log(error.config); */
      });
  }

  async editContractAsync(contract) {
    // console.log("Empezando ruleta...");
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      contract: contract
    };
    return axios
      .post(API + EDIT_CONTRACT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => result.data)
      .catch(error => {
        console.log("Error al editar el contrato");
      });
  }
  // Save contract (product data) 
  editContract(contract) {
    if (this.state.isSavingContract) return;
    /* ////console.log("################## GET USERNAME ################"); */

    this.setState({
      isSavingContract: true
      // isSigningContract: contract.signature || false
    });

    let request = {
      contract: contract
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    /* ////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + EDIT_CONTRACT, request, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          isSavingContract: false
          // isSigningContract: false
        });
        if (result.data.result === "OK") {
          // console.log("respuesta save OK");
          let options = {
            place: "tr",
            message: "Contrato guardado",
            type: "primary",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
          this.setState({
            isContractOpened: false,
            closeContract: true
          });
        } else {
          let options = {
            place: "tr",
            message: "No se pudo guardar el contrato",
            type: "danger",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch((error) => {
        this.setState({
          isLoadingContract: false
          // isSigningContract: false
        });
        /* ////console.log(error.config); */
      });
  }

  // Save contract (product data) 
  deleteContract(contract) {
    if (this.state.isSavingContract) return;
    /* ////console.log("################## GET USERNAME ################"); */

    this.setState({
      isSavingContract: true
      // isSigningContract: contract.signature || false
    });

    let request = {
      contract: contract
    };
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    /* ////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + DELETE_CONTRACT, request, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          isSavingContract: false
          // isSigningContract: false
        });
        if (result.data.result === "OK") {
          // console.log("respuesta save OK");
          this.loadContractTemplates();
          let options = {
            place: "tr",
            message: "Plantilla eliminada",
            type: "primary",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
          this.setState({
            isContractOpened: false,
            closeContract: true
          });
        } else {
          let options = {
            place: "tr",
            message: result.data.error,
            type: "danger",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch((error) => {
        this.setState({
          isLoadingContract: false
          // isSigningContract: false
        });
        let options = {
          place: "tr",
          message: "Error en el servidor",
          type: "danger",
          icon: "now-ui-icons files_paper",
          autoDismiss: 3
        };
        this.showNotification(options);
        /* ////console.log(error.config); */
      });
  }

  closeContract(contractToSave) {
    if (contractToSave) {
      this.saveContract(contractToSave);
    } else {
      this.setState({ isContractOpened: false });
    }
  }

  parseDate(date) {
    try {
      let result = "";
      if (date && date.length > 0) {
        result = date.replace("<span class=\"date-display-single\">", "").replace("</span>", "");
        // result = result.split("-")[1].replace(" ", "");
      }
      return result;
    } catch (error) {
      return date;
    }
  }

  searchHomeVisits(query, min_date, max_date) {
    // console.log("################## searchHomeVisits ################");
    // console.log("query", query);
    // console.log("min_date", min_date);
    // console.log("max_date", max_date);
    if (query === undefined) {
      query = "";
    }
    if (!this.state.isSearchingHomeVisits) {
      this.setState({
        searchHomeVisitsQuery: query,
        isSearchingHomeVisits: true
      });
    }
    if (min_date || max_date) {
      this.setState({
        date_day_min: min_date,
        date_day_max: max_date
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + SEARCH_HOME_VISITS_URL;
    if (query && query !== "") urlToUse = urlToUse + "?search=" + query;

    if (!min_date) {
      min_date = moment();
    } else {
      min_date = moment(min_date).format('YYYY-MM-DD');
    }
    if (min_date) urlToUse = urlToUse + (!urlToUse.includes("?") ? "?" : "&") + "args[0]=" + min_date;

    if (!max_date) {
      max_date = moment().add(7, "days");
    } else {
      max_date = moment(max_date).format('YYYY-MM-DD');
    }
    if (max_date) urlToUse = urlToUse + "--" + max_date;
    if (this.isTechnician()) urlToUse = urlToUse + "&technician=" + this.state.user.uid;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA searchHomeVisits ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let homeVisits = this.state.homeVisits;
        if (!homeVisits) homeVisits = {};
        homeVisits.list = result.data;

        const groupByDateDay = groupBy('visit_day_relative');
        if (homeVisits.list && homeVisits.list.length > 0) {
          homeVisits.list = homeVisits.list.map(homeVisit => {
            Object.keys(homeVisit).map(key => {
              // console.log("Current key to check");
              // console.log(key);
              if (key.includes("date")) {
                homeVisit[key] = this.parseDate(homeVisit[key]);
              }
            });
            homeVisit.visit_day_relative = moment(homeVisit.visit_date_day, "D/MM/YYYY").calendar();
            if (homeVisit.visit_state) {
              homeVisit.visit_status = homeVisit.visit_state;
              homeVisit.visit_status_name = homeVisit.visit_state_name;
            } else {
              homeVisit.visit_state = homeVisit.visit_status;
              homeVisit.visit_state_name = homeVisit.visit_status_name;
            }
            // console.log("Current home visit preparing");
            // console.log(homeVisit);
            if (homeVisit.visit_day_relative && homeVisit.visit_day_relative.length > 0) {
              let stripIndex = homeVisit.visit_day_relative.indexOf(" a la");
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.substring(0, stripIndex);
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.charAt(0).toUpperCase() + homeVisit.visit_day_relative.slice(1);
            }
            if (!homeVisit.visit_day_relative || homeVisit.visit_day_relative === "") {
              homeVisit.visit_day_relative = moment(homeVisit.visit_date_day, "D/MM/YYYY").fromNow();
            }
            if (this.isBillingDepartment() && homeVisit.billing_status.tid) {
              if (parseInt(homeVisit.billing_status.tid) === 375) {
                homeVisit.opacity = "transparente";
              } else if(parseInt(homeVisit.billing_status.tid) === 377) {
                homeVisit.opacity = "colorido";
              }
            } else {
              homeVisit.opacity = "solido";
            }
            homeVisit.assigned_technician = JSON.parse(homeVisit.assigned_technician);
            homeVisit.working_technician = JSON.parse(homeVisit.working_technician);
            homeVisit.viewed_by = JSON.parse(homeVisit.viewed_by);
            return homeVisit;
          });
          homeVisits.grouped = groupByDateDay(homeVisits.list);

          homeVisits.calendar = homeVisits.list.map(homeVisit => {
            let dateComponents = homeVisit.visit_date_day.split("/");
            let day = dateComponents[0];
            if (day.length < 2) day = `0${day}`;
            let month = dateComponents[1];
            if (month.length < 2) month = `0${month}`;
            let year = dateComponents[2];
            if (year.length < 2) year = `0${year}`;
            let hourComponents = homeVisit.visit_date_hour.split(":");
            let hour = hourComponents[0];
            if (hour.length < 2) hour = `0${hour}`;
            let minutes = hourComponents[1];
            if (minutes.length < 2) minutes = `0${minutes}`;
            
            // let start = new Date(year.toString() + "-" + month.toString() + "-" + day.toString() + "T" + hour.toString() + ":" + minutes.toString());
            let start_string = `${year}-${month}-${day}T${hour}:${minutes}`;
            // console.log("Start_string:", start_string);
            let start = new Date(start_string);
            let end = new Date(start_string);
            // console.log("homeVisit parseando duration", homeVisit);
            let duration_hours = parseFloat(homeVisit.expected_duration);
            if (!duration_hours) duration_hours = 2;
            end.setTime(end.getTime() + duration_hours * 60 * 60 * 1000);
            return {
              id: homeVisit.id,
              calendarId: (homeVisit.active_customer_renewal === "1")? 7635492 /* Línea verde a la izquierda*/ : parseInt(homeVisit.calendar),
              title: homeVisit.title,
              category: "time",
              dueDateClass: "",
              start: start,
              end: end,
              bgColor: "#ecf0f1",
              dragBgColor: "#ecf0f1",
              homeVisit: homeVisit,
              location: homeVisit.visit_address,
              body: homeVisit.description
            };
          });
          console.log("homeVisits calendar", homeVisits.calendar);
          const groupById = groupBy('id');
          const groupedHomeVisits = groupById(homeVisits.list);
          homeVisits.byIdForCalendar = groupedHomeVisits;
        }
        // console.log("################## HOME VISITS AFTER CLEAN ################");
        // console.log(homeVisits);

        this.setState({
          homeVisitsLoaded: true,
          homeVisits: homeVisits,
          isSearchingHomeVisits: false,
          isSearchHomeVisitsResult: true,
          lastLoadedCalendar: moment().valueOf()
        });
        let options = {
          place: "tr",
          message: "Visitas a domicilio cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        console.log("################## HOME VISITS ERROR ################");
        console.log("error", error);
        this.setState({
          homeVisitsLoaded: true,
          homeVisits: [],
          isSearchingHomeVisits: false,
          isSearchHomeVisitsResult: true
        });
        if (error.response){
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getHomeVisitsLog(related_id) {
    if (!this.state.isSearchingHomeVisitsLog) {
      this.setState({
        isSearchingHomeVisitsLog: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let body = {};
    if (related_id) body = { related_id: related_id };
    let urlToUse = API + GET_HOME_VISITS_LOG;
    axios
      .post(urlToUse, body, queryHeaders, { withCredentials: true })
      .then(result => {

        let log = this.state.log;
        if (!log) {
          log = {};
          log.homeVisits = [];
        }
        if (!related_id) related_id = "all";
        log.homeVisits[related_id] = result.data.log;

        this.setState({
          log: log,
          isSearchingHomeVisitsLog: false,
        });
        let options = {
          place: "tr",
          message: "Log de visitas a domicilio cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        // console.log("################## HOME VISITS ERROR ################");
        // console.log("error", error);
        this.setState({
          isSearchingHomeVisitsLog: false,
        });
        // if (error.response){
        //   if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        // }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCustomerHomeVisits(customer) {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_CUSTOMER_HOME_VISITS_URL + "?search=" + customer;

    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let homeVisits = this.state.homeVisits;
        if (!homeVisits) homeVisits = {};
        let auxHomeVisits = result.data;

        const groupByCustomer = groupBy('related_customer_id');
        if (auxHomeVisits && auxHomeVisits.length > 0) {
          auxHomeVisits = auxHomeVisits.map(homeVisit => {
            homeVisit.related_customer_id = parseInt(homeVisit.related_customer_id);
            Object.keys(homeVisit).map(key => {
              // console.log("Current key to check");
              // console.log(key);
              if (key.includes("date")) {
                homeVisit[key] = this.parseDate(homeVisit[key]);
              }
            });
            homeVisit.visit_day_relative = moment(homeVisit.visit_date_day, "D/MM/YYYY").calendar();
            // console.log("Current home visit preparing");
            // console.log(homeVisit);
            if (homeVisit.visit_day_relative && homeVisit.visit_day_relative.length > 0) {
              let stripIndex = homeVisit.visit_day_relative.indexOf(" a la");
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.substring(0, stripIndex);
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.charAt(0).toUpperCase() + homeVisit.visit_day_relative.slice(1);
            }
            if (!homeVisit.visit_day_relative || homeVisit.visit_day_relative === "") {
              homeVisit.visit_day_relative = moment(homeVisit.visit_date_day, "D/MM/YYYY").fromNow();
            }
            homeVisit.assigned_technician = JSON.parse(homeVisit.assigned_technician);
            homeVisit.working_technician = JSON.parse(homeVisit.working_technician);
            return homeVisit;
          });
        }
        auxHomeVisits = groupByCustomer(auxHomeVisits);
        homeVisits.byCustomer = auxHomeVisits;
        // console.log("################## HOME VISITS AFTER CLEAN ################");
        // console.log(homeVisits);

        this.setState({
          homeVisits: homeVisits
        });
        let options = {
          place: "tr",
          message: "Visitas a domicilio cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response){
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentHomeVisit() {
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_CURRENT_HOME_VISIT_URL;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        // const groupByID = groupBy('cliente_id');
        // const groupByOrderID = groupBy('order_id');
        // const groupedByCliente_id = groupByID(result.data);
        // const groupedByOrder_id = groupByOrderID(result.data);
        // let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);

        let homeVisits = this.state.homeVisits;
        if (!homeVisits) homeVisits = {};
        if (result.data && result.data.length > 0) {
          let homeVisit = result.data[0];
          // console.log("Current home visit response");
          // console.log(result);
          Object.keys(homeVisit).map(key => {
            // console.log("Current key to check");
            // console.log(key);
            if (key.includes("date")) {
              homeVisit[key] = this.parseDate(homeVisit[key]);
            }
            homeVisit.visit_day_relative = moment(homeVisit.visit_date_day, "D/MM/YYYY").calendar();
            if (homeVisit.visit_day_relative && homeVisit.visit_day_relative.length > 0) {
              let stripIndex = homeVisit.visit_day_relative.indexOf(" a la");
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.substring(0, stripIndex);
              homeVisit.visit_day_relative = homeVisit.visit_day_relative.charAt(0).toUpperCase() + homeVisit.visit_day_relative.slice(1);
            }
          });
          homeVisit.assigned_technician = JSON.parse(homeVisit.assigned_technician);
          homeVisit.working_technician = JSON.parse(homeVisit.working_technician);
          homeVisits.current = homeVisit;
        } else {
          homeVisits.current = null;
        }

        this.setState({
          homeVisits: homeVisits
        });
        let options = {
          place: "tr",
          message: "Visita a domicilio actual cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  addHomeVisitComment(comment) {
    this.setState({ isCreatingHomeVisitComment: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      comment: comment
    };
    axios
      .post(API + ADD_HOME_VISIT_COMMENT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(comment.home_visit_id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits
          });
          let options = {
            place: "tr",
            message: "Comentario añadido a la visita a domicilio",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al añadir el comentario a la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
        this.setState({ isCreatingHomeVisitComment: false });
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        this.setState({ isCreatingHomeVisitComment: false });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  addHomeVisitPhoto(photo, isMultiple) {
    if (!isMultiple) {
      photo = {
        home_visit_id: photo.home_visit_id,
        photos: [photo.photo]
      };
    }
    this.setState({ isCreatingHomeVisitPhoto: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      photo: photo
    };
    axios
      .post(API + ADD_HOME_VISIT_PHOTO, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(photo.home_visit_id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits
          });
          let options = {
            place: "tr",
            message: "Foto añadida a la visita a domicilio",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al añadir la foto a la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
        this.setState({ isCreatingHomeVisitPhoto: false });
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        this.setState({ isCreatingHomeVisitPhoto: false });
        /* //////console.log("################## ERROR ################"); */
      });
  }
  
  editHomeVisitPhoto(photo) {
    this.setState({ isEditingHomeVisitPhoto: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      photo: photo
    };
    axios
      .post(API + EDIT_HOME_VISIT_PHOTO, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(photo.home_visit_id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits
          });
          let options = {
            place: "tr",
            message: "Foto editada de la visita a domicilio",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al editar la foto de la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
        this.setState({ isEditingHomeVisitPhoto: false });
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        this.setState({ isEditingHomeVisitPhoto: false });
        /* //////console.log("################## ERROR ################"); */
      });
  }
  
  deleteHomeVisitPhoto(photo) {
    this.setState({ isDeletingHomeVisitPhoto: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      photo: photo
    };
    axios
      .post(API + DELETE_HOME_VISIT_PHOTO, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(photo.home_visit_id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits
          });
          let options = {
            place: "tr",
            message: "Foto eliminada de la visita a domicilio",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al eliminar la foto de la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
        this.setState({ isDeletingHomeVisitPhoto: false });
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        this.setState({ isDeletingHomeVisitPhoto: false });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  createHomeVisitFromCalendar(homeVisit) {
    let preloadedData = null;
    if (homeVisit) {
      // console.log("DATOS DESDE CALENDARIO", homeVisit);
      preloadedData = {
        title: homeVisit.title,
        date: moment(homeVisit.start.getTime()),
        address: homeVisit.location
      };
      // console.log("DATOS POST TRATAMIENTO", preloadedData);
    }
    this.setState({ homeVisitFromCalendar: preloadedData});
  }

  getHomeVisit(id) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_HOME_VISIT, {id: parseInt(id)}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(id)] = [];
          homeVisits.byId[parseInt(id)][0] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits
          });
          let options = {
            place: "tr",
            message: "Visita a domicilio cargada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al cargar la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  viewHomeVisit(id) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + VIEW_HOME_VISIT, {id: parseInt(id)}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
          };
          if (result.data.new_viewer) {
            options = {
              place: "tr",
              message: "Visita a domicilio marcada como vista",
              type: "primary",
              icon: "now-ui-icons ui-1_check",
              autoDismiss: 3
            };
          } else {
            options = {
              place: "tr",
              message: "Ya habías visto esta visita",
              type: "info",
              icon: "now-ui-icons ui-1_check",
              autoDismiss: 3
            };
          }
          /*if (this.state.debug)*/ this.showNotification(options);
        } else {
          let options = {
            place: "tr",
            message: "Error al marcar la visita a domicilio como vista: " + result.data.error[0],
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
          console.error("Error ver visita", result.data);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  startHomeVisit(id) {
    if (this.state.isStartingHomeVisit) return;
    this.setState({ isStartingHomeVisit: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + START_HOME_VISIT, {id: parseInt(id)}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits,
            isStartingHomeVisit: false
          });
          let options = {
            place: "tr",
            message: "Visita a domicilio cargada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            isStartingHomeVisit: false
          });
          let options = {
            place: "tr",
            message: "Error al cargar la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isStartingHomeVisit: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  changeHomeVisitBillingStatus(id) {
    if (this.state.isChangingHomeVisitBillingStatus) return;
    this.setState({ isChangingHomeVisitBillingStatus: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + CHANGE_HOME_VISIT_BILLING_STATUS, {id: parseInt(id)}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          homeVisits.byId[parseInt(id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits,
            isChangingHomeVisitBillingStatus: false
          });
          let options = {
            place: "tr",
            message: "Visita a domicilio cargada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            isChangingHomeVisitBillingStatus: false
          });
          let options = {
            place: "tr",
            message: "Error al cargar la visita a domicilio",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({
          isChangingHomeVisitBillingStatus: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  deleteHomeVisit(id) {
    // if (this.state.isStartingHomeVisit) return;
    // this.setState({ isStartingHomeVisit: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + DELETE_HOME_VISIT, { id: parseInt(id) }, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Cita eliminada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        } else {
          let options = {
            place: "tr",
            message: "Error al eliminar la cita",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getCashRegistersList() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_CASH_REGISTERS_LIST, {}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          this.setState({
            cashRegisters: result.data.cash_registers,
            cashRegistersLoaded: true
          });
          let options = {
            place: "tr",
            message: "Cajas registradoras cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al cargar las cajas registradoras",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getTasks(force) {
    // if (DEBUG_MODE) return;
    if (!force) {
      if (this.state.isListingTasks) return;
      let newUpdateDate = moment();
      // console.log("lastTaskUpdate", lastTasksLoadedOnUpdate);
      // console.log("newTaskUpdate", newUpdateDate);
      let timeDiff = newUpdateDate.diff(lastTasksLoadedOnUpdate);
      // console.log("Diff tiempo tasks", timeDiff);
      if (timeDiff < 3000) return;
      lastTasksLoadedOnUpdate = newUpdateDate;
    }
    this.setState({ isListingTasks: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_TASKS_LIST, {}, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({ isListingTasks: false });
        if (result.data.result === "OK") {
          this.setState({
            tasksList: result.data.tasks
          });
          let options = {
            place: "tr",
            message: "Tareas cargadas",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
      })
      .catch(error => {
        this.setState({ isListingTasks: false });
        // if (error.response) {
        //   if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        // }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  startTask(taskID) {
    if (this.state.startingTask[taskID]) return;
    let startingTask = this.state.startingTask;
    startingTask[taskID] = true;
    this.setState({startingTask: startingTask});

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      task_id: taskID
    };
    axios
      .post(API + START_TASK, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        startingTask = this.state.startingTask;
        startingTask[taskID] = false;
        this.setState({startingTask: startingTask});
        if (result.data.result === "OK") {
          let tasks = this.state.tasksList;
          tasks[taskID] = result.data.task;
          this.setState({ tasksList: tasks });
        }
      })
      .catch(error => {
        startingTask = this.state.startingTask;
        startingTask[taskID] = false;
        this.setState({startingTask: startingTask});
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  pauseTask(taskID) {
    if (this.state.pausingTask[taskID]) return;
    let pausingTask = this.state.pausingTask;
    pausingTask[taskID] = true;
    this.setState({pausingTask: pausingTask});

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      task_id: taskID
    };
    axios
      .post(API + PAUSE_TASK, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        pausingTask = this.state.pausingTask;
        pausingTask[taskID] = false;
        this.setState({pausingTask: pausingTask});
        if (result.data.result === "OK") {
          let tasks = this.state.tasksList;
          tasks[taskID] = result.data.task;
          this.setState({ tasksList: tasks });
        }
      })
      .catch(error => {
        pausingTask = this.state.pausingTask;
        pausingTask[taskID] = false;
        this.setState({pausingTask: pausingTask});
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  finishTask(taskID) {
    if (this.state.finishingTask[taskID]) return;
    let finishingTask = this.state.finishingTask;
    finishingTask[taskID] = true;
    this.setState({finishingTask: finishingTask});

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      task_id: taskID
    };
    axios
      .post(API + FINISH_TASK, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        finishingTask = this.state.finishingTask;
        finishingTask[taskID] = false;
        this.setState({finishingTask: finishingTask});
        if (result.data.result === "OK") {
          let tasks = this.state.tasksList;
          tasks[taskID] = result.data.task;
          this.setState({ tasksList: tasks });
        }
      })
      .catch(error => {
        finishingTask = this.state.finishingTask;
        finishingTask[taskID] = false;
        this.setState({finishingTask: finishingTask});
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  createTask(task) {
    if (this.state.isCreatingTask) return;
    this.setState({isCreatingTask: true});

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      new_task: task
    };
    // console.log("new_task", request);
    // return;
    axios
      .post(API + CREATE_TASK, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({isCreatingTask: false});
        
        if (result.data.result === "OK") {
          this.getTasks(true);
        }
        // this.getTasks();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        this.setState({isCreatingTask: false});        
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  createCashRegistry(registry) {
    if (this.state.creatingCashRegistry) return;
    this.setState({
      creatingCashRegistry: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    registry.amount = this.formatPrice(parseFloat(registry.amount).toString());
    let request = {
      registry: registry
    };
    axios
      .post(API + CREATE_CASH_REGISTRY, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          this.setState({
            creatingCashRegistry: false
          });
          let options = {
            place: "tr",
            message: "Registro creado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
          this.getCashRegistersList();
        } else {
          this.setState({
            contractProducts: []
          });
          let options = {
            place: "tr",
            message: "Error al crear el registro",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        }
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getTodayDataUsage(query) {
    // console.log("################## GET TODAY USAGE (" + query + ") ################");
    query = parseInt(query);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      mobile: query
    };
    axios
      .post(API + GET_TODAY_DATA_USAGE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // console.log("################## RESPUESTA GET TODAY USAGE (" + query + ") ################");
        // // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        let auxTodayUsage = this.state.todayDataUsage;
        auxTodayUsage[query] = result.data;

        this.setState({
          todayDataUsage: auxTodayUsage
        });
        let options = {
          place: "tr",
          message: "Uso de datos diario cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getOrders(query) {
    /* //////console.log("################## GET ORDERS ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (query === "FIRST-LOAD") {
      this.setState({
        ordersLoaded: true,
        orders: []
      });
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_ORDERS_URL, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        const groupByID = groupBy('cliente_id');
        const groupByOrderID = groupBy('order_id');
        const groupedByCliente_id = groupByID(result.data);
        const groupedByOrder_id = groupByOrderID(result.data);
        let customersToSearch = Object.keys(groupedByCliente_id);
        // console.log("################## CUSTOMERS ORDERS KEYS ################");
        // console.log(customersToSearch);
        this.searchCustomer(customersToSearch, true);

        this.setState({
          ordersLoaded: true,
          orders: result.data
        });
        let options = {
          place: "tr",
          message: "Facturas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // Comentado al hacer la llamada al abrir los conceptos de la factura en lugar de traerlos todos de golpe
        // this.getOrdersArticles(Object.keys(groupedByOrder_id), true);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  cleanArray(array) {
    return array.filter(function (el) {
      return el != null;
    });
  }

  searchBulkCustomer(ids) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      ids: ids
    };
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + GET_BULK_CUSTOMERS, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {

        // <Extracción info clientes> --------------------------------
        let resultClients = result.data.clients;
        const groupByID = groupBy("id");
        const groupedByID = groupByID(resultClients);
        const groupByDNI = groupBy("nif");
        const groupedByDNI = groupByDNI(resultClients);
        let customersResultAux = this.state.customers;
        Object.keys(groupedByID).map(function(k) {
          customersResultAux[k] = groupedByID[k];
        });

        let resultMobiles = result.data.mobiles;
        const groupByUID = groupBy("cliente_id");
        const groupByNumero = groupBy("numero");
        // </Extracción info clientes> --------------------------------

        // <Extracción info móviles> --------------------------------
        let resultAux = resultMobiles;
        const groupedExistingNumero = this.state.customersMobilesRaw.length > 0 ? groupByNumero(this.state.customersMobilesRaw) : [];

        resultAux = this.cleanArray(resultAux);

        const groupedResult = resultMobiles.length > 0 ? groupByUID(resultAux) : [];
        const groupedResultNumero = resultMobiles.length > 0 ? groupByNumero(resultAux) : [];
        let auxCustomersMobiles = this.state.customersMobiles;
        Object.keys(groupedResult).map(function(k) {
          auxCustomersMobiles[k] = groupedResult[k];
        });

        let auxRawMobiles = this.state.customersMobilesRaw.concat(resultAux);
        // </Extracción info móviles> --------------------------------

        // <Extracción info CDR> --------------------------------
        const groupByOrigin = groupBy("origen");
        const groupedResultCDR = groupByOrigin(result.data.cdr);
        let auxCDR = this.state.mobilesCDR;
        
        const groupByRegistryType = groupBy("tipo_consumo");

        let currentArray = Object.keys(groupedResultNumero);
        Object.keys(currentArray).map(function(k) {
          let currentMobile = currentArray[k];
          let currentMobileCDR = [];
          if (currentMobile in groupedResultCDR) {
            let groupedByType = groupByRegistryType(groupedResultCDR[currentMobile]);
            currentMobileCDR = groupedByType;
          }
          auxCDR[currentMobile] = currentMobileCDR;
        });
        // </Extracción info CDR> --------------------------------
        

        this.setState({
          mobilesCDR: auxCDR,
          mobilesCDRLoaded: true,
          customersMobilesRaw: auxRawMobiles,
          customersMobiles: auxCustomersMobiles,
          customersMobilesCount: auxRawMobiles.length,
          customersMobilesLoaded: true,
          customersLoaded: true,
          customers: customersResultAux
        });
        // console.log("################## Resultado get bulk customers (" + ids + ") ################");
        // console.log(result.data);
        // console.log("################## Estado después de setState de get bulk customers (" + ids + ") ################");
        // console.log(this.state);
        // this.getCustomersMobiles(Object.keys(groupedByDNI), true, null, null);
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al cargar clientes de manera masiva",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  searchCustomer(query, bulkOperation, prevIndex, isSearch, isGetUser) {
    if (bulkOperation) {
      this.searchBulkCustomer(query);
      return;
    }
    // console.log("################## GET CUSTOMERS ################");
    // console.log(query);

    if (query === "FIRST-LOAD") {
      let customers = this.state.customers;
      if (!customers) customers = [];
      this.setState({
        customersLoaded: true,
        customers: customers
      });
      return;
    }

    if (bulkOperation && !prevIndex) {
      query = query.map((item, key) => {
        if (!(item in this.state.customers)) return item;
      });
      query = this.cleanArray(query);
      if (query.length == 0) return;
    }
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);

    let currentIndex = prevIndex ? prevIndex : 0;
    let endIndex = 0;
    let arrayQuery = query;
    if (bulkOperation) {
      endIndex = (query.length > (currentIndex + 5))? currentIndex + 4 : query.length - 1;
      query = query.slice(currentIndex, endIndex + 1).join("+");
    }
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    //if (saveForBulk) {
      //this.setState({
      //  searchBulkCustomer: (this.state.searchBulkCustomer != null)? this.state.searchBulkCustomer + "+" + query : query
      //});
     // return;
    //}
    if (isSearch && this.state.isSearchingCustomer) {
      return;
    }
    if (this.state.customersLoaded && !this.state.customersMobilesLoaded) {
      //this.getCustomersMobiles();
    }
    if (query === undefined) {
      query = "";
    }
    if (isSearch & !this.state.isSearchingCustomer) {
      this.setState({
        searchCustomerQuery: query,
        isSearchingCustomer: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_SEARCH_CUSTOMER + query;
    if (isSearch) {
      urlToUse = API + GET_SEARCH_CUSTOMER_FILTER + query;
    }
    let externalUsers = [
      "Oniti"
    ];
    if (externalUsers.indexOf(this.state.user.name) > -1) {
      urlToUse += " Oniti";
    } 
    if (isGetUser) {
      urlToUse = API + GET_CUSTOMER + query;
    }
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET CUSTOMERS ################");
        //console.log(query);
        //console.log(result);
        const groupByID = groupBy("id");
        const groupedByID = groupByID(result.data);
        const groupByDNI = groupBy("nif");
        const groupedByDNI = groupByDNI(result.data);
        let customersResultAux = this.state.customers;
        Object.keys(groupedByID).map(function(k) {
          customersResultAux[k] = groupedByID[k];
        });
        // this.searchBulkCustomer(Object.keys(groupedByID));

        //console.log(groupedByID);
        if (isSearch) {
          let auxSearchResult = this.state.customerSearchResult;
          auxSearchResult[query] = groupedByID;
          this.setState({
            customersLoaded: true,
            customers: customersResultAux,
            isSearchCustomerResult: true,
            isSearchingCustomer: false,
            customerSearchResult: auxSearchResult
          });
        } else {
          this.setState({
            customersLoaded: bulkOperation ? this.state.customersLoaded : true,
            customers: customersResultAux
          });
        }
        if (isGetUser) {
          let auxUpdate = this.state.last_customer_update;
          auxUpdate[query] = Date.now();
          this.setState({
            last_customer_update: auxUpdate
          });
        }
        let options = {
          place: "tr",
          message: "Clientes cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (bulkOperation && arrayQuery.length > (endIndex + 1)) this.searchCustomer(arrayQuery, true, endIndex + 1);
        this.getCustomersMobiles(Object.keys(groupedByDNI), true, null, null, true);
        if (this.state.debug) this.showNotification(options);

        if (isGetUser && query in this.state.settingCustomerInternet) {
          // console.log("################## RESPUESTA GET CUSTOMER ################");
          // console.log(result);
          // console.log("################## URL UTILIZADA GET CUSTOMER ################");
          // console.log(urlToUse);
          let settingAux = this.state.settingCustomerInternet;
          settingAux[query] = false;
          this.setState({
            settingCustomerInternet: settingAux
          });
        }
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {

        if (isGetUser && query in this.state.settingCustomerInternet) {
          let settingAux = this.state.settingCustomerInternet;
          settingAux[query] = false;
          this.setState({
            settingCustomerInternet: settingAux
          });
        }
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  searchCustomerReference(query) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_SEARCH_CUSTOMER_FILTER + query;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET CUSTOMERS ################");
        //console.log(query);
        //console.log(result);
        const groupByID = groupBy("id");
        const groupedByID = groupByID(result.data);
        // const groupByDNI = groupBy("nif");
        // const groupedByDNI = groupByDNI(result.data);
        // let customersResultAux = this.state.customers;
        // Object.keys(groupedByID).map(function(k) {
        //   customersResultAux[k] = groupedByID[k];
        // });
        // this.searchBulkCustomer(Object.keys(groupedByID));

        //console.log(groupedByID);
        let auxSearchResult = this.state.customerSearchReference;
        if (!result.data || (result.data && result.data.length === 0)) {
          result.data = [];
        }
        auxSearchResult[query] = {
          customers: groupedByID,
          references: result.data.map(customer => {
            return {
                label: customer.nombre_completo + " " + customer.primer_apellido + " " + customer.segundo_apellido + " (" + customer.nif + ") " + customer.localidad,
                value: customer.id
            };
          })
        };
        console.log("################## RESULTADO BUSCAR REFERENCIAS ################");
        console.log(auxSearchResult);
        this.setState({
          customerSearchReference: auxSearchResult
        });
        let options = {
          place: "tr",
          message: "Clientes cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getTechniciansList() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    this.setState({
      isGettingTechnicians: true
    });
    let urlToUse = API + GET_TECHNICIANS_LIST;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          techniciansList: result.data,
          isGettingTechnicians: false
        });
        let options = {
          place: "tr",
          message: "Técnicos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
          this.setState({
            isGettingTechnicians: false
          });
        }
      });
  }

  getCalendarsList() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    this.setState({
      isGettingTechnicians: true
    });
    let urlToUse = API + GET_CALENDARS_LIST;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          calendarsList: result.data
        });
        let options = {
          place: "tr",
          message: "Calendarios cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        this.setState({
          isGettingTechnicians: false
        });
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getHomeVisitTypesList() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_HOME_VISIT_TYPES_LIST;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          homeVisitTypesList: result.data
        });
        let options = {
          place: "tr",
          message: "Técnicos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getHomeVisitFinishReasonList() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_HOME_VISIT_FINISH_REASON_LIST;
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          homeVisitFinishReasonList: result.data
        });
        let options = {
          place: "tr",
          message: "Técnicos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  createHomeVisit(homeVisit) {
    this.setState({
      isCreatingHomeVisit: true,
      isErrorCreatingHomeVisit: false
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      home_visit: homeVisit
    };
    axios
      .post(API + CREATE_HOME_VISIT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          this.setState({
            isCreatingHomeVisit: false,
            isErrorCreatingHomeVisit: false
          });
          let options = {
            place: "tr",
            message: "Cita creada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          this.searchHomeVisits();
        } else {
          this.setState({
            isCreatingHomeVisit: false,
            isErrorCreatingHomeVisit: true
          });
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo crear la cita: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        this.setState({
          isCreatingHomeVisit: false,
          isErrorCreatingHomeVisit: true
        });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  editHomeVisit(homeVisit) {
    this.setState({
      isEditingHomeVisit: true,
      isErrorEditingHomeVisit: false
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      home_visit: homeVisit
    };
    axios
      .post(API + EDIT_HOME_VISIT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          // this.props.state.homeVisits && this.props.state.homeVisits.byId
          let aux = this.state.homeVisits;
          if (!homeVisit) aux = {};
          aux.byId = [];
          aux.byId[homeVisit.id] = [result.data.homeVisit];
          this.setState({
            homeVisits: aux,
            isEditingHomeVisit: false,
            isErrorEditingHomeVisit: false
          });
          let options = {
            place: "tr",
            message: "Cita editada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          this.searchHomeVisits();
        } else {
          this.setState({
            isEditingHomeVisit: false,
            isErrorEditingHomeVisit: true
          });
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo editar la cita: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        this.setState({
          isEditingHomeVisit: false,
          isErrorEditingHomeVisit: true
        });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  editHomeVisitDate(homeVisit, date_min, date_max) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      home_visit: homeVisit
    };
    axios
      .post(API + EDIT_HOME_VISIT_DATE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Cita modificada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // this.searchHomeVisits();
        } else {
          this.searchHomeVisits("", date_min, date_max);
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo modificar la cita: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        /* //////console.log("################## ERROR ################"); */
      });
  }

  finishHomeVisit(homeVisit) {
    this.setState({
      isFinishingHomeVisit: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      home_visit: homeVisit
    };
    axios
      .post(API + FINISH_HOME_VISIT, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        if (result.data.result === "OK") {
          let homeVisits = this.state.homeVisits;
          if (!homeVisits) homeVisits = {};
          if (!homeVisits.byId) homeVisits.byId = [];
          let id = homeVisit.home_visit_id;
          homeVisits.byId[parseInt(id)] = result.data.home_visit.clean;
          this.setState({
            homeVisits: homeVisits,
            isFinishingHomeVisit: false
          });
          let options = {
            place: "tr",
            message: "Cita firmada",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // this.searchHomeVisits();
        } else {
          this.setState({
            isFinishingHomeVisit: false
          });
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo firmar la cita: </span>
              <ul>{errorContentList}</ul>
            </div>;
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        this.setState({
          isFinishingHomeVisit: false
        });
        /* //////console.log("################## ERROR ################"); */
      });
  }

  searchWebMobileRequests(query, bulkOperation, prevIndex, isSearch, isGetWebRequest, isGetCustomerWebRequests, isByStatus) {
    // console.log("################## searchWebMobileRequests ################");
    // console.log(query);
    // console.log(isByStatus);

    if (query === "FIRST-LOAD") {
      this.setState({
        webMobileRequestsLoaded: true,
        webMobileRequests: []
      });
      return;
    }

    if (bulkOperation && !prevIndex) {
      query = query.map((item, key) => {
        if (!(item in this.state.webMobileRequests)) return item;
      });
      query = this.cleanArray(query);
      if (query.length == 0) return;
    }
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);

    let currentIndex = prevIndex ? prevIndex : 0;
    let endIndex = 0;
    let arrayQuery = query;
    if (bulkOperation) {
      endIndex = (query.length > (currentIndex + 5))? currentIndex + 4 : query.length - 1;
      query = query.slice(currentIndex, endIndex + 1).join("+");
    }
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    //if (saveForBulk) {
      //this.setState({
      //  searchBulkCustomer: (this.state.searchBulkCustomer != null)? this.state.searchBulkCustomer + "+" + query : query
      //});
     // return;
    //}
    if (isSearch && this.state.isSearchingWebMobileRequests) {
      return;
    }
    if (query === undefined) {
      query = "";
    }
    if (isSearch & !this.state.isSearchingWebMobileRequests) {
      this.setState({
        searchWebMobileRequestsQuery: query,
        isSearchingWebMobileRequests: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_WEB_MOBILE_REQUESTS + query;
    if (isSearch) {
      urlToUse = API + GET_WEB_MOBILE_REQUESTS + query;
    }
    if (isGetWebRequest) {
      urlToUse = API + GET_WEB_MOBILE_REQUESTS + query;
    }
    if (isGetCustomerWebRequests) {
      urlToUse = API + GET_CUSTOMER_WEB_MOBILE_REQUESTS + query;
    }
    if (isByStatus) {
      urlToUse = API + GET_CUSTOMER_WEB_MOBILE_REQUESTS_BY_STATUS + query;
      // /*if (this.state.debug)*/ console.log(urlToUse);
    }
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // if (this.state.debug) console.log("################## RESPUESTA GET WEBMOBILEREQUESTS ################");
        // console.log(query);
        // if (this.state.debug) console.log(result);
        const groupByID = groupBy("id");
        const groupedByID = groupByID(result.data);
        let webMobileRequestsResultAux = this.state.webMobileRequests;
        Object.keys(groupedByID).map(function(k) {
          webMobileRequestsResultAux[k] = groupedByID[k];
        });

        const groupByStatus = groupBy("estado_solicitud");
        const groupedByStatus = groupByStatus(result.data);
        let webMobileRequestsStatusResultAux = this.state.webMobileRequestsByStatus;
        Object.keys(groupedByStatus).map(function(k) {
          webMobileRequestsStatusResultAux[k] = groupedByStatus[k];
        });
        
        const groupByCustomerID = groupBy("id_cliente");
        const groupedByCustomerID = groupByCustomerID(result.data);
        let webMobileRequestsByCustomerIDAux = this.state.webMobileRequestsByCustomerID;
        Object.keys(groupedByCustomerID).map(function(k) {
          webMobileRequestsByCustomerIDAux[k] = groupedByCustomerID[k];
        });

        //console.log(groupedByID);
        if (isSearch) {
          let auxSearchResult = this.state.webMobileRequestsSearchResult;
          auxSearchResult[query] = groupedByID;
          this.setState({
            webMobileRequestsLoaded: true,
            webMobileRequests: webMobileRequestsResultAux,
            isSearchWebMobileRequestsResult: true,
            isSearchingWebMobileRequests: false,
            webMobileRequestsSearchResult: auxSearchResult,
            webMobileRequestsByCustomerID: webMobileRequestsByCustomerIDAux,
            webMobileRequestsByStatus: webMobileRequestsStatusResultAux
          });
        } else {
          this.setState({
            webMobileRequestsLoaded: bulkOperation ? this.state.webMobileRequestsLoaded : true,
            webMobileRequests: webMobileRequestsResultAux,
            webMobileRequestsByCustomerID: webMobileRequestsByCustomerIDAux,
            webMobileRequestsByStatus: webMobileRequestsStatusResultAux
          });
        }
        let options = {
          place: "tr",
          message: "Solicitudes web cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (bulkOperation && arrayQuery.length > (endIndex + 1)) this.searchWebMobileRequests(arrayQuery, true, endIndex + 1);
        //this.getCustomersMobiles(Object.keys(groupedByDNI), true, null, null, true);
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  getWebMobileRequestDocuments(query) {
    // console.log("################## GET MOBILE REQUEST DOCUMENTS ################");
    // console.log(query);
    // console.log("################## GET CUSTOMERS CLEANED ################");
    // console.log(query);

    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    //if (saveForBulk) {
      //this.setState({
      //  searchBulkCustomer: (this.state.searchBulkCustomer != null)? this.state.searchBulkCustomer + "+" + query : query
      //});
     // return;
    //}
    if (!(query in this.state.isSearchingWebMobileRequestsDocuments)) {
      // console.log("################## GET MOBILE REQUEST DOCUMENTS CREAMOS SEARCHING ################");
      let auxSearching = this.state.isSearchingWebMobileRequestsDocuments;
      auxSearching[query] = true;
      this.setState({
        isSearchingWebMobileRequestsDocuments: auxSearching
      });
    } else if (this.state.isSearchingWebMobileRequestsDocuments[query]) {
      // console.log("################## GET MOBILE REQUEST DOCUMENTS SALIMOS PORQUE YA EXISTE ################");
      return;
    } else {
      // console.log("################## GET MOBILE REQUEST DOCUMENTS ACTUALIZAMOS ################");
      let auxSearching = this.state.isSearchingWebMobileRequestsDocuments;
      auxSearching[query] = true;
      this.setState({
        isSearchingWebMobileRequestsDocuments: auxSearching
      });
    }
    // console.log("################## GET MOBILE REQUEST DOCUMENTS SEGUIMOS ################");
    if (query === undefined) {
      query = "";
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let urlToUse = API + GET_WEB_MOBILE_REQUEST_DOCUMENTS + query;
    // console.log("################## GET MOBILE REQUEST DOCUMENTS URL ################");
    // console.log(urlToUse);
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET WEBMOBILEREQUEST DOCUMENTS ################");
        // // console.log(query);
        // console.log(result.data[0]);
        
        let webMobileRequestsResultAux = this.state.webMobileRequestDocuments;
        webMobileRequestsResultAux[query] = result.data[0];

        let auxSearching = this.state.isSearchingWebMobileRequestsDocuments;
        auxSearching[query] = false;

        this.setState({
          webMobileRequestDocuments: webMobileRequestsResultAux,
          isSearchingWebMobileRequestsDocuments: auxSearching
        });

        let options = {
          place: "tr",
          message: "Documentos de la solictud cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        //this.getCustomersMobiles(Object.keys(groupedByDNI), true, null, null, true);
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  getCustomersMonthCount(month) {
    //console.log("################## GET CUSTOMERS BY MONTH ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_SEARCH_CUSTOMER_MONTH + month, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET CUSTOMERS BY MONTH " + month + " ################");
        //console.log(result);

        let customersCount = {
          count: result.data.length,
          month: month
        };

        this.setState({
          customersLastMonths: this.state.customersLastMonths.concat(customersCount),
          customersLastMonthsLoaded:
              this.state.customersLastMonths.length + 1 == MONTHS_TO_LOAD_COUNT
        });
        let options = {
          place: "tr",
          message: "Cuenta clientes del mes " + month + " cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  getActiveCustomersCount() {
    //console.log("################## GET ACTIVE CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_ACTIVE_CUSTOMERS_COUNT, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET ACTIVE CUSTOMERS ################");
        //console.log(result);

        this.setState({
          customersCount: result.data.length > 0 ? result.data[0].count : 0,
          customersCountLoaded: true
        });
        let options = {
          place: "tr",
          message: "Cuenta de clientes activos cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET ACTIVE CUSTOMERS COUNT ################");
      });
  }

  getMobilePlans() {
    return;
    // console.log("################## GET MOBILE PLANS ################");
    //console.log("################## GET ACTIVE CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_MOBILE_PLANS_SHOP, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET MOBILE PLANS ################");
        // console.log(result);
        let mobilePlans = result.data;
        if (!mobilePlans) mobilePlans = [];
        let mobilePlansOrdered = result.data
          .sort(function(a, b) {
            return a.precio_raw - b.precio_raw;
          })
          .map((item, key) => {
            let providerStyle = {
              padding: "2px 4px",
              borderRadius: "3px",
              background: item.proveedor === "Aire" ? "#009CCF" : ((item.proveedor === "Lemon" || item.proveedor ===  "ONMOVIL") ? "#FF7A01" : "#633386"),
              color: "#FFF",
              fontSize: "9px"
            };
            if (!item.proveedor || item.proveedor === "" || Array.isArray(item.proveedor)) {
              providerStyle.background = "#CCC";
              providerStyle.padding = "4px";
              providerStyle.borderRadius = "50%";
              providerStyle.display = "inline-block";
              providerStyle.width = "10px";
              providerStyle.height = "10px";
            }
            let priceStyle = {
              padding: "2px 4px",
              borderRadius: "3px",
              background: "#DDD",
              color: "#000",
              fontSize: "13px"
            };
            return {
              value: item.id, 
              label: 
                <span>
                  <span style={providerStyle}>{item.proveedor}</span>
                  {" "}
                  {item.titulo.replace("(Nueva) ", "").replace(" (Móvil)", "")}
                  {" "}
                  <span style={priceStyle}>{item.precio}</span>
                </span>
            };
          });

        // console.log("################## MOBILE PLANS ORDERED ################");
        // console.log(mobilePlansOrdered);

        this.setState({
          mobilePlans: {
            raw: mobilePlans,
            forOptions: mobilePlansOrdered
          }
        });
        let options = {
          place: "tr",
          message: "Tarifas de móvil cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET ACTIVE CUSTOMERS COUNT ################");
      });
  }

  getTVPlans() {
    // console.log("################## GET MOBILE PLANS ################");
    //console.log("################## GET ACTIVE CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_TV_PLANS_SHOP, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET MOBILE PLANS ################");
        // console.log(result);
        let TVPlans = result.data;
        if (!TVPlans) TVPlans = [];
        let TVPlansOrdered = result.data
          .sort(function(a, b) {
            return a.precio_raw - b.precio_raw;
          })
          .map((item, key) => {
            return {
              value: item.id, 
              label: item.titulo.replace("nadunet TV ", "") + " (" + item.precio + ")"
            };
          });

        // console.log("################## MOBILE PLANS ORDERED ################");
        // console.log(mobilePlansOrdered);

        this.setState({
          TVPlans: {
            raw: TVPlans,
            forOptions: TVPlansOrdered
          }
        });
        let options = {
          place: "tr",
          message: "Paquetes de TV cargados",
          type: "primary",
          icon: "now-ui-icons tech_tv",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET ACTIVE CUSTOMERS COUNT ################");
      });
  }


  getBillStatuses() {
    // console.log("################## GET BILL STATUSES ################");
    //console.log("################## GET ACTIVE CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_BILL_STATUSES, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET BILL STATUSES ################");
        // console.log(result);
        let billStatuses = result.data;
        if (!billStatuses) billStatuses = [];
        let billStatusesOptions = result.data.map(item => {
          return {
            value: item.id,
            label: item.name
          };
        });

        // console.log("################## BILL STATUSES ORDERED ################");
        // console.log(billStatusesOptions);

        this.setState({
          billStatuses: {
            raw: billStatuses,
            forOptions: billStatusesOptions
          }
        });
        let options = {
          place: "tr",
          message: "Estados de facturas cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET ACTIVE CUSTOMERS COUNT ################");
      });
  }

  getMobileProcedureTypes() {
    //console.log("################## GET ACTIVE CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_PROCEDURE_TYPES_GLOBAL, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET ACTIVE CUSTOMERS ################");
        //console.log(result);

        this.setState({
          mobileProcedureTypes: {
            raw: result.data.length > 0 ? result.data : [],
            forOptions: result.data.map((item, key) => 
              { 
                return {
                  value: item.id, 
                  label: item.nombre
                }
              })
          }
        });
        let options = {
          place: "tr",
          message: "Tarifas de móvil cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET ACTIVE CUSTOMERS COUNT ################");
      });
  }

  getCustomersMobiles(query, bulkOperation, prevIndex, isSearch) {
    if (bulkOperation) {
      this.searchBulkCustomer(query);
      return;
    }
    if (isSearch && this.state.isSearchingMobiles) {
      return;
    }
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    // if (bulkOperation) {
    //   console.log("################## GET CUSTOMERS MOBILES BULK ################");
    //   console.log(query);
    // }

    if (bulkOperation && !prevIndex) {
      query = query.map((item, key) => {
        /*if (!(item in this.state.customersMobiles))*/ return item;
      });
      query = this.cleanArray(query);
      if (query.length == 0) return;
    }
    // console.log("################## GET CUSTOMERS MOBILES CLEANED ################");
    // console.log(query);

    let currentIndex = prevIndex? prevIndex : 0;
    let endIndex = 0;
    let arrayQuery = query;

    // BUILD THE URL
    let urlToUse = API + GET_CUSTOMERS_MOBILES_URL;
    if (query) urlToUse = API + GET_CUSTOMERS_MOBILES_FILTER_URL + query;
    if (bulkOperation) {
      let bulkOperationSize = 5;
      let isByDNI = false;
      query.map((item, key) => {
        if (isNaN(item)) isByDNI = true;
      });
      endIndex = (query.length > (currentIndex + bulkOperationSize))? currentIndex + (bulkOperationSize - 1) : query.length - 1;
      query = query.slice(currentIndex, endIndex + 1).join("+");
      urlToUse = API + GET_CUSTOMERS_MOBILES_FILTER_URL + query;
      if (isByDNI) {
        // console.log("################## GET CUSTOMERS MOBILES BULK - IS BY DNI ################");
        urlToUse = API + GET_CUSTOMERS_MOBILES_DNI_FILTER_URL + query;
      }
    }
    if (isSearch) urlToUse = API + GET_CUSTOMERS_MOBILES_SEARCH_URL + query;

    //if (this.state.customersMobilesLoaded) {
      //this.setState({
      //  customersMobilesLoaded: false
      //});
    //}
    if (query === undefined) {
      query = "";
    }
    if (isSearch & !this.state.isSearchingMobiles) {
      this.setState({
        searchMobilesQuery: query,
        isSearchingMobiles: true
      });
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(urlToUse, queryHeaders, { withCredentials: true })
      .then(result => {
        // if (bulkOperation) {
          // console.log("################## GET CUSTOMERS MOBILES BULK RESULT ################");
          // console.log(result);
        // }
        if (isSearch) {
          // console.log("############## RESULTADO BUSCAR MÓVILES #################");
          // console.log(result);
          let auxSearchResult = this.state.mobilesSearchResult;
          auxSearchResult[query] = result.data;
          this.setState({
            customersMobilesLoaded: true,
            isSearchMobilesResult: true,
            isSearchingMobiles: false,
            mobilesSearchResult: auxSearchResult
          });
        }

        //console.log("################## RESPUESTA GET CUSTOMERS MOBILES ################");
        //console.log(result);
        const groupByUID = groupBy("cliente_id");
        const groupByNumero = groupBy("numero");

        let resultAux = result.data;
        const groupedExistingNumero = this.state.customersMobilesRaw.length > 0 ? groupByNumero(this.state.customersMobilesRaw) : [];
        // resultAux = resultAux.map((item, key) => {
        //   if (item.numero in groupedExistingNumero) return null;
        //   return item;
        // });
        resultAux = this.cleanArray(resultAux);

        const groupedResult = result.data.length > 0 ? groupByUID(resultAux) : [];
        const groupedResultNumero = result.data.length > 0 ? groupByNumero(resultAux) : [];
        //console.log("################## CUSTOMERS MOBILES GROUPED ################");
        //console.log(groupedResult);
        let auxCustomersMobiles = this.state.customersMobiles;
        Object.keys(groupedResult).map(function(k) {
          auxCustomersMobiles[k] = groupedResult[k];
        });

        let auxRawMobiles = this.state.customersMobilesRaw.concat(resultAux);

        this.setState({
          customersMobilesRaw: auxRawMobiles,
          customersMobiles: auxCustomersMobiles,
          customersMobilesCount: auxRawMobiles.length,
          customersMobilesLoaded: true
        });
        let currentCustomers = this.state.customers;
        let customersToSearch = Object.keys(groupedResult).map(function(k) {
          if (k in currentCustomers) return null;
          return k;
        });
        customersToSearch = this.cleanArray(customersToSearch);

        let numbersToLoadCDR = Object.keys(groupedResultNumero);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        this.getMobileCDRShort(numbersToLoadCDR, true);
        let options = {
          place: "tr",
          message: "Móviles de los clientes cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (bulkOperation && arrayQuery.length > (endIndex + 1)) this.getCustomersMobiles(arrayQuery, true, endIndex + 1);
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS MOBILES ################");
      });
  }

  getMobileProceduresCount() {
    return;
    //console.log("################## GET MOBILE PROCEDURES COUNT ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_MOBILE_PROCEDURES_COUNT_GROUPED, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET MOBILE PROCEDURES COUNT ################");
        //console.log(result);

        this.setState({
          mobileProceduresCount: result.data.length > 0 ? result.data : [],
          mobileProceduresCountLoaded: true
        });
        let options = {
          place: "tr",
          message: "Cuenta de trámites de móvil cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET MOBILE PROCEDURES COUNT ################");
      });
  }

  getMobileRejectedProceduresCount() {
    //console.log("################## GET MOBILE REJECTED PROCEDURES COUNT ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_MOBILE_REJECTED_PROCEDURES_COUNT, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET MOBILE REJECTED PROCEDURES COUNT ################");
        //console.log(result);

        this.setState({
          mobileRejectedProceduresCount: result.data.length > 0 ? result.data[0].count : 0,
          mobileRejectedProceduresCountLoaded: true
        });
        let options = {
          place: "tr",
          message: "Cuenta de trámites rechazados de móvil cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET MOBILE REJECTED PROCEDURES COUNT ################");
      });
  }

  //Iff offset is 0, it will return last day of current month
  getLastDayOffsetMonth(offset) {
    let d = new Date();
    d.setMonth(d.getMonth() + (1 - offset)); // set month as next month
    d.setDate(0); // get the last day of previous month
    let options = { year: 'numeric', month: 'numeric', day: 'numeric' };

    return (d.toLocaleDateString("es-ES",options)).replace(/\//g,'-');
  }

  getCustomersCountLastMonths(numberMonths) {
    for (let i = 0; i < numberMonths; i++) {
      let currentLastDay = this.getLastDayOffsetMonth(i);
      //console.log(currentLastDay);

      this.getCustomersMonthCount(currentLastDay);
    }
  }

  getWebMobileRequestsCount() {
    //console.log("################## GET MOBILE PROCEDURES COUNT ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_WEB_MOBILE_REQUESTS_COUNT, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA GET MOBILE PROCEDURES COUNT ################");
        //console.log(result);

        this.setState({
          webMobileRequestsCount: result.data.length > 0 ? result.data : [],
          webMobileRequestsCountLoaded: true
        });
        let options = {
          place: "tr",
          message: "Cuenta de solicitudes de móvil cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET MOBILE PROCEDURES COUNT ################");
      });
  }

  setSearchCustomerQuery(newQuery) {
    this.setState({
      searchCustomerQuery: newQuery
    });
  }

  setSearchWebMobileRequestsQuery(newQuery) {
    this.setState({
      searchWebMobileRequestsQuery: newQuery
    });
  }

  getOrdersArticles(query, bulkOperation, prevIndex, isSearch, isGet) {
    /* //////console.log("################## GET ORDERS ARTICLES ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    //console.log("################## GET ARTICLES ################");
    //console.log(query);

    let currentIndex = prevIndex? prevIndex : 0;
    let endIndex = 0;
    let arrayQuery = query;
    if (bulkOperation) {
      endIndex = (query.length > (currentIndex + 5))? currentIndex + 4 : query.length - 1;
      query = query.slice(currentIndex, endIndex + 1).join("+");
    }
    let URL = GET_ORDERS_ARTICLES_SHOP_URL;
    if (isGet) {
      URL = GET_ORDERS_ARTICLES_SHOP_NUMBER_URL;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + URL + query, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // console.log("################## RESPUESTA GET_ORDERS_ARTICLES_SHOP_URL ################");
        // console.log(result);

        /* numero_pedido: "4120174190"
        tipo: "Producto"
        total: "29,95 €"
        título: "∞ min + 10GB (Móvil)" */

        const groupedArticles = result.data.reduce(
          (currentOrder, { numero_pedido, total, titulo }) => {
            (currentOrder[numero_pedido] =
              currentOrder[numero_pedido] || []).push({ total, titulo });
            return currentOrder;
          },
          {}
        );

        let auxOrdersArticles = this.state.ordersArticles;

        Object.keys(groupedArticles).map(function(k) {
          auxOrdersArticles[k] = groupedArticles[k];
        });

        this.setState({
          ordersArticlesLoaded: true,
          ordersArticles: auxOrdersArticles
        });
        if (bulkOperation && arrayQuery.length > (endIndex + 1)) this.getOrdersArticles(arrayQuery, true, endIndex + 1);
        let options = {
          place: "tr",
          message: "Artículos de facturas cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getServices() {
    /* //////console.log("################## GET SERVICES ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_SERVICES_URL, { headers: queryHeaders.headers })
      .then(result => {
        ////console.log("################## RESPUESTA GET SERVICES ################");

        let jsonResult = result.data[0];
        ////console.log(jsonResult);

        if (jsonResult.internet === "1") {
          this.getInternet();
        }
        if (jsonResult.mobile === "1") {
          this.getMobile();
        }

        this.setState({
          hasMobile: jsonResult.mobile === "1",
          hasInternet: jsonResult.internet === "1",
          mobilesLoaded: jsonResult.mobile === "0",
          internetLoaded: jsonResult.internet === "0",
          mobilesCDRLoaded: jsonResult.mobile === "0"
        });
        let options = {
          place: "tr",
          message: "Servicios obtenidos",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getInternet() {
    /* //////console.log("################## GET INTERNET ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_INTERNET_URL, queryHeaders, { withCredentials: true })
      .then(result => {
        /* //////console.log("################## RESPUESTA GET INTERNET ################");
        //////console.log(result); */

        if (result && result.data && result.data[0]) {
          this.setState({
            internet_plan: {
              name: result.data[0].internet_plan.replace(" (Internet)", ""),
              price: result.data[0].precio
            },
            internetLoaded: true
          });
        }
        let options = {
          place: "tr",
          message: "Internet cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getMobile() {
    /* //////console.log("################## GET MOBILE ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_MOBILE_URL, { headers: queryHeaders.headers })
      .then(result => {
        ////console.log("################## RESPUESTA GET MOBILE ################");

        let jsonResult = result.data;
        ////console.log(jsonResult);
        /* let mobiles = [];
        jsonResult.resultado.map((currentMobile, key) =>{
          mobiles[currentMobile.mobile] = currentMobile.plan;
        }); 
        //////console.log("Mobiles array");
        //////console.log(mobiles); */

        this.setState({
          mobiles: jsonResult,
          mobilesLoaded: true
        });

        //Obtain mobile CDR if there is any mobile
        jsonResult.map(mobile => this.getMobileCDR(mobile.mobile));
        //this.getMobileCDR();

        let options = {
          place: "tr",
          message: "Móviles cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
  }

  getMobileCDR(number) {
    //console.log("################## GET MOBILE CDR ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    /* this.state.mobiles.forEach(function iterator(currentMobileObject) { */
    let currentMobile = number;
    axios
      .get(API + GET_MOBILE_CDR_URL + currentMobile, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        //console.log(
        //  "################## RESPUESTA GET CDR " +
        //    currentMobile +
        //    " ################"
        //);
        //console.log(result);

        if (result && result.data) {
          /* let auxCDR = { [currentMobile]: result.data }; */

          const groupByRegistryType = groupBy("tipo_consumo");
          const groupedResult = groupByRegistryType(result.data);

          let auxCDR = this.state.mobilesCDR;
          auxCDR[currentMobile] = groupedResult;
          this.setState({
            mobilesCDR: auxCDR
          });

          /* let auxCDR = this.state.mobilesCDR.slice().push(result.data);

          let mobilesAlreadyLoaded = ((this.state.mobilesLoadedCount + 1) == this.state.mobiles.length);

          this.setState({
            mobilesCDR: auxCDR,
            mobilesCDRLoaded: mobilesAlreadyLoaded,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1
          }); */
          let options = {
            place: "tr",
            message: "CDR del móvil " + currentMobile + " cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else if (this.state.retriesCDR < 5) {
          const retries = this.state.retriesCDR + 1;
          this.setState({
            retriesCDR: retries
          });
          this.getMobileCDR(currentMobile);
        } else {
          this.setState({
            mobilesCDRLoaded: true,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1
          });
        }
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
    /* }, this); */
  }

  getInternetPlans() {
    //console.log("################## GET MOBILE CDR ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_INTERNET_PLANS, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        const groupByInternetType = groupBy("tipo_internet");
        const groupedResult = groupByInternetType(result.data);

        this.setState({
          internetPlans: groupedResult
        });

        let options = {
          place: "tr",
          message: "Tarifas de internet cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
    /* }, this); */
  }

  getMobileCDRShort(query, bulkOperation, prevIndex, isSearch) {
    // console.log("################## GET MOBILE CDR SHORT ################");
    // console.log(query);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    
    let currentIndex = prevIndex ? prevIndex : 0;
    let endIndex = 0;
    let arrayQuery = query;
    let currentArray = [];
    if (bulkOperation) {
      endIndex = (query.length > (currentIndex + 5))? currentIndex + 4 : query.length - 1;
      currentArray = query.slice(currentIndex, endIndex + 1);
      query = currentArray.join("+");
    } 
    if (!query) return;
    if (query.length == 0) return;

    /* this.state.mobiles.forEach(function iterator(currentMobileObject) { */
    //let currentMobile = number;
    axios
      .get(API + GET_MOBILE_CDR_SHORT_URL + query, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // console.log("################## RESPUESTA GET CDR ####################");
        // console.log(query);
        //  "################## RESPUESTA GET CDR " +
        //    currentMobile +
        //    " ################"
        //);
        // console.log(result);

        if (result && result.data) {
          /* let auxCDR = { [currentMobile]: result.data }; */

          const groupByOrigin = groupBy("origen");
          const groupedResult = groupByOrigin(result.data);
          let auxCDR = this.state.mobilesCDR;
          if (!auxCDR) auxCDR = [];
          
          const groupByRegistryType = groupBy("tipo_consumo");

          Object.keys(currentArray).map(function(k) {
            let currentMobile = currentArray[k];
            let currentMobileCDR = [];
            if (currentMobile in groupedResult) {
              let groupedByType = groupByRegistryType(groupedResult[currentMobile]);
              currentMobileCDR = groupedByType;
            }
            auxCDR[currentMobile] = currentMobileCDR;
          });
          // console.log("################## RESPUESTA GET CDR GROUPED ####################");
          // console.log(groupedResult);

          this.setState({
            mobilesCDR: auxCDR,
            mobilesCDRLoaded: true
          });
          if (bulkOperation && arrayQuery.length > (endIndex + 1)) this.getMobileCDRShort(arrayQuery, true, endIndex + 1);

          /* let auxCDR = this.state.mobilesCDR.slice().push(result.data);

          let mobilesAlreadyLoaded = ((this.state.mobilesLoadedCount + 1) == this.state.mobiles.length);

          this.setState({
            mobilesCDR: auxCDR,
            mobilesCDRLoaded: mobilesAlreadyLoaded,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1
          }); */
          let options = {
            place: "tr",
            message: "CDR de los móviles " + query + " cargados",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
        } else if (this.state.retriesCDR < 5) {
          const retries = this.state.retriesCDR + 1;
          this.setState({
            retriesCDR: retries
          });
          this.getMobileCDRShort(query, true, 0);
        } else {
          this.setState({
            mobilesCDRLoaded: true,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1
          });
        }
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        /* //////console.log("################## ERROR ################"); */
      });
    /* }, this); */
  }

  showNotification(optionsInput) {
    if (optionsInput != null) {
      if (this.refs && this.refs.notificationAlert)
        this.refs.notificationAlert.notificationAlert(optionsInput);
    } else {
      var message = "Notificación genérica...";
      let options = {
        place: "tr",
        message: message,
        type: "primary",
        icon: "now-ui-icons ui-1_check",
        autoDismiss: 3
      };
      this.refs.notificationAlert.notificationAlert(options);
    }
  }

  createMobileProcedure(ICC, tarifa, cliente, tipo, fecha, numero, tipoContratoPrevio, ICC_origen, existing_mobile) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (this.state.isCreatingMobileProcedure) {
      return;
    }

    this.setState({
      isCreatingMobileProcedure: true
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = null;
    // Si es cambio de tarifa
    if (tipo && parseInt(tipo.value) === 175) {
      request = {
        customer: parseInt(this.checkValue(cliente)),
        type: parseInt(this.checkValue(tipo)),
        existing_mobile: existing_mobile.value,
        plan: parseInt(this.checkValue(tarifa)),
        title: "Nuevo trámite (" + tipo.label + ")"
      };
    } else {
      numero = this.checkValue(numero);
      if (numero) {
        numero = parseInt(numero);
      } else {
        numero = 0;
      }
      ICC_origen = this.checkValue(ICC_origen);
      if (!ICC_origen) ICC_origen = "";
      tipoContratoPrevio = this.checkValue(tipoContratoPrevio);
      if (tipoContratoPrevio) {
        tipoContratoPrevio = parseInt(tipoContratoPrevio);
      } else {
        tipoContratoPrevio = 0;
      }
      request = {
        title: "Nuevo trámite (" + tipo.label + ")",
        icc: this.checkValue(ICC),
        plan: parseInt(this.checkValue(tarifa)),
        customer: parseInt(this.checkValue(cliente)),
        type: parseInt(this.checkValue(tipo)),
        previous_contract: this.checkValue(tipoContratoPrevio),
        // field_estado_tramite: { und: "182" }, //182: Es el estado inicial "Procesando"
        /*field_fecha_programada: { und: "2019-10-25" },*/
        mobile: numero,
        previous_icc: ICC_origen
      };
    }
    request = {
      procedure: request
    };
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_MOBILE_PROCEDURE, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);

        this.setState({
          isCreatingMobileProcedure: false
        });

        this.searchMobileProcedures(cliente);
        if (result.data.result === "OK") {
          this.getCustomerExtraExpenses(cliente);
          let options = {
            place: "tr",
            message: "Trámite de móvil creado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug) */this.showNotification(options);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo crear el trámite: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        this.setState({
          isCreatingMobileProcedure: false
        });

        let options = {
          place: "tr",
          message: "Error al crear el trámite de móvil",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  createSIMDelivery(delivery) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (this.state.isCreatingSIMDelivery) {
      return;
    }

    this.setState({
      isCreatingSIMDelivery: true
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      delivery: delivery
    };

    // let request = {
    //   title_field: {
    //     und: [
    //       {
    //         value: "Nuevo envío (" + titulo + " - " + numero + ")"
    //       }
    //     ]
    //   },
    //   type: "wrapper_envio_sim",
    //   body: [],
    //   field_icc_sim_tramite: {
    //     und: [
    //       {
    //         value: this.checkValue(ICC)
    //       }
    //     ]
    //   },
    //   // field_cliente_relacionado: { und: this.checkValue(cliente) },
    //   field_id_cliente_relacionado: {
    //     und: [
    //       {
    //         value: this.checkValue(cliente)
    //       }
    //     ]
    //   },
    //   field_numero_movil: {
    //     und: [
    //       {
    //         value: this.checkValue(numero)
    //       }
    //     ]
    //   },
    //   field_estado_del_envio: { und: "189" },
    //   // field_estado_del_envio: { und: "189" }, //189: Es el estado inicial "Preparando"
    //   /*field_fecha_programada: { und: "2019-10-25" },*/
    //   field_id_tramite_relacionado: {
    //     und: [
    //       {
    //         value: this.checkValue(tramite)
    //       }
    //     ]
    //   },
    //   field_cobertura_sim: {
    //     und: [
    //       {
    //         value: this.checkValue(cobertura)
    //       }
    //     ]
    //   },
    //   field_tipo_de_envio: { und: "193" }
    //   // field_tipo_de_envio: {
    //   //   und: [
    //   //     {
    //   //       tid: "193"
    //   //     }
    //   //   ]
    //   // }
    // };
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_SIM_DELIVERY, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);

        this.setState({
          isCreatingSIMDelivery: false
        });

        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Envío de SIM creado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          if (this.state.debug) this.showNotification(options);
          this.searchSIMDeliveries(delivery.customer);
        } else {
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Hubo errores al crear el envío de SIM: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        this.setState({
          isCreatingSIMDelivery: false
        });

        let options = {
          place: "tr",
          message: "Error al crear el envío de SIM",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  generateUsername(customerData) {
    let username = "";
    try {
      let nameCompound = 
        customerData.name.replace(/[^a-zA-Z0-9]/g, "") +
        (customerData.lastname ? customerData.lastname.replace(/[^a-zA-Z0-9]/g, "") : "emp") +
        (customerData.lastname2 ? (customerData.lastname2 ? customerData.lastname2.replace(/[^a-zA-Z0-9]/g, "") : "ext") : "ext");
      if (nameCompound && nameCompound.length > 20) nameCompound = nameCompound.substring(0, 20);
      username = 
        nameCompound +
        "-" +
        customerData.dni +
        "-" +
        Math.random()
          .toString(36)
          .substring(2, 7);
    } catch (error) {
      username = 
        customerData.name.replace(/[^a-zA-Z0-9]/g, "") + "-emp"
        "-" +
        customerData.dni +
        "-" +
        Math.random()
          .toString(36)
          .substring(2, 7);
    }

    return username;
  }

  createCustomerFromWebRequest(webRequest) {
    this.setState({
      createCustomerFromWebRequest: webRequest
    });
  }

  createCustomerFromContract(contract) {
    this.setState({
      createCustomerFromContract: contract
    });
    this.cleanContract();
  }

  createCustomer(customerData) {
    console.log("################## CREATE CUSTOMER MAIN ################");
    console.log(customerData);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (this.state.isCreatingCustomer) {
      return;
    }

    this.setState({
      isCreatingCustomer: true,
      createCustomerFromWebRequest: null,
      isCreatingCustomerError: false
    });

    //Si se trata de una empresa, establece el tipo de documento como NIF
    let customerIDType = "";
    if (customerData.customerType === "90") {
      customerIDType = "95";
    } else {
      customerIDType = customerData.fiscalIdType.value;
    }

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      name: this.generateUsername(customerData),
      pass: customerData.mobile,
      mail: customerData.email,
      status: "1",
      // field_codigo_promocional: {
      //   und: [
      //     {
      //       value: customerData.promoCode ? customerData.promoCode.toUpperCase() : ""
      //     }
      //   ]
      // },
      // field_tipo_de_cliente: { und: customerData.customerType },
      field_tipo_de_cliente: {
        und: [
          {
            tid: customerData.customerType
          }
        ]
      },
      // field_tipo_de_documento_de_ident: { und: customerIDType },
      field_tipo_de_documento_de_ident: {
        und: [
          {
            tid: customerIDType
          }
        ]
      },
      field_dni: {
        und: [
          {
            value: customerData.dni
          }
        ]
      },
      field_nombre_completo: {
        und: [
          {
            value: customerData.name
          }
        ]
      },
      field_primer_apellido: {
        und: [
          {
            value: customerData.lastname
          }
        ]
      },
      field_segundo_apellido: {
        und: [
          {
            value: customerData.lastname2
          }
        ]
      },
      field_telefono: {
        und: [
          {
            value: customerData.mobile
          }
        ]
      },
      field_domicilio: {
        und: [
          {
            country: "ES",
            administrative_area: customerData.province,
            sub_administrative_area: null,
            locality: customerData.city,
            dependent_locality: null,
            postal_code: customerData.postalCode,
            thoroughfare: customerData.street,
            premise: ""
          }
        ]
      },
      field_comunidad_autonoma: {
        und: [
          {
            value: customerData.comunity
          }
        ]
      },
      /*field_comercial: { und: this.state.user.uid },*/
      field_numero_de_cuenta: {
        und: [
          {
            value: customerData.iban
          }
        ]
      },
      field_dni_gerente: {
        und: [
          {
            value: customerData.dniManager
          }
        ]
      },
      field_nombre_gerente: {
        und: [
          {
            value: customerData.firstnameManager
          }
        ]
      },
      field_primer_apellido_gerente: {
        und: [
          {
            value: customerData.lastnameManager
          }
        ]
      },
      field_segundo_apellido_gerente: {
        und: [
          {
            value: customerData.lastname2Manager
          }
        ]
      }
    };
    if (customerData.contract_id) {
      request.is_from_contract = true;
      request.contract_id = customerData.contract_id;

      request.field_dni_frontal_base64 = {
        und: [
          {
            value: customerData.contract.documents.front
          }
        ]
      };
      request.field_dni_trasero_base64 = {
        und: [
          {
            value: customerData.contract.documents.back
          }
        ]
      };
      request.field_firma_base64 = {
        und: [
          {
            value: customerData.contract.signature
          }
        ]
      };
    }
    if (customerData.isCreateFromRequest && customerData.mobile_request) {
      request.is_from_mobile_request = true;
      request.mobile_request_id = customerData.mobile_request.id;
      // request.field_dni_frontal_base64 = {
      //   und: [
      //     {
      //       value: customerData.mobile_request.dni_frontal
      //     }
      //   ]
      // };
      // request.field_dni_trasero_base64 = {
      //   und: [
      //     {
      //       value: customerData.mobile_request.dni_trasero
      //     }
      //   ]
      // };
      // request.field_firma_base64 = {
      //   und: [
      //     {
      //       value: customerData.mobile_request.firma
      //     }
      //   ]
      // };
    }
    request = {
      new_user: request
    };
    // console.log("################## CREATE CUSTOMER REQUEST ################");
    // console.log(request);

    // console.log("################## CREATE CUSTOMER AUXREQUEST ################");
    // console.log(auxRequest);

    // return;
    axios
      .post(API + CREATE_CUSTOMER, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // console.log("################## RESPUESTA CREATE CUSTOMER ################");
        // console.log(result);

        if (result.data.result === "OK") {
          this.setState({
            isCreatingCustomer: false,
            createCustomerFromContract: null
          });
          let options = {
            place: "tr",
            message: "Cliente creado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          // console.log("################## RESULT.DATA CREATE CUSTOMER ################");
          // console.log(result.data);
          // console.log("################## RESULT.DATA.UID CREATE CUSTOMER ################");
          // console.log(result.data.uid);
          this.searchCustomer([result.data.uid], true, null, null);
          this.searchWebMobileRequests(result.data.uid, null, null, false, false, true);
          //this.getOrdersArticles();
          /* this.props.godMode(result);
          if(result !== null && result.length > 0 && result[0] !== ""){ */
          /* this.setState({
              username: result[0],
              loginError: false
            }); */
          //doLogin();
          //}
        } else {
          this.setState({
            isCreatingCustomer: false,
            isCreatingCustomerError: true
          });
  
          // this.setState({
          //   isCreatingCustomer: false
          // });
          // <div dangerouslySetInnerHTML={{ __html: note.texto }} />
  
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>No se pudo crear el cliente: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
      })
      .catch(error => {
        console.log("################## ERROR CREATE CUSTOMER ################");
        console.log(error);

        this.setState({
          isCreatingCustomer: false,
          isCreatingCustomerError: true
        });

        // this.setState({
        //   isCreatingCustomer: false
        // });
        // <div dangerouslySetInnerHTML={{ __html: note.texto }} />

        let errorContentList = Object.keys(error.response.data.form_errors).map(currentError => {
          let currentLi = 
            <li key={currentError}>
              <div dangerouslySetInnerHTML={{ __html: error.response.data.form_errors[currentError] }} />
            </li>;
          return currentLi;
        });
        let errorContet =
          <div>
            <span>No se pudo crear el cliente: </span>
            <ul>{errorContentList}</ul>
          </div>

        let options = {
          place: "tr",
          message: errorContet,
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 0
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }
  
  getBillingData() {
    // Billing
    this.getAllBillingMonthly();
    this.getPlansBillingMonthly();
    this.getExtrasBillingMonthly();
    this.getNaduPackBillingMonthly();
    this.getMonthlyBillingReturns();
    this.getMonthlyBillingReturnsPaid();
    this.getMonthlyBillsPaidAll();
    this.getMonthlyBillsPaidRecurrent();
    this.getMonthlyBillsPaidByConcept();
    this.getMonthlyBillsPaidInvestment();
    // this.getMonthlyBillsPaidVariable();

    // Customers
    this.getMonthlyActiveCustomers();
    this.getMonthlyBillReturningCustomers();
    this.getMonthlyBillReturningPaidCustomers();
    this.getCurrentInternetCustomers();
    this.getActiveMobileLines();
    this.getCurrentMobileCustomers();
    this.getCurrentMobileCustomersWithInternet();
    this.getCurrentMobileCustomersWithoutInternet();
    this.getCurrentInternetWifiCustomers();
    this.getCurrentInternetFiberCustomers();

    // Employees
    this.getMonthlyPayrolls();
  }

  getAllBillingMonthly() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_ALL;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.all = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación de tarifas cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getPlansBillingMonthly() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_PLANS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.plans = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación de tarifas cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getExtrasBillingMonthly() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_EXTRAS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.extras = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación de gastos extra cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getNaduPackBillingMonthly() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_NADUPACK;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.nadupack = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación de naduPacks cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillingReturns() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_RETURNS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.returns = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación devuelta cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillingReturnsPaid() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLING_RETURNS_PAID;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let billingData = this.state.billingData || {};
        billingData.returnsPaid = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturación devuelta y pagada cargada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyActiveCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_ACTIVE_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let monthlyCustomers = this.state.monthlyCustomers || {};
        monthlyCustomers.all = result.data;

        this.setState({
          monthlyCustomers: monthlyCustomers
        });
        let options = {
          place: "tr",
          message: "Clientes activos mensuales cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillReturningCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILL_RETURNING_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let monthlyCustomers = this.state.monthlyCustomers || {};
        monthlyCustomers.returning = result.data;

        this.setState({
          monthlyCustomers: monthlyCustomers
        });
        let options = {
          place: "tr",
          message: "Clientes morosos mensuales cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  
  getMonthlyBillReturningPaidCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILL_RETURNING_PAID_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let monthlyCustomers = this.state.monthlyCustomers || {};
        monthlyCustomers.returningPaid = result.data;

        this.setState({
          monthlyCustomers: monthlyCustomers
        });
        let options = {
          place: "tr",
          message: "Clientes morosos mensuales cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillsPaidAll() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLS_PAID_ALL;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let billingData = this.state.billingData || {};
        if (!billingData.paidBills) billingData.paidBills = {};
        billingData.paidBills.all = result.data;

        this.setState({
          billingData: billingData
        });
        this.getMonthlyBillsPaidVariable();
        let options = {
          place: "tr",
          message: "Facturas recibidas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillsPaidRecurrent() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLS_PAID_RECURRENT;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let billingData = this.state.billingData || {};
        if (!billingData.paidBills) billingData.paidBills = {};
        billingData.paidBills.recurrent = result.data;

        this.setState({
          billingData: billingData
        });
        this.getMonthlyBillsPaidVariable();
        let options = {
          place: "tr",
          message: "Facturas recibidas variables cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillsPaidVariable() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLS_PAID_VARIABLE;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let billingData = this.state.billingData || {};
        if (!billingData.paidBills) billingData.paidBills = {};
        billingData.paidBills.variable = result.data;

        this.setState({
          billingData: billingData
        });
        let options = {
          place: "tr",
          message: "Facturas recibidas variables cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if (error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillsPaidByConcept() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLS_PAID_DETAIL;

    axios
      .post(API + URL, {}, queryHeaders, { withCredentials: true })
      .then(result => {
        let billingData = this.state.billingData || {};
        if (!billingData.paidBills) billingData.paidBills = {};
        billingData.paidBills.detail = result.data.bills;

        this.setState({
          billingData: billingData
        });
        // this.getMonthlyBillsPaidVariable();
        let options = {
          place: "tr",
          message: "Facturas recibidas por concepto cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyBillsPaidInvestment() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_BILLS_PAID_INVESTMENT;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let billingData = this.state.billingData || {};
        if (!billingData.paidBills) billingData.paidBills = {};
        billingData.paidBills.investment = result.data;

        this.setState({
          billingData: billingData
        });
        // this.getMonthlyBillsPaidVariable();
        let options = {
          place: "tr",
          message: "Facturas recibidas de inversión cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMonthlyPayrolls() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_MONTHLY_EMPLOYEES_PAYROLLS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let payrolls = this.state.payrolls || {};
        payrolls.monthly = result.data;

        this.setState({
          payrolls: payrolls
        });
        let options = {
          place: "tr",
          message: "Nóminas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentInternetCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_INTERNET_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let overallStatus = this.state.overallStatus || {};
        overallStatus.internet = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes de Internet cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentInternetWifiCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_INTERNET_WIFI_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let overallStatus = this.state.overallStatus || {};
        overallStatus.internet_wifi = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes de Internet WiFi cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentInternetFiberCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_INTERNET_FIBER_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {

        let overallStatus = this.state.overallStatus || {};
        overallStatus.internet_fiber = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes de Internet Fibra cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentMobileCustomers() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_MOBILE_CUSTOMERS;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let overallStatus = this.state.overallStatus || {};
        overallStatus.mobile_customers = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes de móvil cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getActiveMobileLines() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_ACTIVE_MOBILE_LINES;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let overallStatus = this.state.overallStatus || {};
        overallStatus.mobile_lines = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Móviles activos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentMobileCustomersWithInternet() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_MOBILE_CUSTOMERS_WITH_INTERNET;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let overallStatus = this.state.overallStatus || {};
        overallStatus.mobile_customers_with_internet = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes con móvil e Internet cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCurrentMobileCustomersWithoutInternet() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = GET_CURRENT_MOBILE_CUSTOMERS_WITHOUT_INTERNET;

    axios
      .get(API + URL, queryHeaders, { withCredentials: true })
      .then(result => {
        let overallStatus = this.state.overallStatus || {};
        overallStatus.mobile_customers_without_internet = result.data[0].count;

        this.setState({
          overallStatus: overallStatus
        });
        let options = {
          place: "tr",
          message: "Clientes con móvil e Internet cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        if(error.response)
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  
  editCustomer(customerData) {
    // console.log("################## EDIT CUSTOMER MAIN ################");
    // console.log(customerData);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (this.state.isEditingCustomer) {
      return;
    }

    this.setState({
      isEditingCustomer: true
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {};

    Object.keys(customerData).map(currentField => {
      let currentValue = customerData[currentField];
      if (currentValue !== null) request[currentField] = currentValue;
    });

    request = {
      user_data: request
    };

    // console.log("################## EDIT CUSTOMER REQUEST ################");
    // console.log(request);

    // console.log("################## CREATE CUSTOMER AUXREQUEST ################");
    // console.log(auxRequest);

    axios
      .post(API + EDIT_CUSTOMER, request, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        // console.log("################## RESPUESTA EDIT CUSTOMER ################");
        // console.log(result);

        this.setState({
          isEditingCustomer: false
        });

        if (customerData.client_id in this.state.customers) {
          // console.log("################## RESPUESTA EDIT CUSTOMER - Actualizar customer local ################");
          let currentUserId = request.user_data.client_id;
          let currentCustomer = this.state.customers[currentUserId][0];
          if (!currentCustomer) {
            currentUserId = currentUserId.toString();
            currentCustomer = this.state.customers[currentUserId][0];
          }

          Object.keys(request.user_data).map(currentField => {
            let currentValue = customerData[currentField];
            switch (currentField) {
              case "direccion":
                currentCustomer.domicilio = currentValue;
                break;
              case "localidad":
                currentCustomer.localidad = currentValue;
                break;
              case "codigo_postal":
                currentCustomer.codigo_postal = currentValue;
                break;
              case "nombre":
                currentCustomer.nombre_completo = currentValue;
                break;
              case "primer_apellido":
                currentCustomer.primer_apellido = currentValue;
                break;
              case "segundo_apellido":
                currentCustomer.segundo_apellido = currentValue;
                break;
              case "nif":
                currentCustomer.nif = currentValue;
                break;
              case "movil":
                currentCustomer.phone = currentValue;
                break;
              case "email":
                currentCustomer.email = currentValue;
                break;
              case "tipo_cliente":
                currentCustomer.tipo_cliente.tid = currentValue;
                break;
              case "tipo_documento_identidad":
                currentCustomer.tipo_documento.tid = currentValue;
                break;

              case "nif_manager":
                currentCustomer.nif_manager = currentValue;
                break;
              case "nombre_manager":
                currentCustomer.nombre_manager = currentValue;
                break;
              case "primer_apellido_manager":
                currentCustomer.primer_apellido_manager = currentValue;
                break;
              case "segundo_apellido_manager":
                currentCustomer.segundo_apellido_manager = currentValue;
                break;
              default:
                break;
            }
          });
          let auxCustomers = this.state.customers;
          auxCustomers[currentUserId][0] = currentCustomer;
          this.setState({ customers: auxCustomers });
        }

        let options = {
          place: "tr",
          message: "Cliente editado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (result.data.result === "ERROR") {
          options = {
            place: "tr",
            message: "Error al editar el cliente",
            type: "danger",
            icon: "now-ui-icons ui-1_simple-remove",
            autoDismiss: 5
          };
        }
        /*if (this.state.debug)*/ this.showNotification(options);
        // console.log("################## RESULT.DATA CREATE CUSTOMER ################");
        // console.log(result.data);
        // console.log("################## RESULT.DATA.UID CREATE CUSTOMER ################");
        // console.log(result.data.uid);
        // this.searchCustomer([result.data.uid], true, null, null);
        // this.searchWebMobileRequests(result.data.uid, null, null, false, false, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        console.log("################## ERROR EDIT CUSTOMER ################");
        console.log(error);
        console.log(error.response.data);

        this.setState({
          isEditingCustomer: false
        });
        let options = {
            place: "tr",
            message: "Error al editar el cliente",
            type: "danger",
            icon: "now-ui-icons ui-1_simple-remove",
            autoDismiss: 5
          };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  createNote(noteType, noteTitle, noteText, customer) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (this.state.isCreatingNote) {
      return;
    }

    this.setState({
      isCreatingNote: true
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let request = {
    //   title_field: {
    //     und: [
    //       {
    //         value: noteTitle
    //       }
    //     ]
    //   },
    //   type: "notas",
    //   body: {
    //     und: [
    //       {
    //         value: noteText
    //       }
    //     ]
    //   },
    //   field_usuario_relacionado: { und: customer },
    //   field_tipo: { und: noteType }
    // };

    let request = {
      title: noteTitle,
      body: noteText,
      customer: parseInt(customer),
      type: parseInt(noteType)
    };
    // console.log("################## CREATE NOTE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NOTE, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);

        this.setState({
          isCreatingNote: false
        });
        let options = {
          place: "tr",
          message: "Nota añadida",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (result.data.result === "OK") {
          if (this.state.debug) this.showNotification(options);
          if (customer) this.getCustomerNotes(customer);
        } else {
          let options = {
            place: "tr",
            message: "Error al crear la nota",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al crear la nota",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        this.setState({
          isCreatingNote: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }
  
  createInternetWrapper(customer, internetPlan) {
    // console.log("################## CREATE INTERNET WRAPPER ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let request = {
    //   title_field: {
    //     und: [
    //       {
    //         value: "Wrapper Internet"
    //       }
    //     ]
    //   },
    //   type: "activar_internet_wrapper",
    //   field_id_cliente_relacionado: { und: [{value: customer}] },
    //   field_id_tarifa_internet_nueva: { und: [{value: internetPlan}] }
    // };

    let request = {
      internet_plan: {
        customer_id: customer,
        internet_plan: internetPlan
      }
    };
    // console.log("################## CREATE INTERNET WRAPPER QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + SET_CUSTOMER_INTERNET_PLAN, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);

        let options = {
          place: "tr",
          message: "Tarifa de Internet configurada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);

        this.searchCustomer(customer, null, null, false, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al crear la nota",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        let settingAux = this.state.settingCustomerInternet;
        settingAux[customer] = false;
        this.setState({
          settingCustomerInternet: settingAux
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  formatPrice(price) {
    if (price.endsWith(".00")) price = price.replace(".00", "");
    if (price.endsWith(".0")) price = price.replace(".0", "");
    if (price.endsWith(",00")) price = price.replace(",00", "");
    if (price.endsWith(",0")) price = price.replace(",0", "");
    switch (Number(price).countDecimals()) {
      case 0:
        return price + "00";
      case 1:
        return price.replace(".", "") + "0";
      case 2:
        return price.replace(".", "");
      default:
    }
  }

  createExtraExpenseWrapper(customer, extraExpense) {
    // console.log("################## CREATE GASTO EXTRA WRAPPER ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      // title_field: {
      //   und: [
      //     {
      //       value: "Wrapper Gasto extra"
      //     }
      //   ]
      // },
      // type: "wrapper_gasto_extra",
      customer: customer,
      concept: extraExpense.concept,
      type: parseInt(extraExpense.type),
      price: this.formatPrice(parseFloat(extraExpense.price).toString()),
      fees: parseInt(extraExpense.fees ? extraExpense.fees : 0)
    };

    let URL = API + CREATE_EXTRA_EXPENSE;
    let isCreate = true;

    if (extraExpense.id_existing_expense) {
      // let id_existing_expense = { und: [{value: extraExpense.id_existing_expense}] };
      request.id = parseInt(extraExpense.id_existing_expense);
      URL = API + EDIT_EXTRA_EXPENSE;
      isCreate = false;
    }
    request = {
      expense: request
    };
    // console.log("################## CREATE GASTO EXTRA WRAPPER REQUEST ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(URL, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA CREATE GASTO EXTRA WRAPPER REQUEST ################");
        // console.log(result);

        let options = {
          place: "tr",
          message: "Gasto extra " + (isCreate ? "añadido" : "editado"),
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        if (result.data.result !== "OK") {
          options = {
            place: "tr",
            message:
              "Error al " +
              (isCreate ? "añadir" : "editar") +
              " el gasto extra",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
        }
        /*if (this.state.debug)*/ this.showNotification(options);

        this.getCustomerExtraExpenses(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al añadir el gasto extra",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        // let settingAux = this.state.settingCustomerInternet;
        // settingAux[customer] = false;
        // this.setState({
        //   settingCustomerInternet: settingAux
        // });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }
  async newRegisterPayment(request) {
    // console.log("################## CREATE GASTO EXTRA WRAPPER ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    request = {
      request: {
        order: request.order,
        concept: request.concept,
        amount: this.formatPrice(parseFloat(request.amount).toString())
      }
    };

    let URL = API + NEW_REGISTER_PAYMENT;
    return axios.post(URL, request, queryHeaders, {withCredentials: true})
      .then(result => result.data)
      .catch((error) => {});
  }
  
  changeClientPassword(customer, password) {
    // console.log("################## CREATE GASTO EXTRA WRAPPER ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      client_id: customer,
      password: password
    };

    let URL = API + CHANGE_CLIENT_PASSWORD;

    axios
      .post(URL, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA CREATE GASTO EXTRA WRAPPER REQUEST ################");
        // console.log(result);

        let options = {
          place: "tr",
          message: "Contraseña cambiada",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        if (result.data.result !== "OK") {
          let errorMessage = "Error al cambiar la contraseña: <br />" + result.data.error;
          options = {
            place: "tr",
            message: <div dangerouslySetInnerHTML={{ __html: errorMessage }} />,
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
        }
        /*if (this.state.debug)*/ this.showNotification(options);

        // this.getCustomerExtraExpenses(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CREATE MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al añadir el gasto extra",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };

        // let settingAux = this.state.settingCustomerInternet;
        // settingAux[customer] = false;
        // this.setState({
        //   settingCustomerInternet: settingAux
        // });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  createCustomerMobile(customer, mobileNumber, mobilePlan, existingID, status, mobileDiscount, dataBonus) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    // this.setState({
    //   isCreatingNote: true
    // });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let request = {
    //   type: "wrapper_movil",
    //   title: "Wrapper móvil",
    //   field_numero_movil: {
    //     und: [
    //       {
    //         value: mobileNumber
    //       }
    //     ]
    //   },
    //   field_cliente_relacionado: { und: customer },
    //   field_tarifa_numero_movil: { und: mobilePlan }
    // };

    let request = {
      customer: parseInt(customer),
      mobile: parseInt(mobileNumber),
      plan: parseInt(mobilePlan),
      extra: {
        discount: mobileDiscount,
        databonus: dataBonus
      }
    };

    if (existingID) {
      request = {
        mobile_id: parseInt(existingID),
        mobile: parseInt(mobileNumber),
        plan: parseInt(mobilePlan),
        status: parseInt(status.value)
      };
    }
    // request.extra = [];
    // if (mobileDiscount) request.extra['discount'] = mobileDiscount;
    // if (dataBonus) request.extra['databonus'] = dataBonus;
    // console.log("create mobile request", request);
    // return;
    // console.log("################## CREATE MOBILE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    let urlToUse = ADD_MOBILE;
    if (existingID) urlToUse = EDIT_MOBILE;

    axios
      .post(API + urlToUse, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA CREATE MOBILE ################");
        // console.log(result);
        let accion = "añadido";
        if (existingID) accion = "editado";

        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Móvil " + accion,
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          this.getCustomersMobiles([customer], true);
        } else {
          let options = {
            place: "tr",
            message: "Error al crear el móvil: " + result.data.error,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        // console.log("################## ERROR CREATE MOBILE ################");
        // console.log(error);

        let options = {
          place: "tr",
          message: "Error al crear el móvil",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  searchMobileProcedures(query, searchByStatus) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    let procedureStatus = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    if (!searchByStatus) {
      if (customerID in this.state.isSearchingMobileProcedures && this.state.isSearchingMobileProcedures[customerID]) {
        //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
        return;
      } else {
        let searchingAux = this.state.isSearchingMobileProcedures;
        searchingAux[customerID] = true;
        this.setState({
          isSearchingMobileProcedures: searchingAux
        });
      }
    } else {
      if (procedureStatus in this.state.isSearchingMobileProcedures && this.state.isSearchingMobileProcedures[procedureStatus]) {
        //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
        return;
      } else {
        let searchingAux = this.state.isSearchingMobileProcedures;
        searchingAux[procedureStatus] = true;
        this.setState({
          isSearchingMobileProcedures: searchingAux
        });
      }
    }

    if (query === undefined) {
      query = "";
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let URL = SEARCH_MOBILE_PROCEDURES;//procedure_status
    if (searchByStatus) {
      URL = SEARCH_MOBILE_PROCEDURES_BY_STATUS;
    }

    axios
      .get(API + URL + query, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA SEARCH MOBILE PROCEDURES (" + query + ") ################");
        // console.log(result);
        const groupByID = groupBy('cliente');
        const groupedByID = groupByID(result.data);
        let customersToSearch = Object.keys(groupedByID);
        //console.log(groupedByID);

        let customerID = query ? query : 0;
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        let searchingAux = this.state.isSearchingMobileProcedures;
        searchingAux[customerID] = false;

        let mobileProceduresAux = this.state.mobileProcedures;
        // if (customerID == 0) {
          mobileProceduresAux = groupedByID;
          mobileProceduresAux[customerID] = result.data;
          if (mobileProceduresAux[customerID] == undefined) mobileProceduresAux[customerID] = [];
          //console.log("################## AGREGADO PROCEDURES OBTENIDOS ################");
          //console.log(mobileProceduresAux);
        // } 
        // console.log("################## isSearchingMobileProcedures (" + query + ") ################");
        // console.log(searchingAux);
        // console.log("################## mobileProcedures (" + query + ") ################");
        // console.log(mobileProceduresAux);

        this.setState({
          isSearchingMobileProcedures: searchingAux,
          mobileProcedures: mobileProceduresAux
        });
        let options = {
          place: "tr",
          message: "Trámites cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  confirmSIMDelivery(SIMDelivery) {
    let SIMDeliveryID = SIMDelivery.id;
    let SIMDeliveryCustomer = SIMDelivery.cliente;
    let isConfirmingDelivery = this.state.isConfirmingDelivery;
    if (!isConfirmingDelivery) isConfirmingDelivery = [];
    if (SIMDeliveryID in isConfirmingDelivery && isConfirmingDelivery[SIMDeliveryID]) return;
    isConfirmingDelivery[SIMDeliveryID] = true;
    this.setState({ isConfirmingDelivery: isConfirmingDelivery });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      delivery: SIMDeliveryID
    };
    axios
      .post(API + CONFIRM_SIM_DELIVERY, request, queryHeaders, { withCredentials: true })
      .then(result => {
        isConfirmingDelivery = this.state.isConfirmingDelivery;
        isConfirmingDelivery[SIMDeliveryID] = false;
        this.setState({ isConfirmingDelivery: isConfirmingDelivery });
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Envío de SIM confirmado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
          this.searchSIMDeliveries(SIMDeliveryCustomer);
        } else {
          let options = {
            place: "tr",
            message: "Error al confirmar el envío de SIM",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        isConfirmingDelivery = this.state.isConfirmingDelivery;
        isConfirmingDelivery[SIMDeliveryID] = false;
        this.setState({ isConfirmingDelivery: isConfirmingDelivery });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  searchSIMDeliveries(query) {
    // console.log("################## SEARCH SIM DELIVERIES ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    if (customerID in this.state.isSearchingSIMDeliveries && this.state.isSearchingSIMDeliveries[customerID]) {
      //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
      return;
    } else {
      let searchingAux = this.state.isSearchingSIMDeliveries;
      searchingAux[customerID] = true;
      this.setState({
        isSearchingSIMDeliveries: searchingAux
      });
    }
    if (query === undefined) {
      query = "";
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      customer: query
    };
    axios
      .post(API + SEARCH_SIM_DELIVERIES, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA SIM SEARCH DELIVERIES (" + query + ") " + API + SEARCH_SIM_DELIVERIES + query +" ################");
        // console.log(result);
        const groupByID = groupBy('cliente');
        const groupedByID = groupByID(result.data);
        // console.log("################## RESPUESTA SIM SEARCH DELIVERIES (" + query + ") " + API + SEARCH_SIM_DELIVERIES + query +" ################");
        // console.log(result);
        // console.log("################## GROUPED SIM SEARCH DELIVERIES ################");
        // console.log(groupedByID);
        let customersToSearch = Object.keys(groupedByID);
        //console.log(groupedByID);

        let customerID = query ? query : 0;
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        let searchingAux = this.state.isSearchingSIMDeliveries;
        searchingAux[customerID] = false;

        let SIMDeliveriesAux = this.state.SIMDeliveries;
        if (customerID == 0) {
          customersToSearch.map(key => {
            SIMDeliveriesAux[key] = groupedByID[key];
          });
          SIMDeliveriesAux[0] = result.data;
          if (SIMDeliveriesAux[0] == undefined) SIMDeliveriesAux[0] = [];
          //console.log("################## AGREGADO PROCEDURES OBTENIDOS ################");
          //console.log(mobileProceduresAux);
        } else {
          if (result.data.length > 0) {
            SIMDeliveriesAux[customerID] = groupedByID[customerID];
          } else {
            SIMDeliveriesAux[customerID] = [];
          }
        }
        // console.log("################## SIMDeliveriesAux SIM SEARCH DELIVERIES ################");
        // console.log(SIMDeliveriesAux);

        this.setState({
          isSearchingSIMDeliveries: searchingAux,
          SIMDeliveries: SIMDeliveriesAux
        });
        let options = {
          place: "tr",
          message: "Envíos cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getSIMDeliveryTypes() {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_SIM_DELIVERY_TYPES, null, queryHeaders, { withCredentials: true })
      .then(result => {
        if (result.data.result === "OK") {
          let options = {
            place: "tr",
            message: "Cargados tipos de envío",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          // this.showNotification(options);
          this.setState({ SIMDeliveryTypes: result.data.types });
        } else {
          let options = {
            place: "tr",
            message: "Error al cargar los tipos de envío",
            type: "danger",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };
          this.showNotification(options);
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCustomerNotes(query) {
    // if (DEBUG_MODE) return;
    // console.log("################## GET CUSTOMER NOTES (" + query + ") ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    if (customerID in this.state.isSearchingCustomerNotes && this.state.isSearchingCustomerNotes[customerID]) {
      //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
      return;
    } else {
      let searchingAux = this.state.isSearchingCustomerNotes;
      searchingAux[customerID] = true;
      this.setState({
        isSearchingCustomerNotes: searchingAux
      });
    }
    if (query === undefined) {
      query = "";
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let request = {
      entity_id: parseInt(query)
    }
    axios
      .post(API + GET_ENTITY_NOTES, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET CUSTOMER NOTES (" + query + ") ################");
        // console.log(result);
        const groupByID = groupBy('usuario_relacionado_id');
        const groupedByID = groupByID(result.data.notes);
        // let customersToSearch = Object.keys(groupedByID);
        // console.log("customer notes grouped by ID", groupedByID);

        let customerID = query ? query : 0;
        customerID = parseInt(customerID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        let searchingAux = this.state.isSearchingCustomerNotes;
        searchingAux[customerID] = false;

        let customerNotesAux = this.state.customerNotes;
        if (customerID == 0) {
          customerNotesAux = groupedByID;
          customerNotesAux[0] = result.data;
          if (customerNotesAux[0] == undefined) customerNotesAux[0] = [];
          //console.log("################## AGREGADO PROCEDURES OBTENIDOS ################");
          //console.log(mobileProceduresAux);
        } else {
          customerNotesAux[customerID] = groupedByID[customerID];
        }

        if (result.data.length == 0) customerNotesAux[customerID] = [];

        // console.log("this.state.customerNotes", customerNotesAux);
        this.setState({
          isSearchingCustomerNotes: searchingAux,
          customerNotes: customerNotesAux
        });
        let options = {
          place: "tr",
          message: "Notas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        let searchingAux = this.state.isSearchingCustomerNotes;
        searchingAux[customerID] = false;
        this.setState({
          isSearchingCustomerNotes: searchingAux
        });
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401);// this.cleanSession();
        }
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getCustomerExtraExpenses(query) {
    // console.log("################## GET CUSTOMER NOTES (" + query + ") ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    // let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    // if (customerID in this.state.isSearchingCustomerNotes && this.state.isSearchingCustomerNotes[customerID]) {
    //   //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
    //   return;
    // } else {
    //   let searchingAux = this.state.isSearchingCustomerNotes;
    //   searchingAux[customerID] = true;
    //   this.setState({
    //     isSearchingCustomerNotes: searchingAux
    //   });
    // }
    if (query === undefined || query === "") {
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_CUSTOMER_EXTRA_EXPENSES + query, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA GET CUSTOMER NOTES (" + query + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);

        let customerID = query ? query : 0;
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        let customerExtraExpensesAux = this.state.customerExtraExpenses;
        customerExtraExpensesAux[customerID] = result.data;

        if (result.data.length == 0) customerExtraExpensesAux[customerID] = [];

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          customerExtraExpenses: customerExtraExpensesAux
        });
        let options = {
          place: "tr",
          message: "Gastos extra cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  cancelMobileProcedure(mobileProcedure, customer) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (customer in this.state.isCancellingMobileProcedure && 
        mobileProcedure in this.state.isCancellingMobileProcedure[customer] &&
        this.state.isCancellingMobileProcedure[customer][mobileProcedure]) {
      return;
    }

    let auxIsCancelling = this.state.isCancellingMobileProcedure;
    if (!(customer in auxIsCancelling)) {
      auxIsCancelling[customer] = [];
    }
    auxIsCancelling[customer][mobileProcedure] = true;

    this.setState({
      isCancellingMobileProcedure: auxIsCancelling
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let request = {
    //   "flag_name": "cancelar_tramite",
    //   "entity_id": mobileProcedure.toString(),
    //   "action": "flag"
    // };

    let request = {
      "procedure": mobileProcedure.toString()
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CANCEL_PROCEDURE/*FLAG_NODE*/, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        let auxIsCancelling = this.state.isCancellingMobileProcedure;
        auxIsCancelling[customer][mobileProcedure] = false;
    
        this.setState({
          isCancellingMobileProcedure: auxIsCancelling
        });
        let options = {
          place: "tr",
          message: "Trámite de móvil cancelado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        this.searchMobileProcedures(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let auxIsCancelling = this.state.isCancellingMobileProcedure;
        auxIsCancelling[customer][mobileProcedure] = false;
    
        this.setState({
          isCancellingMobileProcedure: auxIsCancelling
        });

        let options = {
          place: "tr",
          message: "Error al cancelar el trámite de móvil",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  setCustomerInternetPlan(customer, internetPlan) {

    let settingAux = this.state.settingCustomerInternet;
    settingAux[customer] = true;
    this.setState({
      settingCustomerInternet: settingAux
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      "field_tarifa_del_cliente": {
          "und": internetPlan
      }
    };
    this.createInternetWrapper(customer, internetPlan);

    // axios
    //   .put(API + UPDATE_CUSTOMER + customer, request, queryHeaders, { withCredentials: true })
    //   .then(result => {
    //     console.log("################## RESPUESTA SET INTERNET ################");
    //     console.log(result);
    //     /* let request = {
    //       username: this.state.username,
    //       password: this.state.passField
    //     }; */
    //     //this.setState({ isLoading: true });
    //     this.toggleCustomerInternetService(customer, true);

    //     let options = {
    //       place: "tr",
    //       message: "Tarifa de Internet configurada",
    //       type: "primary",
    //       icon: "now-ui-icons ui-1_check",
    //       autoDismiss: 3
    //     };
    //     if (this.state.debug) this.showNotification(options);
    //     //this.getOrdersArticles();
    //     /* this.props.godMode(result);
    //     if(result !== null && result.length > 0 && result[0] !== ""){ */
    //     /* this.setState({
    //         username: result[0],
    //         loginError: false
    //       }); */
    //     //doLogin();
    //     //}
    //   })
    //   .catch(error => {
    //     //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
    //     //console.log(error);
    //     let settingAux = this.state.settingCustomerInternet;
    //     settingAux[customer] = false;
    //     this.setState({
    //       settingCustomerInternet: settingAux
    //     });

    //     let options = {
    //       place: "tr",
    //       message: "Error al configurar la tarifa de Internet",
    //       type: "danger",
    //       icon: "now-ui-icons ui-1_check",
    //       autoDismiss: 3
    //     };
    //     /*if (this.state.debug)*/ this.showNotification(options);
    //   });
  }

  toggleCustomerInternetService(customer, isActive) {
    let settingAux = this.state.settingCustomerInternet;
    settingAux[customer] = true;
    this.setState({
      settingCustomerInternet: settingAux
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let action = isActive ? "flag" : "unflag";

    let request = {
      flag_name: "internet",
      entity_id: customer,
      action: action
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + FLAG_NODE, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        this.searchCustomer(customer, null, null, false, true);

        let options = {
          place: "tr",
          message: "Internet " + (isActive ? "activado" : "desactivado"),
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // this.searchMobileProcedures(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);
        let settingAux = this.state.settingCustomerInternet;
        settingAux[customer] = false;
        this.setState({
          settingCustomerInternet: settingAux
        });

        let options = {
          place: "tr",
          message: "Error al modificar el estado del servicio de Internet",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }
  getMobileServicesAPI(mobile) {
    // console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    // console.log("timestamp: " + timestamp);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      mobile: parseInt(mobile)
    };
    axios
      .post(API + GET_MOBILE_SERVICES_API_URL, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA SERVICIOS DEL MÓVIL (" + mobile + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        let mobileServicesAux = this.state.mobileServices;
        mobileServicesAux[mobile] = result.data;

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          mobileServices: mobileServicesAux
        });
        let options = {
          place: "tr",
          message: "Servicios del móvil " + mobile + " obtenidos.",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  readAllNotifications() {
    // console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    // console.log("timestamp: " + timestamp);
    if (this.state.markingAllNotificationsAsRead) return;
    this.setState({
      markingAllNotificationsAsRead: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let notification_id = null;
    let raw_notifications = this.state.notifications;

    if (raw_notifications && Object.keys(raw_notifications).length > 0) {
      let notifications_ids = Object.keys(raw_notifications);
      if (notifications_ids.length > 0) {
        notifications_ids = Object.keys(raw_notifications).reverse();
        notification_id = notifications_ids[0];
      }
    }
    // console.log("notifications_ids", notifications_ids);

    let request = {
      notification_id: parseInt(notification_id)
    };
    axios
      .post(API + MARK_ALL_NOTIFICATIONS_AS_READ, request, queryHeaders, { withCredentials: true })
      .then(result => {
        this.setState({
          markingAllNotificationsAsRead: false
        });
        let options = {
          place: "tr",
          message: "Marcadas todas las notificaciones como leídas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch(error => {
        this.setState({
          markingAllNotificationsAsRead: false
        });
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  loadMobileServices(timestamp, mobile, watermark) {
    console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    console.log("timestamp: " + timestamp);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    // let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    // if (customerID in this.state.isSearchingCustomerNotes && this.state.isSearchingCustomerNotes[customerID]) {
    //   //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
    //   return;
    // } else {
    //   let searchingAux = this.state.isSearchingCustomerNotes;
    //   searchingAux[customerID] = true;
    //   this.setState({
    //     isSearchingCustomerNotes: searchingAux
    //   });
    // }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .get(API + GET_MOBILE_SERVICES + timestamp + "&mobile=" + mobile, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA SERVICIOS DEL MÓVIL (" + mobile + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        if (result.data.length == 0) {
          setTimeout(function() {
            // console.log("################## INTENTANDO OBTENER DE NUEVO LOS SERVICIOS DEL MÓVIL (" + mobile + ") ################");
            this.loadMobileServices(timestamp, mobile);
          }.bind(this), 2000);
          return;
        }

        let mobileServicesAux = this.state.mobileServices;
        let resultAux = result.data[0].respuesta_api.replace(/&quot;/g,'"');
        try {
          // console.log("################## resultAux ################");
          // console.log(resultAux);
          resultAux = JSON.parse(resultAux);
          // console.log("################## resultAux PARSED ################");
          // console.log(resultAux);
        } catch(error) {
          console.log("################## ERROR parsing JSON ################");
          console.log(error);
        }
        result.data[0].respuesta_api = resultAux;
        result.data[0].watermark = watermark;
        mobileServicesAux[mobile] = result.data[0];

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          mobileServices: mobileServicesAux
        });
        let options = {
          place: "tr",
          message: "Servicios del móvil " + mobile + " obtenidos.",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  createMobileServicesWrapper(mobile_id, mobile, timestamp, watermark) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      title_field: {
        und: [
          {
            value: "Wrapper obtención de servicios " + mobile
          }
        ]
      },
      type: "wrapper_obtencion_servicios_movi",
      body: null,
      field_id_movil: {
        und: [
          {
            value: mobile_id
          }
        ]
      },
      field_numero_movil: {
        und: [
          {
            value: mobile
          }
        ]
      }
    };
    // console.log("################## CREATE NOTE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NODE, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);
        this.loadMobileServices(timestamp, mobile, watermark);

        let options = {
          place: "tr",
          message: "Obteniendo servicios del móvil",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al obtener los servicios del móvil",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  editBill(orderId, status, customer_id) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let editingBill = this.state.editingBill;
    if (!editingBill) editingBill = [];
    if (editingBill[orderId]) return;
    editingBill[orderId] = true;
    this.setState({editingBill: editingBill});

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      order: {
        id: orderId,
        status: status
      }
    };
    // let request = {
    //   title_field: {
    //     und: [
    //       {
    //         value: "Wrapper modificar estado factura " + bill_number
    //       }
    //     ]
    //   },
    //   type: "wrapper_modificar_estado_factura",
    //   body: null,
    //   field_id_pedido: {
    //     und: [
    //       {
    //         value: bill_id
    //       }
    //     ]
    //   },
    //   field_nuevo_estado_factura: { und: status }
    // };
    // console.log("################## EDIT BILL QUERY ################");
    // console.log(JSON.stringify(request));
    // console.log("################## CREATE PROCEDURE PARAMS ################");
    // console.log(tipo);
    // console.log("################## EDIT BILL REQUEST ################");
    // console.log(request);

    axios
      .post(API + UPDATE_ORDER_STATUS, request, queryHeaders, { withCredentials: true })
      .then(result => {
        // console.log("################## RESPUESTA EDIT BILL STATUS ################");
        // console.log(result);   
        editingBill = this.state.editingBill;
        if (!editingBill) editingBill = [];
        editingBill[orderId] = false;
        this.setState({editingBill: editingBill});
        this.getOrder(orderId, customer_id);     
        // this.props.searchBills(nif);
        
        // try {
        //   const groupByOrderID = groupBy('order_id');
        //   const groupedByOrder_id = groupByOrderID(this.state.orders);
        //   if (bill_id in groupedByOrder_id) {
        //     let currentBill = groupedByOrder_id[bill_id];
        //     let client_id = currentBill.client_id;
        //     if (client_id in this.state.customers) {
        //       let currentCustomer = this.state.customers[client_id];
        //       this.searchBills(currentCustomer.nif);
        //     }
        //   }
        // } catch (error) {
          
        // }
        // this.loadMobileServices(timestamp, mobile, watermark);

        let options = {
          place: "tr",
          message: "Editado el estado de la factura",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al obtener los servicios del móvil",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response) {
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        }
      });
  }

  getMobileServices(mobile_id, mobile, watermark) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let d = new Date;
    d.setSeconds(d.getSeconds() - 10);
    let dformat =
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    let timestamp = dformat;

    this.createMobileServicesWrapper(mobile_id, mobile, timestamp, watermark);
    return;

    let request = {
      flag_name: "obtener_servicios_movil",
      entity_id: mobile_id,
      action: "flag"
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + FLAG_NODE, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        // this.searchCustomer(customer, null, null, false, true);
        this.loadMobileServices(timestamp, mobile);

        let options = {
          place: "tr",
          message: "Obteniendo servicios del móvil",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        // this.searchMobileProcedures(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al obtener los servicios del móvil",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
      });
  }

  modifyMobileServicesWrapper(mobile, service_json, service_name) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      title_field: {
        und: [
          {
            value: "Wrapper modificación de servicios " + mobile
          }
        ]
      },
      type: "wrapper_modificacion_servicios",
      body: null,
      field_json_servicios: {
        und: [
          {
            value: service_json
          }
        ]
      },
      field_numero_movil: {
        und: [
          {
            value: mobile
          }
        ]
      }
    };
    // console.log("################## CREATE NOTE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NODE, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);
        // this.loadMobileServices(timestamp, mobile);

        let options = {
          place: "tr",
          message: "Modificado el servicio " + service_name,
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al modificar el servicio " + service_name,
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  setCustomerIBAN(customer, iban) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let request = {
    //   field_numero_de_cuenta: {
    //     und: [
    //       {
    //         value: iban
    //       }
    //     ]
    //   }
    // };

    let request = {
      client_id: customer,
      iban: iban
    };

    axios
      .post(API + SET_IBAN_CUSTOMER, request, queryHeaders, { withCredentials: true })
      .then(result => {
        let options = {
          place: "tr",
          message: "IBAN modificado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        this.searchCustomer(customer, null, null, false, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let options = {
          place: "tr",
          message: "Error al modificar el IBAN",
          type: "danger",
          icon: "now-ui-icons ui-2_settings-90",
          autoDismiss: 3
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
      });
  }

  switchCustomerRenewal(customer, isActive) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    // let action = isActive ? "flag" : "unflag";

    // let request = {
    //   flag_name: "renovar",
    //   entity_id: customer,
    //   action: action
    // };
    let request = {
      client_id: customer,
      renewal_status: isActive
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + SWITCH_RENEWAL_CUSTOMER, request, queryHeaders, { withCredentials: true })
      .then(result => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        this.searchCustomer(customer, null, null, false, true);

        let options = {
          place: "tr",
          message: "Renovación " + (isActive ? "activada" : "desactivada"),
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3
        };
        if (this.state.debug) this.showNotification(options);
        this.searchMobileProcedures(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch(error => {
        try {
          let options = {
            place: "tr",
            message: "Error al modificar el estado de la renovación",
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
          if (error.response.status === 403 || error.response.status === 401) this.cleanSession();
        } catch (error) {
          let options = {
            place: "tr",
            message: "Error al modificar el estado de la renovación",
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 3
          };
          /*if (this.state.debug)*/ this.showNotification(options);
        }
      });
  }

  onToggleList = () => {
    this.setState(prevState => ({ toggle: !prevState.toggle }));
  };

  checkValue(value) {
    ////console.log("################## Checking value ################");
    ////console.log(value);
    return value
      ? value.value
        ? value.value.toString()
        : value.toString()
      : null;
  }

  isTechnician() {
    // To check if technician:
    // -Has two roles:
    // --1) Auth user (role ID = 2)
    // --2) Technician role (role ID = 7)
    // -Hasn't one roles:
    // --1) Tienda role (role ID = 10)
    let result = false;
    if (this.state.user && this.state.user.roles) {
      let roles = this.state.user.roles;
      result =
        roles && Object.keys(roles).length >= 2 && 2 in roles && 7 in roles && !(10 in roles);
    }
    return result;
  }

  isSalesDepartment() {
    // return true;
    // To check if technician:
    // -Has two roles:
    // --1) Auth user (role ID = 2)
    // --2) Tienda role (role ID = 10)
    // --3) Billing role (role ID = 12)
    // --4) Sales role (role ID = 6)
    let result = false;
    if (this.state.user && this.state.user.roles) {
      let roles = this.state.user.roles;
      result =
        roles && Object.keys(roles).length >= 2 && 2 in roles && 10 in roles && 6 in roles;
    }
    return result;
  }
  isBillingDepartment() {
    // return true;
    // To check if technician:
    // -Has two roles:
    // --1) Auth user (role ID = 2)
    // --2) Tienda role (role ID = 10)
    // --3) Billing role (role ID = 12)
    let result = false;
    if (this.state.user && this.state.user.roles) {
      let roles = this.state.user.roles;
      result =
        roles && Object.keys(roles).length >= 2 && 2 in roles && 10 in roles && 12 in roles;
    }
    return result;
  }
  isBillingDepartmentN1() {
    return this.isBillingDepartment();
  }
  isBillingDepartmentN2() {
    // return true;
    // To check if technician:
    // -Has two roles:
    // --1) Auth user (role ID = 2)
    // --2) Tienda role (role ID = 10)
    // --3) Billing role (role ID = 12)
    // --3) Billing Level 2 role (role ID = 13)
    let result = false;
    if (this.state.user && this.state.user.roles) {
      let roles = this.state.user.roles;
      result =
        roles && Object.keys(roles).length >= 2 && 2 in roles && 10 in roles && 13 in roles;
    }
    return result;
  }

  godMode(input, alreadyLoggedIn, password, isRefresh) {
    // console.log("########## GOD MODE input ###########");
    // console.log(input);
    let cookie_refreshing_session_string = "0";
    // console.log("filters_string", filters_string);
    cookies.set("refreshing_session", cookie_refreshing_session_string, {
      path: "/"
    });
    if (DEBUG_MODE && input && input.data) {
      console.log("DEBUG In godMode (input)", input);
      try {
        console.log("Setting sessión cookie", input.data.session_name + "=" + input.data.sessid);
        cookies.set(input.data.session_name, input.data.sessid, {
          path: "/",
          domain:  "",
          // domain: ".mi-tienda.nadunet.es",
          maxAge: 1995840,
          httpOnly: true,
          secure: true
        });
      } catch (error) {
        console.log("Error al intentar establecer la cookie de sesión: " + error.message);
      }
    }
    axios.defaults.withCredentials = true;
    // console.log("########## GOD MODE input ###########");
    // console.log(input);
    // console.log("########## GOD MODE alreadyLoggedIn ###########");
    // console.log(alreadyLoggedIn);
    // console.log("########## GOD MODE password ###########");
    // console.log(password);
    // console.log("########## GOD MODE isRefresh ###########");
    // console.log(isRefresh);
      // console.log("########## GOD MODE alreadyLoggedIn ###########", alreadyLoggedIn);
    if (!alreadyLoggedIn || isRefresh) {
      ReactGA.set({ userId: input.data.user.name });
      // console.log("########## GOD MODE pre setXCSRFToken ###########", input.data.token);
      this.setXCSRFToken(input.data.token);
      // localStorage.setItem('token', input.data.token);
      // console.log("########## GOD MODE pre setstate ###########");
      this.setState({
        isLoggedIn: true,
        session: {
          sessid: input.data.sessid,
          session_name: input.data.session_name,
          token: input.data.token
        },
        user: input.data.user,
        password: password,
        refreshingSession: false,
        refreshRetries: 0,
        faceLogin: input.data.faceLogin
      });
      // console.log("########## GOD MODE pre push ###########");
      hist.push("/dashboard");
      // console.log("########## GOD MODE post push ###########");

      // if (DEBUG_MODE)
      //   document.cookie = input.data.session_name + "=" + input.data.sessid;
    } else {
      ReactGA.set({ userId: this.state.user.name });
    }

    // if (DEBUG_MODE)
    //   document.cookie = this.state.session.session_name + "=" + this.state.session.sessid;

    if (!this.checkPermissions(this.state.user.roles))
      window.location.href = "https://mi.nadunet.es";

    if (true || !alreadyLoggedIn) {
      if (!this.isTechnician()) {
        this.get_notifications(true);
        this.get_configuration();
        try {
          this.checkNotifications = setInterval(async () => {
            this.get_notifications();
          }, 60000);
        } catch (e) {
          console.log(e);
        }
        this.getBillStatuses();
        // this.getActiveCustomersCount();
        // this.getOrders("FIRST-LOAD");
        this.searchCustomer("FIRST-LOAD");
        this.getMobileProceduresCount();
        this.getWebMobileRequestsCount();
        this.searchWebMobileRequests("");
        // this.getCustomersCountLastMonths(MONTHS_TO_LOAD_COUNT);
        //this.getServices();
        // this.getCustomersMobiles();
        // this.getMobileRejectedProceduresCount();
        this.searchMobileProcedures();
        this.getMobilePlans();
        this.getTVPlans();
        this.getMobileProcedureTypes();
        this.getInternetPlans();
        this.getCalendarsList();
      }
    }
  }

  checkPermissions(roles) {
    // console.log("########## CHECK roles ###########");
    // console.log(roles);
    let hasPermissions = false;
    Object.keys(roles).map((key) => {
      // console.log("########## CHECK key ###########");
      // console.log(key);
      key = parseInt(key);
      if (key === 10 || key === 3 || key === 7) hasPermissions = true;
    });
    // console.log("########## CHECK hasPermissions ###########");
    // console.log(hasPermissions);
    return hasPermissions;
  }

  doLogin() {
    if (this.state.refreshRetries > 5) {
      this.setState({ isLoggedIn: false });
      this.checkIfLoggedIn();
      return;
    }
    this.setState({
      refreshRetries: this.state.refreshRetries + 1
    });
    axios.defaults.withCredentials = false;
    /* //////console.log("################## DO LOGIN ################"); */
    // let request = {
    //   username: this.state.user.name,
    //   password: this.state.password
    // };
    if (this.state.faceLogin) {
      let face = this.state.password;
      this.faceLogin(face).then(result => {
          if (result.ok) {
            let name = result.user.field_nombre_completo.und[0].value;
            if (name) name = name.split(" ");
            if (name && name.length > 0) name = name[0];
            let input = {
              data: this.state.loginResult,
              faceLogin: true
            };
            this.godMode(input, true, face, true);
          } else {
            console.log("Error al renovar la sesión con loginFace (result)", result);
          }
        })
        .catch((error) => {
          this.setState({
            sendingFaces: false
          });
          // Error 😨
          console.log("Error al añadir las caras: " + error.message);
          // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
        });
    } else {
      let request = {
        dni: this.state.user.name,
        password: this.state.password
      };
      /* //////console.log(request); */
      //this.setState({ isLoading: true });
      axios.post(API + LOGIN_URL, request, {withCredentials: false})
        .then(result => {
          /* //////console.log("################## RESPUESTA ################");
          //////console.log(result); */
          this.setState({
            isLogging: false
          });
          this.godMode(result, true, this.state.password, true);
        })
        .catch((error) => {
          // Error 😨
          if (error.response) {
              /*
                * The request was made and the server responded with a
                * status code that falls out of the range of 2xx
                */
              /* //////console.log(error.response.data);
              //////console.log(error.response.status);
              //////console.log(error.response.headers); */
  
              this.handleLoginError(error.response.status);
  
              /* this.setState({
                error,
                isLogging: false
              }); */
          } else if (error.request) {
              /*
                * The request was made but no response was received, `error.request`
                * is an instance of XMLHttpRequest in the browser and an instance
                * of http.ClientRequest in Node.js
                */
              /* //////console.log(error.request); */
              this.handleLoginError(666);
              /* this.setState({
                error,
                isLogging: false
              }); */
          } else {
              // Something happened in setting up the request and triggered an Error
              /* //////console.log('Error', error.message); */
              this.setState({
                error,
                isLogging: false
              });
          }
          /* //////console.log(error.config); */
        });
    }
  }

  handleLoginError(error) {
    //////console.log("#################### HANDLE ERROR ##################");
    //////console.log(error);
    switch (error) {
      case 401:
        this.cleanSession();
        this.doLogin();
        break;
      case 406:
        this.cleanSession();
        this.doLogin();
        break;
      case 500:
        this.doLogin();
        break;
      case 666:
        this.doLogin();
        break;
      default:
        break;
    }
  }

  cleanSession() {
    if (this.state.refreshingSession) return;
    
    let cookie_refreshing_session = cookies.get("refreshing_session");
    // console.log("########## COOKIES REFRESHING SESSION ###########", cookie_refreshing_session);
    if (cookie_refreshing_session && cookie_refreshing_session === "1") {
      // console.log("########## COOKIES REFRESHING SESSION - Returning ###########", cookie_refreshing_session);
      return;
    }

    // console.log("########## COOKIES REFRESHING SESSION - Setting to 1 ###########", cookie_refreshing_session);
    let cookie_refreshing_session_string = "1";
    // console.log("filters_string", filters_string);
    cookies.set("refreshing_session", cookie_refreshing_session_string, {
      path: "/"
    });
    this.setState({
      refreshingSession: true
    });

    //Get a list of all cookies as a semicolon+space-separated string
    // let sessionCookies = document.cookie.split(';').filter(c => c.startsWith('SSESS'));
    // if (sessionCookies.length === 0) {
    //   hist.push("/entrar");
    //   return;
    // }

    axios.defaults.withCredentials = true;
    
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios.post(API + GET_TOKEN_URL, request, {withCredentials: true})
      .then(result => {
        let cookie_refreshing_session_string = "0";
        // console.log("filters_string", filters_string);
        cookies.set("refreshing_session", cookie_refreshing_session_string, {
          path: "/"
        });
        //////console.log("################## RESPUESTA GET TOKEN ################");
        //////console.log(result);
        this.setXCSRFToken(result.data.token);
        return;
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch((error) => {
        let cookie_refreshing_session_string = "0";
        // console.log("filters_string", filters_string);
        cookies.set("refreshing_session", cookie_refreshing_session_string, {
          path: "/"
        });
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          this.cleanSession();
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
            this.setState({
              error,
              isLogging: false
            });
        }
        //////console.log(error.config);
      });
  }

  miniLogout(newToken) {
    if (window.location.host.includes("localhost")) return;
    let request = {};
    let queryHeaders = {
      headers:{
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        //////console.log("################## RESPUESTA LOGOUT ################");
        //////console.log(result);
        
        if(result.data[0]) {
          this.doLogin();
        } else {
          this.cleanSession();
        }
      })
      .catch((error) => {
        // Error 😨
        if (error.response) {
            /*
              * The request was made and the server responded with a
              * status code that falls out of the range of 2xx
              */
            //////console.log(error.response.data);
            //////console.log(error.response.status);
            //////console.log(error.response.headers);

            this.handleLoginError(error.response.status);

            /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
            /*
              * The request was made but no response was received, `error.request`
              * is an instance of XMLHttpRequest in the browser and an instance
              * of http.ClientRequest in Node.js
              */
            //////console.log(error.request);
            this.handleLoginError(666);
            /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
            // Something happened in setting up the request and triggered an Error
            //////console.log('Error', error.message);
          this.cleanSession();
          this.setState({
            error,
            isLogging: false
          });
      }
        //////console.log(error.config);
      });
  }
  
  changeSelectedTaskMenu(taskMenu) {
    if (taskMenu) {
      this.setState({ selectedTaskMenu: taskMenu });
    }
  }

  getTaskMenu() {
    let aux = null;
    let tasksIds = [];
    let waitingTasks = [];
    switch (this.state.taskMenu.position) {
      case TASK_MENU_CREATE:
        return (
          <Card color="white">
            <CardHeader>
              <CardTitle>Guardar tarea</CardTitle>
            </CardHeader>
            <CardBody>
              <Row>
                <Col xs={12}>
                  <FormGroup>
                      <Input
                        type="text"
                        className="task-name"
                        placeholder="Nombre..."
                        value={this.state.taskName || ""}
                        // onChange={e => this.handleChange("searchQuery", e)}
                        onChange={e => this.setState({ taskName: e.target.value })}
                        onKeyDown={e => {
                          //console.log(e.keyCode);
                          if(e.keyCode == 13){
                            if (this.state.taskName && this.state.taskName.length > 2) {
                              let new_task = {
                                title: this.state.taskName,
                                url: window.location.pathname,
                                date: moment()
                              };
                              this.createTask(new_task);
                              // let tasksList = this.state.tasksList;
                              // tasksList.push({ 
                              //   title: this.state.taskName,
                              //   url: window.location.pathname,
                              //   date: moment()
                              //  });
                              let taskMenu = this.state.taskMenu;
                              taskMenu.position = TASK_MENU_MAIN;
                              this.setState({ taskMenu: taskMenu, taskName: "" });
                            }
                          }
                        }}
                        // onKeyDown={this.handleKeyDown}
                        // disabled={this.props.mainState.isSearchingBuildings}
                        // onKeyDown={e => {
                        //   //console.log(e.keyCode);
                        //   if (e.keyCode == 13) {
                        //     console.log("ola k ase?");
                        //     //Enter is key code 13
                        //     // this.searchCustomer();
                        //     // put the login here
                        //   }
                        // }}
                        // style={{ marginRight: "10px" }}
                      />
                  </FormGroup>
                </Col>
                <Col xs={6}>                        
                  <Button
                      // icon
                      block
                      key={"createTaskButton"}
                      color="primary"
                      disabled={!(this.state.taskName && this.state.taskName.length > 2)}
                      onClick={() => {
                        if (this.state.taskName && this.state.taskName.length > 2) {
                          let new_task = {
                            title: this.state.taskName,
                            url: window.location.pathname,
                            date: moment()
                          };
                          this.createTask(new_task);
                          // let tasksList = this.state.tasksList;
                          // tasksList.push({ 
                          //   title: this.state.taskName,
                          //   url: window.location.pathname,
                          //   date: moment()
                          //  });
                          let taskMenu = this.state.taskMenu;
                          taskMenu.position = TASK_MENU_MAIN;
                          this.setState({ taskMenu: taskMenu, taskName: "" });
                        }
                      }}
                      // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                      leftLabel={"now-ui-icons ui-1_simple-add"}
                  >Crear tarea</Button> 
                </Col>
                <Col xs={6}>                        
                  <Button
                      // icon
                      block
                      key={"createTaskButton"}
                      color="default"
                      onClick={() => {
                        let taskMenu = this.state.taskMenu;
                        taskMenu.position = TASK_MENU_MAIN;
                        this.setState({ taskMenu: taskMenu });
                        // this.showPopUp(NOTA);
                      }}
                      // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                      leftLabel={"now-ui-icons ui-1_simple-remove"}
                  >Cancelar</Button> 
                </Col>
              </Row>
            </CardBody>
          </Card>
        );
      case TASK_MENU_LIST:
        aux = this.state.tasksList;
        if (aux) tasksIds = Object.keys(aux);
        if (tasksIds.length > 0) {
          tasksIds.map(id => {
            let currentTask = aux[id];
            if (currentTask.state !== 249) waitingTasks[id] = currentTask;
          })
          tasksIds = Object.keys(waitingTasks);
        }
        if (tasksIds.length > 0) {
          let tasksText = tasksIds.length + " tarea pendiente";
          if (tasksIds.length > 1) tasksText = tasksIds.length + " tareas pendientes";
          return (
            <Card>
              <CardText>
                <CardHeader className="text-center">
                  <b>{tasksText}</b>
                  <Button
                    // size={"sm"}
                    icon
                    neutral
                    onClick={() => { this.redirectTo("/tareas") }}
                    style={{ position: "relative", top: "-3px" }}
                  >
                    <i className={"now-ui-icons arrows-1_share-66"} />
                  </Button>
                </CardHeader>
                <List style={{maxHeight: 200, overflow: 'auto'}}>
                  {tasksIds.map((currentId, index) => {
                    let task = this.state.tasksList[currentId];
                    if (task.state === 249) return null;
                    let taskIcon = taskStateIcons[parseInt(task.state)];
                    if (this.state.selectedTaskMenu && parseInt(task.id) === parseInt(this.state.selectedTaskMenu)) {
                      return (
                        <ListItem 
                          key={index} 
                          onContextMenu={(e) => {
                            e.preventDefault();
                            this.changeSelectedTaskMenu("cerrar");
                          }}
                          // primaryText={task.title}
                          // secondaryText={moment(task.date).fromNow()}
                          // // leftAvatar={<Avatar>{index + 1}</Avatar>}
                          // onClick={() => hist.push(task.url)}
                          // // leftCheckbox={<Checkbox></Checkbox>}
                          // rightIconButton={rightIconMenu(task.id)}
                          // leftAvatar={
                          //   <Avatar
                          //     className="fab-list-task"
                          //     rounded
                          //   ><i className={"now-ui-icons " + taskIcon} /></Avatar>}
                          
                          // {...item} 
                        >
                          <Row>
                            <i 
                              className={"now-ui-icons ui-1_simple-remove"} 
                              style={{ position: "absolute", top: "5px", right: "5px" }}
                              onClick={() => this.changeSelectedTaskMenu("cerrar")}
                            />
                            <Col xs={12} className="text-center">
                              <h6><i className={"now-ui-icons " + taskIcon} />{" " + task.title}</h6>
                            </Col>
                            <Col xs={4} className="text-center">
                              <Button
                                  style={{ margin: "0 auto"}}
                                  icon
                                  block
                                  key={"startTaskButton"}
                                  color="info"
                                  disabled={parseInt(task.state) !== 247 || this.state.startingTask[task.id]}
                                  onClick={() => {
                                    this.startTask(task.id);
                                  }}
                                  // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                                    leftLabel={"now-ui-icons " + (this.state.startingTask[task.id]? "arrows-1_refresh-69 spin reposition-spin" : "media-1_button-play")}
                              /><span className="category">Inicio</span>
                            </Col>
                            <Col xs={4} className="text-center">
                              <Button
                                  style={{ margin: "0 auto"}}
                                  icon
                                  block
                                  key={"pauseTaskButton"}
                                  color="warning"
                                  disabled={parseInt(task.state) !== 248 || this.state.pausingTask[task.id]}
                                  onClick={() => {
                                    this.pauseTask(task.id);
                                  }}
                                  // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                                    leftLabel={"now-ui-icons " + (this.state.pausingTask[task.id]? "arrows-1_refresh-69 spin reposition-spin" : " media-1_button-pause")}
                              /><span className="category">Pausa</span>
                            </Col>
                            <Col xs={4} className="text-center">
                              <Button
                                  style={{ margin: "0 auto"}}
                                  icon
                                  block
                                  key={"endTaskButton"}
                                  color="primary"
                                  disabled={parseInt(task.state) !== 248 || this.state.finishingTask[task.id]}
                                  onClick={() => {
                                    this.finishTask(task.id);
                                  }}
                                  leftLabel={"now-ui-icons " + (this.state.finishingTask[task.id]? "arrows-1_refresh-69 spin reposition-spin" : " media-1_button-power")}
                              /><span className="category">Fin</span>
                            </Col>
                          </Row>
                        </ListItem>
                      );
                    } else {
                      return (
                        <ListItem 
                          key={index} 
                          primaryText={task.title}
                          secondaryText={moment(task.date).fromNow()}
                          // leftAvatar={<Avatar>{index + 1}</Avatar>}
                          onClick={() => {hist.push(task.url); this.startTask(task.id);}}
                          // leftCheckbox={<Checkbox></Checkbox>}
                          rightIconButton={rightIconMenu(task.id, this)}
                          onContextMenu={(e) => {
                            e.preventDefault();
                            this.changeSelectedTaskMenu(task.id);
                          }}
                          leftAvatar={
                            <Avatar
                              className="fab-list-task"
                              rounded="true"
                            ><i className={"now-ui-icons " + taskIcon} /></Avatar>}
                          
                          // {...item} 
                        />
                      );
                    }
                  })}
                </List>
              </CardText>
              <Button
                  // icon
                  block
                  key={"returnTaskButton"}
                  color="default"
                  onClick={() => {
                    let taskMenu = this.state.taskMenu;
                    taskMenu.position = TASK_MENU_MAIN;
                    this.setState({ taskMenu: taskMenu });
                    // this.showPopUp(NOTA);
                  }}
                  // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                  leftLabel={"now-ui-icons arrows-1_minimal-down"}
              >Volver</Button> 
            </Card>
          );
        } else {
          return (
            <Card>
              <CardText>
                No hay tareas creadas.
              </CardText>
              <Button
                  // icon
                  block
                  key={"returnTaskButton"}
                  color="default"
                  onClick={() => {
                    let taskMenu = this.state.taskMenu;
                    taskMenu.position = TASK_MENU_MAIN;
                    this.setState({ taskMenu: taskMenu });
                    // this.showPopUp(NOTA);
                  }}
                  // leftLabel={"now-ui-icons " + (this.props.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
                  leftLabel={"now-ui-icons arrows-1_minimal-down"}
              >Volver</Button> 
            </Card>
          );
        }
        break;
      default:
        return (
          <BubbleList>
            <BubbleListItem
              primaryText="Lista de tareas"
              rightAvatar={
                <Avatar
                  className="fab-list-task"
                  rounded="true"
                ><i className={"now-ui-icons design_bullet-list-67"} /></Avatar>}
              onClick={() => {
                let taskMenu = this.state.taskMenu;
                taskMenu.position = TASK_MENU_LIST;
                this.setState({ taskMenu: taskMenu });
              }}
            />
            <BubbleListItem
              primaryText="Crear tarea"
              rightAvatar={
                <Avatar
                  className="fab-create-task"
                  rounded="true"
                ><i className={"now-ui-icons ui-1_simple-add"} /></Avatar>}
              onClick={() => {
                let taskMenu = this.state.taskMenu;
                taskMenu.position = TASK_MENU_CREATE;
                this.setState({ taskMenu: taskMenu });
              }}
            />
          </BubbleList>
        );
    }
  }
  setXCSRFToken(token) {
    localStorage.setItem("token", token);
  }
  getXCSRFToken() {
    return localStorage.getItem('token');
  }
  removeXCSRFToken() {
    localStorage.removeItem();
  }
  getWebContent(content) {
    // if (this.state.isGettingwebContent) return;
    // if (window.location.pathname.includes("/calendario")) return;
    this.setState({
      isGettingwebContent: true
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    if (!content) content = "free_webforms";
    let query = {
      content: content
    };
    axios
      .post(API + GET_WEB_CONTENT, query, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        this.setState({
          isGettingwebContent: false
        });
        if (result.data.ok) {
          let options = {
            place: "tr",
            message: "Contenido web cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };

          // let special = content.includes("all");
          let webforms = /*special ? this.state.adminWebforms :*/ this.state.webforms;
          if (!webforms) webforms = [];
          let new_webforms = result.data.data;
          if (new_webforms && Object.keys(new_webforms).length > 0) {
            Object.keys(new_webforms).map((id)=> {
              webforms[id] = new_webforms[id];
            });
            // if (special) {
            //   this.setState({
            //     adminWebforms: webforms
            //   });
            // } else {
              this.setState({
                webforms: webforms
              });
            // }
          }
          // if (concat && !no_concat) this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al obtener los formularios web: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        // this.show_notifications_popups();
      })
      .catch(error => {
        this.setState({
          isGettingwebContent: false
        });
        // if (error && error.response) {
        //   if (error.response.status === 403 || error.response.status === 401)
        //     this.cleanSession();
        // }
      });
  }

  assignWebform(webform, unassign) {
    // if (this.state.isGettingwebContent) return;
    // if (window.location.pathname.includes("/calendario")) return;
    let aux = this.state.isAssigningWebform;
    if (aux && aux[webform]) return;
    if (!aux) aux = [];
    aux[webform] = true;
    this.setState({
      isAssigningWebform: aux
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let query = {
      webform: webform
    };
    let url = ASSIGN_WEBFORM;
    if (unassign) url = UNASSIGN_WEBFORM;
    axios
      .post(API + url, query, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        let aux = this.state.isAssigningWebform;
        if (!aux) aux = [];
        aux[webform] = false;
        this.setState({
          isAssigningWebform: aux
        });

        if (result.data.ok) {
          let options = {
            place: "tr",
            message: "Formulario asignado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };

          let webforms = this.state.webforms;
          if (!webforms) webforms = [];
          webforms[webform] = result.data.webform;
          this.setState({
            webforms: webforms
          });
          // if (concat && !no_concat) this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al asignar el formulario web: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        // this.show_notifications_popups();
      })
      .catch(error => {
        let aux = this.state.isAssigningWebform;
        if (!aux) aux = [];
        aux[webform] = false;
        this.setState({
          isAssigningWebform: aux
        });
        // if (error && error.response) {
        //   if (error.response.status === 403 || error.response.status === 401)
        //     this.cleanSession();
        // }
      });
  }

  closeWebform(webform, unassign) {
    // if (this.state.isGettingwebContent) return;
    // if (window.location.pathname.includes("/calendario")) return;
    let aux = this.state.isClosingWebform;
    if (aux && aux[webform]) return;
    if (!aux) aux = [];
    aux[webform] = true;
    this.setState({
      isClosingWebform: aux
    });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.getXCSRFToken(),
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    let query = {
      webform: webform
    };
    let url = CLOSE_WEBFORM;
    axios
      .post(API + url, query, queryHeaders, {
        withCredentials: true
      })
      .then(result => {
        let aux = this.state.isClosingWebform;
        if (!aux) aux = [];
        aux[webform] = false;
        this.setState({
          isClosingWebform: aux
        });

        if (result.data.ok) {
          let options = {
            place: "tr",
            message: "Formulario cerrado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3
          };

          let webforms = this.state.webforms;
          if (!webforms) webforms = [];
          webforms[webform] = result.data.webform;
          this.setState({
            webforms: webforms
          });
          // if (concat && !no_concat) this.get_notifications(true);
        } else {
          let errorContentList = Object.keys(result.data.error).map(currentError => {
            let currentLi = 
              <li key={currentError}>
                <div dangerouslySetInnerHTML={{ __html: result.data.error[currentError] }} />
              </li>;
            return currentLi;
          });
          let errorContent =
            <div>
              <span>Error al cerrar el formulario web: </span>
              <ul>{errorContentList}</ul>
            </div>
  
          let options = {
            place: "tr",
            message: errorContent,
            type: "danger",
            icon: "now-ui-icons ui-2_settings-90",
            autoDismiss: 0
          };
          this.showNotification(options);
        }
        // this.show_notifications_popups();
      })
      .catch(error => {
        let aux = this.state.isClosingWebform;
        if (!aux) aux = [];
        aux[webform] = false;
        this.setState({
          isClosingWebform: aux
        });
        // if (error && error.response) {
        //   if (error.response.status === 403 || error.response.status === 401)
        //     this.cleanSession();
        // }
      });
  }

  render() {
    let pendingTasks = null;
    let waitingTasks = 0;
    let tasksIds = [];
    if (!this.isTechnician()){
      let aux = null;
      aux = this.state.tasksList;
      if (aux) tasksIds = Object.keys(aux);
      if (tasksIds.length > 0) {
        tasksIds.map(id => {
          let currentTask = aux[id];
          if (currentTask.state !== 249) waitingTasks++;
        });
      }
      if (waitingTasks > 0) pendingTasks = <span key="pending-tasks-badge" id="pending-tasks-badge">{waitingTasks}</span>;
      // console.log("Pending tasks", waitingTasks);
    }
    return (
      <ConfigProvider locale={esES}>
        <div>
          {/* <VoIP></VoIP> */}
          {/* <SoftPhone
            callVolume={33} //Set Default callVolume
            ringVolume={44} //Set Default ringVolume
            connectOnStart={true} //Auto connect to sip
            notifications={true} //Show Browser Notification of an incoming call
            config={config} //Voip config
            setConnectOnStartToLocalStorage={setConnectOnStartToLocalStorage} // Callback function
            setNotifications={setNotifications} // Callback function
            setCallVolume={setCallVolume} // Callback function
            setRingVolume={setRingVolume} // Callback function
            timelocale={'UTC+1'} //Set time local for call history
          /> */}
          <Router history={hist}>
            <div>
              <NotificationAlert 
                ref="notificationAlert"
                onContextMenu={(e) => {
                  e.preventDefault();
                  // this.changeSelectedTaskMenu("cerrar");
                  // alert("right click");
                  console.log("right click");
                }}
                onClick={() => {
                  // e.preventDefault();
                  // this.changeSelectedTaskMenu("cerrar");
                  // alert("left click");
                  console.log("left click");
                }} 
              />
              {pendingTasks}
              {!this.isTechnician() && this.state.isLoggedIn && <MuiThemeProvider>
                <SpeedDial
                  classNameButtonWrap="fab-button-negro"
                  enableMouseActions
                  ariaLabel="Menú de tareas"
                  onChange={(e) => {
                    // console.log("onChange task", e);
                  }}
                  onChangeState={(e) => {
                    // console.log("onChangeState task", e);
                    if (!e.wasOpened) {
                      let taskMenu = this.state.taskMenu;
                      taskMenu.position = TASK_MENU_MAIN;
                      this.setState({ taskMenu: taskMenu });
                    }
                  }}
                  // className={classes.speedDial}
                  // hidden={hidden}
                  // icon={<SpeedDialIcon />}
                  // onClose={handleClose}
                  // onOpen={handleOpen}
                  // open={open}
                  // direction={direction}
                >    
                  {this.getTaskMenu()}
                </SpeedDial>
              </MuiThemeProvider>}
              <Switch>
                {/* <Route
                  path="/entrar/cara"
                  render={props => (
                    <FaceDetection
                      {...props}
                      {...this}
                      mainState={this.state}
                      userData={this} />
                  )}
                /> */}
                <Route
                  path="/entrar"
                  render={props => (
                    <LoginPage
                      {...props}
                      godMode={this.godMode.bind(this)}
                      showNotification={this.showNotification.bind(this)}
                      mainState={this.state}
                      userData={this}
                    />
                  )}
                />
                <Route
                  path="/restablecer"
                  render={props => (
                    <LoginPage
                      {...props}
                      godMode={this.godMode.bind(this)}
                      showNotification={this.showNotification.bind(this)}
                      mainState={this.state}
                      goToLogin={this.goToLogin.bind(this)}
                    />
                  )}
                />
                <Route
                  path="/recuperar"
                  render={props => (
                    <LoginPage
                      {...props}
                      godMode={this.godMode.bind(this)}
                      showNotification={this.showNotification.bind(this)}
                      mainState={this.state}
                      goToLogin={this.goToLogin.bind(this)}
                    />
                  )}
                />
                <Route
                  path="/"
                  render={props => (
                    <Dashboard
                      {...props}
                      {...this}
                      mainState={this.state}
                    />
                  )}
                />
                {/* {indexRoutes.map((prop, key) => {
                      return <Route path={prop.path} key={key} component={prop.component} />;
                  })} */}
              </Switch>
            </div>
          </Router>
        </div>
      </ConfigProvider>
    );
  }
}

// function VoIP() {
//   const config = {
//     domain: 'pbx-aire-empresas.nadunet.es', // sip-server@your-domain.io
//     uri: 'sip:2031704@pbx-aire-empresas.nadunet.es', // sip:sip-user@your-domain.io
//     password: 'RubenFijo2020%', //  PASSWORD ,
//     ws_servers: 'ws://2031704@pbx-aire-empresas.nadunet.es:9060/ws', //ws server
//     sockets: new WebSocketInterface('ws://pbx-aire-empresas.nadunet.es:9060/ws'),
//     display_name: 'Test softphone',//jssip Display Name
//     debug: true // Turn debug messages on
//   };
//   const setConnectOnStartToLocalStorage =(newValue)=>{
//     // Handle save the auto connect value to local storage
//     return true
//   }
//   const setNotifications =(newValue)=>{
//     // Handle save the Show notifications of an incoming call to local storage
//     return true
//   }
//   const setCallVolume =(newValue)=>{
//     // Handle save the call Volume value to local storage
//     return true
//   }
//   const setRingVolume =(newValue)=>{
//     // Handle save the Ring Volume value to local storage
//     return true
//   }

//   return (
//     <SoftPhone
//       callVolume={33} //Set Default callVolume
//       ringVolume={44} //Set Default ringVolume
//       connectOnStart={false} //Auto connect to sip
//       notifications={false} //Show Browser Notification of an incoming call
//       config={config} //Voip config
//       setConnectOnStartToLocalStorage={setConnectOnStartToLocalStorage} // Callback function
//       setNotifications={setNotifications} // Callback function
//       setCallVolume={setCallVolume} // Callback function
//       setRingVolume={setRingVolume} // Callback function
//       timelocale={'UTC+3'} //Set time local for call history
//     />
//     );
// }

Number.prototype.countDecimals = function() {
  if (Math.floor(this.valueOf()) === this.valueOf()) return 0;
  return this.toString().split(".")[1].length || 0;
};
// Warn if overriding existing method
if (Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function (array) {
    // if the other array is a falsy value, return
    if (!array)
        return false;

    // compare lengths - can save a lot of time 
    if (this.length != array.length)
        return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i]))
                return false;       
        }           
        else if (this[i] != array[i]) { 
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;   
        }           
    }       
    return true;
}
// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx